/* pg-global.js (v83) - skrypty Prime Gastro wspólne dla każdej strony, ładowane raz,
   z atrybutem defer po global.min.js (klasy motywu istnieją, DOM gotowy). Każda część
   to osobny IIFE; kolejność: menu, wyszukiwarka SKU, kopiowanie SKU, łatki motywu,
   klasa przewinięcia dla nagłówka i licznik koszyka bez nawiasów (v84). */

/* ===== menu-performance-patch.js ===== */
(()=>{if(window.__MENU_PATCH_LITE__)return;window.__MENU_PATCH_LITE__=!0;const CONFIG={debug:!1,selectors:{root:'[data-menu-root]',menuImages:'img.desk-menu_item-image, img.link-image',bgTiles:'[data-bg]',toggles:'[data-action="toggle-subdrawer"], [data-action="toggle-drawer"], [data-action="open-third-menu"]'},behavior:{rootMargin:'200px 0px',maxPreloadPerOpen:4,respectSaveData:!0,slowNetworkTypes:['slow-2g','2g']}};const log=(...a)=>CONFIG.debug&&console.info('[MenuPatch LITE]',...a);const STATE={io:null,ioBg:null,loaded:new WeakSet(),loadedBg:new WeakSet(),observed:new WeakSet(),observedBg:new WeakSet(),initializedRoots:new WeakSet(),paused:!1};function getEventElement(ev){if(ev&&typeof ev.composedPath==='function'){const path=ev.composedPath();for(const n of path)if(n&&n.nodeType===1)return n}
if(ev&&ev.target&&ev.target.nodeType===1)return ev.target;if(ev&&ev.target&&ev.target.parentElement)return ev.target.parentElement;return null}
function closestSafe(fromEl,selector){let el=fromEl;while(el&&el.nodeType===1){try{if(el.matches&&el.matches(selector))return el}catch{}
el=el.parentElement}
return null}
const isSaveData=()=>CONFIG.behavior.respectSaveData&&navigator.connection&&navigator.connection.saveData;const isVerySlowNet=()=>{const t=navigator.connection&&navigator.connection.effectiveType;return!!t&&CONFIG.behavior.slowNetworkTypes.includes(t)};function ensureIO(){if(!('IntersectionObserver' in window))return null;if(!STATE.io){STATE.io=new IntersectionObserver((entries)=>{if(STATE.paused)return;entries.forEach(e=>{if(!e.isIntersecting)return;upgradeImg(e.target);STATE.io.unobserve(e.target)})},{rootMargin:CONFIG.behavior.rootMargin,threshold:0.01})}
if(!STATE.ioBg){STATE.ioBg=new IntersectionObserver((entries)=>{if(STATE.paused)return;entries.forEach(e=>{if(!e.isIntersecting)return;upgradeBg(e.target);STATE.ioBg.unobserve(e.target)})},{rootMargin:CONFIG.behavior.rootMargin,threshold:0.01})}
return STATE.io}
function upgradeImg(img){if(!img||STATE.loaded.has(img))return;const ds=img.getAttribute('data-src');const dss=img.getAttribute('data-srcset');if(!ds&&!dss){STATE.loaded.add(img);return}
if(ds){img.src=ds;img.removeAttribute('data-src')}
if(dss){img.srcset=dss;img.removeAttribute('data-srcset')}
if(!img.hasAttribute('fetchpriority'))img.setAttribute('fetchpriority','low');STATE.loaded.add(img)}
function upgradeBg(el){if(!el||STATE.loadedBg.has(el))return;const bg=el.getAttribute('data-bg');if(bg){el.style.backgroundImage=`url("${bg}")`;el.removeAttribute('data-bg');STATE.loadedBg.add(el)}}
/* v77 FIX: observeRoot nie pomija już raz odwiedzonego korzenia, tylko obserwuje
   obrazki, których jeszcze nie widział (WeakSet observed). Slajdy przebudowane po
   pierwszym przebiegu (swiper, klony) dostają obserwatora przy kolejnym wywołaniu. */
function observeRoot(root){const io=ensureIO();if(!root)return;root.querySelectorAll(CONFIG.selectors.menuImages).forEach(img=>{if(STATE.loaded.has(img)||STATE.observed.has(img))return;const realSrc=/^(https?:)?\/\//i.test(img.currentSrc||img.src||'');const needs=!realSrc&&(img.hasAttribute('data-src')||/^data:image\/(svg\+xml|png|gif|jpe?g|webp|avif)/i.test(img.src||''));if(needs){if(io){STATE.io.observe(img);STATE.observed.add(img)}else upgradeImg(img)}});root.querySelectorAll(CONFIG.selectors.bgTiles).forEach(el=>{if(STATE.loadedBg.has(el)||STATE.observedBg.has(el))return;if('IntersectionObserver' in window){STATE.ioBg.observe(el);STATE.observedBg.add(el)}else upgradeBg(el)});STATE.initializedRoots.add(root);log('observeRoot ok',root)}
/* v77 FIX: wpisy IO dostarczone, gdy karta była w tle, były odrzucane (paused) i
   kasowane przez takeRecords, a element w lepkim nagłówku nigdy nie generuje
   kolejnego wpisu. Po powrocie karty obserwujemy oczekujące obrazki od nowa:
   observe() po unobserve() oddaje świeży wpis ze stanem początkowym. */
function reobservePending(){try{if(STATE.io)document.querySelectorAll(CONFIG.selectors.menuImages).forEach(img=>{if(STATE.loaded.has(img))return;if(img.hasAttribute('data-src')||img.hasAttribute('data-srcset')){STATE.io.unobserve(img);STATE.io.observe(img);STATE.observed.add(img)}});if(STATE.ioBg)document.querySelectorAll(`${CONFIG.selectors.bgTiles}[data-bg]`).forEach(el=>{STATE.ioBg.unobserve(el);STATE.ioBg.observe(el);STATE.observedBg.add(el)})}catch(e){}}
function preloadSome(root,limit=CONFIG.behavior.maxPreloadPerOpen){if(!root||isSaveData()||isVerySlowNet())return;let n=0;const list=root.querySelectorAll(`${CONFIG.selectors.menuImages}[data-src], `+`${CONFIG.selectors.bgTiles}[data-bg]`);for(const el of list){if(el.tagName==='IMG')upgradeImg(el);else upgradeBg(el);if(++n>=limit)break}
if(n)log('prefetch',n);}
document.addEventListener('click',(ev)=>{const el=getEventElement(ev);if(!el)return;const toggle=closestSafe(el,CONFIG.selectors.toggles)||(el.matches&&el.matches(CONFIG.selectors.toggles)?el:null);if(!toggle)return;const root=closestSafe(toggle,CONFIG.selectors.root);if(!root)return;setTimeout(()=>{observeRoot(root);preloadSome(root)},120)},{passive:!0});const initAllRoots=()=>{document.querySelectorAll(CONFIG.selectors.root).forEach(observeRoot)};if(document.readyState==='loading'){document.addEventListener('DOMContentLoaded',initAllRoots,{once:!0})}else{initAllRoots()}
/* v77 FIX: drugi przebieg po load (slajdy przebudowane między DOMContentLoaded a load)
   i jeszcze jeden po sekundzie bezczynności jako siatka bezpieczeństwa. */
window.addEventListener('load',()=>{initAllRoots();setTimeout(initAllRoots,1000)},{once:!0});
document.addEventListener('shopify:section:load',(e)=>{if(!e||!e.target)return;e.target.querySelectorAll(CONFIG.selectors.root).forEach(observeRoot)});document.addEventListener('visibilitychange',()=>{STATE.paused=document.visibilityState==='hidden';if(!STATE.paused){initAllRoots();reobservePending()}});function cleanup(){try{if(STATE.io)STATE.io.disconnect();if(STATE.ioBg)STATE.ioBg.disconnect();STATE.initializedRoots=new WeakSet()}catch(e){}}
window.addEventListener('pagehide',cleanup);document.addEventListener('shopify:section:unload',cleanup)})()

;
/* ===== pg-sku-search.js ===== */
/* =============================================================================
   pg-sku-search.js  —  Priorytet dokładnego SKU w natywnej wyszukiwarce
   -----------------------------------------------------------------------------
   Natywne wyszukiwanie Shopify jest ZAWODNE dla SKU maszyn (pełne wyniki często
   ich nie zawierają), a zapytanie TYLKO po polu SKU zwraca je pewnie. Dlatego:

   1) DROPDOWN: dokłada produkty pasujące po SKU na GÓRĘ podpowiedzi (karty motywu).
   2) STRONA WYNIKÓW (/search): pobiera produkty pasujące po SKU i wstawia je na
      POCZĄTEK siatki #collection__main-grid, w kartach 'product-card' (3 w rzędzie),
      z deduplikacją. Siatka jest chowana do czasu wstawienia (fade) — bez przeskoku.
      (Współpracuje z inline-skryptem w theme.liquid, który chowa siatkę od pierwszego
       malowania. Bez niego też działa — tylko przeskok może błysnąć.)

   Nie rusza wyszukiwania po nazwach. Zależności: brak.
   ============================================================================= */
(function () {
  "use strict";

  var DEBOUNCE_MS = 250;
  var SKU_LIMIT = 10; /* v83: maksimum API podpowiedzi; przy 6 dokładne SKU (np. KDV920) bywało na 7. miejscu i strona wyników nie dostawała karty */

  function base() {
    var r = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
    return (window.routes && window.routes.predictive_search_url) || (r + "search/suggest");
  }
  function skuUrl(q, section) {
    return base() + "?q=" + encodeURIComponent(q) +
      "&resources[type]=product&resources[limit]=" + SKU_LIMIT +
      "&resources[options][fields]=variants.sku&resources[limit_scope]=each" +
      "&section_id=" + section;
  }
  function isSkuLike(q) { return !!q && q.indexOf(" ") === -1 && q.length >= 2; }
  function fetchHtml(url) {
    return fetch(url, { credentials: "same-origin" }).then(function (r) { return r.ok ? r.text() : ""; });
  }
  function parse(html) { var d = document.createElement("div"); d.innerHTML = html; return d; }

  /* ------------------------------- DROPDOWN ------------------------------- */
  function getInput() {
    return document.querySelector('search-bar input[type="search"], #quickSearch input[type="search"], input[name="q"][type="search"]');
  }
  var dd = { query: "", cardsHtml: "" };

  function boostDropdown(q) {
    dd.query = q; dd.cardsHtml = "";
    if (!isSkuLike(q)) { reinjectDropdown(); return; }
    fetchHtml(skuUrl(q, "search-predictive")).then(function (html) {
      var input = getInput();
      if (!input || input.value.trim() !== q) return;
      var slides = parse(html).querySelectorAll(".predictive-search__product-list .searchSlide[data-sku]");
      if (!slides.length) { reinjectDropdown(); return; }
      var tmp = document.createElement("div");
      for (var i = 0; i < slides.length; i++) tmp.appendChild(slides[i].cloneNode(true));
      dd.cardsHtml = tmp.innerHTML; reinjectDropdown();
    }).catch(function () {});
  }

  function reinjectDropdown() {
    var list = document.querySelector(".predictive-search__product-list");
    if (!list) return;
    var input = getInput(); var q = input ? input.value.trim() : "";
    var old = list.querySelectorAll(".searchSlide.pg-sku-injected");
    for (var i = 0; i < old.length; i++) old[i].remove();
    if (!dd.cardsHtml || q !== dd.query) return;
    var mySlides = parse(dd.cardsHtml).querySelectorAll(".searchSlide[data-sku]");
    if (!mySlides.length) return;
    var mySkus = {};
    for (var j = 0; j < mySlides.length; j++) mySkus[(mySlides[j].getAttribute("data-sku") || "").toUpperCase()] = 1;
    var nat = list.querySelectorAll(".searchSlide[data-sku]");
    for (var k = 0; k < nat.length; k++) { if (mySkus[(nat[k].getAttribute("data-sku") || "").toUpperCase()]) nat[k].remove(); }
    var frag = document.createDocumentFragment();
    for (var m = 0; m < mySlides.length; m++) { var el = mySlides[m].cloneNode(true); el.classList.add("pg-sku-injected"); frag.appendChild(el); }
    list.insertBefore(frag, list.firstChild);
  }

  function initDropdown() {
    var input = getInput(); if (!input) return;
    var t;
    input.addEventListener("input", function () { clearTimeout(t); t = setTimeout(function () { boostDropdown(input.value.trim()); }, DEBOUNCE_MS); });
    var container = input.closest("search-bar") || document.querySelector("search-bar") || document.body;
    new MutationObserver(function () {
      var list = document.querySelector(".predictive-search__product-list");
      if (!list) return;
      if (list.querySelector(".searchSlide.pg-sku-injected")) return;
      reinjectDropdown();
    }).observe(container, { childList: true, subtree: true });
  }

  /* ----------------------------- STRONA WYNIKOW ----------------------------- */
  var spCardsHtml = "";
  var injecting = false;

  // Odsłonięcie siatki (usuwa ukrycie z inline-skryptu + płynny fade-in)
  function revealSearchGrid() {
    var grid = document.querySelector("#collection__main-grid");
    if (grid) { grid.style.opacity = "1"; }
    var st = document.getElementById("pg-sku-prehide");
    if (st && st.parentNode) st.parentNode.removeChild(st);
  }

  function injectSearchGrid() {
    if (injecting) return;
    var grid = document.querySelector("#collection__main-grid");
    if (!grid || !spCardsHtml) return;
    if (grid.querySelector(".pg-sku-card.pg-sku-injected")) return; // już wstawione

    var cards = parse(spCardsHtml).querySelectorAll(".pg-sku-card[data-pg-handle]");
    if (!cards.length) return;

    injecting = true;
    try {
      var handles = {};
      for (var i = 0; i < cards.length; i++) handles[cards[i].getAttribute("data-pg-handle")] = 1;
      var links = grid.querySelectorAll('.main-search__product a[href*="/products/"]');
      for (var j = 0; j < links.length; j++) {
        var mm = (links[j].getAttribute("href") || "").match(/\/products\/([a-z0-9_-]+)/);
        if (mm && handles[mm[1]]) {
          var w = links[j].closest(".main-search__product");
          if (w && !w.classList.contains("pg-sku-card")) w.remove();
        }
      }
      var frag = document.createDocumentFragment();
      for (var k = 0; k < cards.length; k++) { var el = cards[k].cloneNode(true); el.classList.add("pg-sku-injected"); frag.appendChild(el); }
      grid.insertBefore(frag, grid.firstChild);
    } finally {
      injecting = false;
    }
  }

  function initSearchPage() {
    if (!/\/search$/.test(location.pathname.replace(/\/+$/, ""))) return;
    var q = (new URLSearchParams(location.search).get("q") || "").trim();
    if (!isSkuLike(q)) { revealSearchGrid(); return; }

    fetchHtml(skuUrl(q, "search-sku-cards")).then(function (html) {
      spCardsHtml = html;
      injectSearchGrid();
      revealSearchGrid();
      // ponowne wstawienie po AJAX-owym przeładowaniu siatki (filtry / sortowanie)
      var target = document.querySelector("#mainCollectionContainer") ||
                   document.querySelector("#collection__grid-wrapper") ||
                   document.querySelector("#filterSection") || document.body;
      var dbt;
      new MutationObserver(function () { clearTimeout(dbt); dbt = setTimeout(injectSearchGrid, 50); })
        .observe(target, { childList: true, subtree: true });
    }).catch(revealSearchGrid);
  }

  function init() { initSearchPage(); initDropdown(); }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init, { once: true });
  else init();
})();

;
/* ===== sku-copy.js ===== */
(function () {
  function showTooltip(target, text) {
    const tip = document.createElement('div');
    tip.textContent = text;
    Object.assign(tip.style, {
      position: 'absolute',
      background: '#000',
      color: '#fff',
      padding: '4px 8px',
      borderRadius: '4px',
      fontSize: '12px',
      zIndex: 9999,
      whiteSpace: 'nowrap',
      pointerEvents: 'none'
    });
    const rect = target.getBoundingClientRect();
    tip.style.top  = (window.scrollY + rect.top  - 28) + 'px';
    tip.style.left = (window.scrollX + rect.left) + 'px';
    document.body.appendChild(tip);
    setTimeout(() => tip.remove(), 1000);
  }

  document.addEventListener('click', function (e) {
    if (!e.target || !e.target.closest) return;
    const el = e.target.closest('.js-no-link');
    if (!el) return;
    const sel = window.getSelection && window.getSelection().toString().trim();
    e.preventDefault();
    e.stopPropagation();
    if (sel) return;
    const sku = el.getAttribute('data-sku') || el.textContent.trim();
    if (!sku) return;
    navigator.clipboard.writeText(sku)
      .then(() => showTooltip(el, 'Skopiowano!'))
      .catch(() => showTooltip(el, 'Nie udało się skopiować SKU'));
  }, true);

  document.addEventListener('keydown', function (e) {
    // zdarzenie wysłane na document/window (np. przez aplikację) nie ma `closest` – bez tej osłony błąd JS (walidacja 232)
    if (!e.target || !e.target.closest) return;
    const el = e.target.closest('.js-no-link');
    if (!el) return;
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      const sku = el.getAttribute('data-sku') || el.textContent.trim();
      if (!sku) return;
      navigator.clipboard.writeText(sku)
        .then(() => showTooltip(el, 'Skopiowano!'))
        .catch(() => showTooltip(el, 'Nie udało się skopiować SKU'));
    }
  }, true);
})();

;
/* ===== patches.js ===== */
if(window.RevolutionAnimation){RevolutionAnimation.prototype.elementScaleOut=function(elements){const dur=window.theme.animationDuration*2;const step=window.theme.animationBetweenElements;elements.forEach((el,i)=>{if(el.hasAttribute('data-loaded'))return;setTimeout(()=>{el.animate([{transform:'scale(104%)',opacity:'0'},{transform:'scale(100%)',opacity:'1'}],{duration:dur,fill:'forwards'})},step*i);if(!el.hasAttribute('always-animate'))el.setAttribute('data-loaded','true');})}}(function fixDrawerCondition(){const proto=window.Drawer&&window.Drawer.prototype;if(!proto||proto.__patchedMenuCond)return;const _open=proto.openDrawer;proto.openDrawer=function(){const wasVisible=this.pageOverlayElement.classList.contains('is-visible');const ret=_open.apply(this,arguments);if(this.element&&this.element.getAttribute('id')!=='menu'){if(!wasVisible)this.pageOverlayElement.classList.add('is-visible');}
return ret};proto.__patchedMenuCond=!0})();(function fixZoomResize(){const P=window.RevolutionImageZoom&&window.RevolutionImageZoom.prototype;if(!P||P.__patchedResize)return;const _bind=P.bindEvents;P.bindEvents=function(){this.syncHeight=this.syncHeight.bind(this);window.addEventListener('resize',this.syncHeight);return _bind.apply(this,arguments)};P.__patchedResize=!0})()

;
/* ===== header-scroll (v84) ===== */
/* Motyw ustawia #header.header-scrolled tylko poniżej progu desktop (onScrollShrink nie jest
   podpinany na desktopie), więc html.pg-scrolled (scrollY > 0) ustawiamy tu – korzystają z niej
   reguły w base-min.css (cień pod menu po przewinięciu). 18.09 (D4): pasek kontaktowy nad logo
   już się po przewinięciu nie zwija – stoi poza przyklejoną sekcją i po prostu się przewija. */
(function () {
  var root = document.documentElement;
  var ticking = false;
  function apply() {
    ticking = false;
    root.classList.toggle('pg-scrolled', window.scrollY > 0);
  }
  window.addEventListener('scroll', function () {
    if (!ticking) { ticking = true; requestAnimationFrame(apply); }
  }, { passive: true });
  apply();
})();

;
/* ===== header-menu-threshold (v86) ===== */
/* Pasek kategorii to pierwsze menu otwarte na stałe u góry strony (options.menu_is_closed = 0).
   Motyw (Header w global.min.js, closeScrollThreshold = 200) zamykał je dopiero po przewinięciu
   > 200 px w dół i otwierał ponownie przy <= 200 px w górę, a nagłówek maleje (html.pg-scrolled)
   już od 1 px - w pasie 1-200 px pasek wisiał 32 px wyżej niż zwykle i nachodził na treść, a przy
   powrocie na samą górę "spadał" o 32 px (zgłoszenie: "pasek kategorii ~50 px niżej po
   przewinięciu"). Próg = 0: pasek jest otwarty tylko na samej górze i znika/wraca razem ze
   zmianą wysokości nagłówka; strona otwarta od razu przewinięta (powrót, kotwica) startuje
   bez paska.
   20.09 (T2 – zgłoszenie): zamknięty pasek ZOSTAWIAŁ swoje miejsce w dokumencie (rezerwa – bez skoku układu), więc między 0 a ok. 164 px
   przewinięcia pod menu była pusta przestrzeń (pomiar 1440/1920: 124 px przy 40 px, 84 px przy 80 px, 34 px przy 130 px).
   Od 18.09 nagłówek nie zmienia już wysokości przy przewinięciu (pasek kontaktu przewija się normalnie), więc dawny powód
   zamykania paska zniknął. Pasek (rozwijane menu pierwszej pozycji) jest elementem ABSOLUTNYM w przyklejonym nagłówku,
   a jego miejsce w treści to zarezerwowany odstęp pierwszej sekcji szablonu (126 px + marginesy); samo „nie zamykanie”
   paska zrobiłoby z niego drugi przyklejony pasek zasłaniający treść (sprawdzone 19:40). Rozwiązanie: pasek jest ZAWSZE
   otwarty (próg = Infinity), a przy przewijaniu dostaje transform translateY(−przesunięcie), przez co wizualnie zostaje
   PRZYKLEJONY DO SWOJEGO MIEJSCA W TREŚCI i chowa się pod nagłówek razem z nim (z-index −1 – zasłania go tło nagłówka),
   jak zwykła treść; wraca dokładnie tak samo przy przewijaniu w górę. Transform nie zmienia układu (skok układu 0), pusta
   przestrzeń znika, a po najechaniu na „Kategorie” (albo fokusie) pasek pokazuje się pod nagłówkiem jak zwykłe rozwijane
   menu (reguła `transform: none !important` w base-min.css). Strona otwarta od razu przewinięta dostaje pasek otwarty
   i od razu schowany pod nagłówkiem. */
(function () {
  function patch(h) {
    if (!h || h.__pgThreshold) return;
    h.__pgThreshold = true;
    h.closeScrollThreshold = Infinity;
    if (!h.options || h.options.menu_is_closed != 0 || !h.el || !h.el.querySelector) return;
    /* v5 (21.09, T2/T3 – zgłoszenie). Do v4 przesunięcie dostawał tylko pas PIERWSZEJ pozycji („Kategorie”) – pas „Kategorie wg branży”
       po przewinięciu zostawał pod nagłówkiem jak drugi przyklejony pasek i zasłaniał treść, a przewinięcie w górę otwierało
       oba pasy naraz (motyw przy progu = Infinity przy każdym ruchu w górę otwiera pierwszą pozycję). Strzałka zawsze
       pokazywała „w górę” i nic nie robiła (motyw nie zamyka pasa poniżej progu). Teraz:
       – KAŻDY pas z rozwijanym menu dostaje to samo przesunięcie z osi przewijania (własny zakres – pasy mogą mieć różną wysokość);
       – zawsze rozwinięta jest tylko WYBRANA zakładka (`wybrany`; zmienia ją tylko kliknięcie pozycji menu);
       – strzałka należy do nas (`h.arrow = null` – motyw przestaje jej dotykać): pas schowany pod nagłówkiem = strzałka w dół,
         kliknięcie PRZYPINA pas pod nagłówkiem (klasa `pg-pasek-otwarty` – ta sama reguła co najechanie), ponowne kliknięcie
         albo przewinięcie strony zwija go z powrotem; u góry strony (pas stoi w swoim miejscu) kliknięcie przewija stronę
         o wysokość pasa – pas chowa się pod nagłówek bez pustego miejsca po nim;
       – kliknięcie pozycji menu przy schowanym pasie też go przypina (na ekranie dotykowym nie ma najechania);
       – karta produktu: motyw zamyka wszystkie menu, gdy pojawia się przyklejony pasek zakupu (`menu:close`) – pas jest wtedy
         i tak schowany, a najechanie, fokus, strzałka albo kliknięcie pozycji otwierają go ponownie. */
    var lis = Array.prototype.slice.call(h.el.querySelectorAll(".header-link-desk[aria-haspopup='true']"));
    var first = lis[0];
    if (!first || first.classList.contains('desk-menu-closed') || typeof h.openMenu !== 'function') return;
    var hg = h.el.parentElement;
    var paski = [];
    lis.forEach(function (li) {
      var w = li.querySelector('.desktop-menu__dropdown-wrapper');
      if (w && w.parentElement === li) paski.push({ li: li, w: w, cap: 0 });
    });
    if (!paski.length || !hg) return;
    var otworzMotywu = h.openMenu;
    var wybrany = first, przypiety = false, pinY = 0, klik = null;
    var strzalka = h.arrow || null;
    h.arrow = null;
    function rozwiniety(li) { return li.getAttribute('aria-expanded') === 'true'; }
    function otworz(li) { if (!rozwiniety(li)) { try { otworzMotywu.call(h, li); } catch (e) {} } }
    /* motyw woła openMenu(pierwsza pozycja) przy każdym przewinięciu w górę – druga otwarta zakładka zostaje jedyną,
       a po zamknięciu wszystkich (karta produktu) wraca zakładka WYBRANA, nie pierwsza */
    h.openMenu = function (li) {
      for (var i = 0; i < lis.length; i++) { if (lis[i] !== li && rozwiniety(lis[i])) return; }
      if (!klik && li === first && wybrany !== first) li = wybrany;
      return otworzMotywu.call(h, li);
    };
    otworz(first);
    var start = 0, ticking = false;
    /* v4 (20.09, – właściciel: pasek „odbija się od okruszków” przy kółku myszy): przesunięcie ze zdarzenia
       `scroll` + requestAnimationFrame bywało o klatkę ZA treścią (kompozytor przewija stronę, skrypt dogania w następnej
       klatce), więc pasek drgał względem okruszków. Teraz przesunięcie liczy KOMPOZYTOR z osi przewijania – animacja
       sterowana przewijaniem (`animation-timeline: scroll()`, reguła `.pg-pasek` w base-min.css): w każdej klatce dokładnie
       −(przewinięcie − start), bez skryptu; skrypt tylko mierzy start i zakres (`animation-range`, `--pg-pasek-cap`) i mierzy
       od nowa po zmianie rozmiaru. Przeglądarka bez wsparcia (dziś Safari) dostaje dawny transform ze zdarzenia scroll.
       clip-path z 21:2x niepotrzebny: rząd logo ma od v4 własne tło i pozycję (base-min.css), więc pasek z z-index −1 chowa
       się pod nim tak samo jak pod białym rzędem nawigacji. */
    var os = !!(window.CSS && CSS.supports && CSS.supports('animation-timeline: scroll()'));
    function zmierz() {
      /* start = pozycja w dokumencie, od której nagłówek jest przyklejony (dół elementu stojącego nad nim – pasek
         kontaktu); cap = o ile pas wystaje pod dolną krawędź nagłówka (tyle wystarczy go podnieść, żeby zniknął) */
      var prev = hg.previousElementSibling;
      while (prev && prev.getBoundingClientRect().height === 0) prev = prev.previousElementSibling;
      start = prev ? Math.max(0, prev.getBoundingClientRect().bottom + window.scrollY) : 0;
      var hb = hg.getBoundingClientRect().bottom;
      paski.forEach(function (p) { p.cap = Math.max(0, Math.round(p.w.getBoundingClientRect().bottom - hb)); });
    }
    function pasekWybrany() {
      for (var i = 0; i < paski.length; i++) { if (paski[i].li === wybrany) return paski[i]; }
      return null;
    }
    /* zwinięty = cały pas jest pod nagłówkiem (albo motyw zamknął menu na karcie produktu) */
    function zwiniety() {
      var p = pasekWybrany();
      if (!p || !rozwiniety(wybrany)) return true;
      return p.cap > 0 && window.scrollY - start >= p.cap - 1;
    }
    function odswiez() {
      if (!strzalka) return;
      var v = (przypiety || !zwiniety()) ? 'true' : 'false';
      if (strzalka.getAttribute('data-open') !== v) strzalka.setAttribute('data-open', v);
      if (strzalka.getAttribute('aria-expanded') !== v) strzalka.setAttribute('aria-expanded', v);
    }
    function odepnij() {
      przypiety = false;
      lis.forEach(function (li) { li.classList.remove('pg-pasek-otwarty'); });
      odswiez();
    }
    function przypnij() {
      otworz(wybrany);
      lis.forEach(function (li) { li.classList.toggle('pg-pasek-otwarty', li === wybrany); });
      przypiety = true;
      pinY = window.scrollY;
      odswiez();
    }
    function zwinPrzewinieciem() {
      var p = pasekWybrany();
      if (!p) return;
      var cel = Math.ceil(start + p.cap);
      if (cel > document.documentElement.scrollHeight - window.innerHeight) return;
      var spokojnie = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      window.scrollTo({ top: cel, behavior: spokojnie ? 'auto' : 'smooth' });
    }
    function ustaw() {
      paski.forEach(function (p) {
        var t = Math.min(Math.max(0, window.scrollY - start), p.cap);
        p.w.style.transform = t ? 'translateY(-' + t + 'px)' : '';
      });
    }
    function poPrzewinieciu() {
      ticking = false;
      if (!os) ustaw();
      /* „jak się scrolluje to samo ma się zwijać”: przypięty pas zwija każde wyraźne przewinięcie (30 px – zapas na drgnięcie
         kółka przy samym kliknięciu) albo zamknięcie menu przez motyw */
      if (przypiety && (Math.abs(window.scrollY - pinY) > 30 || !rozwiniety(wybrany))) { odepnij(); return; }
      odswiez();
    }
    /* 26.09 (525 T8, etap 1 – ślad `watek-uklad-przyczyny.js`: na telefonie ×4 pomiar pasów wymuszał przeliczenie stylów 61 ms przy wczytaniu):
       menu komputera (klasy `not_mobile not_pocket`) widać dopiero od 1024 px – węższy ekran nie ma czego mierzyć; po obróceniu / poszerzeniu
       okna do 1024+ pomiar robi zdarzenie `resize` (jak dotąd). */
    var mqMenuKomputera = window.matchMedia('(min-width: 1024px)');
    function odNowa() {
      if (!mqMenuKomputera.matches) return;
      /* pomiar bez przesunięcia: animacja wyłączona, a transform zdjęty z pierwszeństwem – nieaktywny pas ma w arkuszu
         translateY(−15 %), które zaniżałoby jego zakres */
      paski.forEach(function (p) {
        p.w.style.animation = 'none';
        p.w.style.setProperty('transform', 'none', 'important');
      });
      zmierz();
      paski.forEach(function (p) {
        p.w.style.removeProperty('transform');
        /* najpierw zdjąć `animation: none` – ustawienie skrótu `animation` (także pustego) zeruje w CSSOM zakres
           `animation-range`, więc zakres i --pg-pasek-cap idą PO nim (20.09 22:2x: odwrotna kolejność dawała pusty zakres
           i przesunięcie rozciągnięte na całą stronę – 1,5 px przy 80 px przewinięcia) */
        p.w.style.animation = '';
        if (os) {
          p.w.style.setProperty('--pg-pasek-cap', p.cap + 'px');
          p.w.style.animationRange = start + 'px ' + (start + p.cap) + 'px';
          p.w.classList.add('pg-pasek');
        }
      });
      if (!os) ustaw();
      odswiez();
    }
    paski.forEach(function (p) {
      p.w.style.transition = 'none';
      p.w.style.clipPath = '';
    });
    odNowa();
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(poPrzewinieciu); } }, { passive: true });
    window.addEventListener('resize', odNowa, { passive: true });
    window.addEventListener('load', odNowa);
    if (strzalka) {
      /* faza przechwytywania + stopImmediatePropagation: własny przełącznik motywu (toggleFirstMenu) nie rusza */
      strzalka.addEventListener('click', function (e) {
        e.stopImmediatePropagation();
        if (przypiety) odepnij();
        else if (zwiniety()) przypnij();
        else zwinPrzewinieciem();
      }, true);
    }
    /* kliknięcie pozycji menu: zmiana zakładki należy do motywu (toggleMenu, opóźnienie 25 ms) – po niej zapamiętujemy wybór,
       mierzymy od nowa (pasy mogą mieć różną wysokość) i przy schowanym pasie przypinamy go (druga zakładka) albo przełączamy
       przypięcie (ta sama zakładka) */
    h.el.addEventListener('click', function (e) {
      var a = e.target && e.target.closest ? e.target.closest('.header-link-desk[aria-haspopup=\'true\'] > .header-main-links') : null;
      if (!a) return;
      var li = a.parentElement;
      var tenSam = li === wybrany && rozwiniety(li);
      klik = li;
      setTimeout(function () {
        klik = null;
        wybrany = li;
        otworz(li);
        odNowa();
        if (!zwiniety() && !przypiety) { odswiez(); return; }
        if (tenSam && przypiety) odepnij(); else przypnij();
      }, 60);
    }, true);
    /* po zamknięciu wszystkich menu przez motyw (karta produktu) reguła najechania / fokusu nie ma czego pokazać –
       otwieramy wybraną zakładkę z powrotem (pas i tak jest schowany pod nagłówkiem) */
    lis.forEach(function (li) {
      function wroc() { if (li === wybrany && !rozwiniety(li)) otworz(li); }
      li.addEventListener('mousemove', wroc, { passive: true });
      li.addEventListener('focusin', wroc);
    });
    /* Escape zwija przypięty pas i oddaje fokus strzałce (wzorzec przycisku rozwijającego) */
    h.el.addEventListener('keydown', function (e) {
      if (e.key !== 'Escape' || !przypiety) return;
      odepnij();
      if (strzalka && h.el.contains(document.activeElement)) strzalka.focus();
    });
  }
  function init() { document.querySelectorAll('header-component').forEach(patch); }
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('header-component').then(init);
  } else {
    init();
  }
})();

;
/* ===== contact-prefill (v86) ===== */
/* Karta produktu ma link "Zapytaj o produkt" -> /pages/kontakt?produkt=<tytuł>&sku=<SKU>#contactForm
   (blocks/_product-trust-items.liquid). Tu, jeśli pole wiadomości jest puste, wpisujemy szablon
   z data-pg-prefill formularza (blocks/contact-form.liquid, tekst z pliku językowego) i ustawiamy
   kursor za nim, żeby klient dopisał pytanie. */
(function () {
  var wrap = document.querySelector('.contact-form__wrapper[data-pg-prefill]');
  if (!wrap) return;
  var q = new URLSearchParams(location.search);
  var p = q.get('produkt'), s = q.get('sku');
  if (!p && !s) return;
  var ta = wrap.querySelector('textarea[name="contact[message]"]');
  if (!ta || ta.value.trim()) return;
  var tpl = wrap.getAttribute('data-pg-prefill') || '';
  ta.value = tpl.replace('%p', p || '').replace('%s', s || '') + '\n\n';
  try {
    wrap.scrollIntoView({ block: 'start' });
    ta.focus({ preventScroll: true });
    ta.setSelectionRange(ta.value.length, ta.value.length);
  } catch (e) {}
})();

;
/* ===== money-format (v84) ===== */
/* Format waluty sklepu to {{amount_with_space_separator}} zł (zmiana w panelu 13.09.2026).
   Shopify.formatMoney z global.min.js zna tylko warianty "amount", "amount_no_decimals" i
   "..._with_comma_separator"; dla separatora spacji zwracałby pustą kwotę. Tu dokładamy
   oba warianty ze spacją (tysiące spacją, grosze po przecinku), reszta idzie do oryginału. */
(function () {
  if (!window.Shopify || typeof Shopify.formatMoney !== 'function') return;
  var orig = Shopify.formatMoney;
  var re = /\{\{\s*(\w+)\s*\}\}/;
  Shopify.formatMoney = function (cents, format) {
    var f = format || this.money_format || Shopify.money_format || '';
    var m = String(f).match(re);
    if (!m || !/space_separator/.test(m[1])) return orig.apply(this, arguments);
    if (typeof cents === 'string') cents = cents.replace('.', '');
    var value = parseInt(cents, 10);
    if (isNaN(value)) value = 0;
    var decimals = /no_decimals/.test(m[1]) ? 0 : 2;
    var parts = (value / 100).toFixed(decimals).split('.');
    var whole = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1 ');
    return String(f).replace(re, whole + (parts[1] ? ',' + parts[1] : ''));
  };
})();

;
/* ===== cart-count (v84) ===== */
/* Skrypt motywu po każdej zmianie koszyka wpisuje do .header-cart__item-count tekst "(n)".
   Licznik w nagłówku pokazuje samą liczbę (na telefonie w kółku, na desktopie nawiasy dodaje
   CSS), więc po każdym zapisie sprowadzamy "(n)" do "n". */
/* v96 (6.E): po zmianie liczby odświeżamy też aria-label („Koszyk - 3 produkty”); formy liczby mnogiej
   z pliku językowego (data-pg-forms w sections/main-header.liquid), wybór formy przez Intl.PluralRules. */
/* 19.09 (D5/E2): licznik to napis w linku koszyka (aria-hidden) – aria-label i dane do niego są na linku, nie na liczniku. */
(function () {
  var el = document.querySelector('.header-cart__item-count');
  if (!el || !('MutationObserver' in window)) return;
  var cel = el.closest('[data-pg-label]') || el;
  var label = cel.getAttribute('data-pg-label');
  var forms = null;
  try { forms = JSON.parse(cel.getAttribute('data-pg-forms') || 'null'); } catch (e) {}
  var rules = null;
  try { rules = new Intl.PluralRules(document.documentElement.lang || 'pl'); } catch (e) {}
  function fix() {
    var m = el.textContent.trim().match(/^\((\d+)\)$/);
    if (m) el.textContent = m[1];
    if (!label || !forms) return;
    var n = parseInt(el.textContent.trim(), 10) || 0;
    var word = forms[rules ? rules.select(n) : 'other'] || forms.other || '';
    var next = label + ' - ' + n + ' ' + word;
    if (cel.getAttribute('aria-label') !== next) cel.setAttribute('aria-label', next);
  }
  new MutationObserver(fix).observe(el, { childList: true, characterData: true, subtree: true });
  fix();
})();

;
/* ===== compare (v84) ===== */
/* Porównywarka: przyciski [data-pg-compare="handle"] na kartach i karcie produktu, lista
   produktów w localStorage (maks. 4; wpis = {h: uchwyt, i: miniatura, t: tytuł}), pasek na dole
   strony z miniaturami (jak na x-kom) widoczny tylko, gdy coś jest w porównaniu, i nakładka
   z tabelą (markup: snippets/pg-compare-ui.liquid). Dane każdego produktu daje sekcja
   pg-compare-data renderowana przez Section Rendering API na adresie produktu: nagłówek kolumny
   (zdjęcie, tytuł, SKU, cena, koszyk) i tabela techniczna (p>strong = grupa, table tr th/td =
   wiersz), którą skrypt parsuje i scala w jedną tabelę z zaznaczeniem różnic. Przyciski koszyka
   w nakładce obsługuje klasa AddToCart motywu (globalna w global.min.js). */
(function () {
  var KEY = 'pg_compare';
  /* 21.09 (T14): porównanie w grupach po kategorii głównej – MAX dotyczy JEDNEJ grupy,
     MAX_RAZEM całego paska (kilka grup naraz, jak na x-kom) */
  var MAX = 4;
  var MAX_RAZEM = 12;
  var aktywna = null; /* uchwyt kategorii oglądanej grupy */
  var ui = document.querySelector('[data-pg-compare-ui]');
  if (!ui) return;
  var bar = ui.querySelector('[data-pg-compare-bar]');
  var items = bar.querySelector('[data-pg-compare-items]');
  var tabs = bar.querySelector('[data-pg-compare-tabs]');
  var grupaNazwa = ui.querySelector('[data-pg-compare-grupa-nazwa]');
  var overlay = ui.querySelector('[data-pg-compare-overlay]');
  var body = overlay.querySelector('[data-pg-compare-body]');
  /* 978 (02.10): na telefonie pasek zwinięty do małego przycisku (68 × 63 px, lewy dolny róg – style w snippets/pg-compare-ui.liquid); stuknięcie rozwija
     pełny pasek, strzałka „zwiń” go chowa, komunikat o limicie rozwija sam; klasa body `pg-compare-rozwiniety` – dymek „Ostatnio oglądane” (pg-rvd.js
     obserwuje klasy body) sprawdza wtedy kolizję od nowa. Na komputerze oba przyciski są ukryte, a pasek wygląda jak dotąd */
  var mini = bar.querySelector('[data-pg-compare-mini]');
  var miniN = bar.querySelector('[data-pg-compare-mini-n]');
  var zwin = bar.querySelector('[data-pg-compare-zwin]');
  function rozwin(on) {
    bar.classList.toggle('is-rozwiniety', on);
    document.body.classList.toggle('pg-compare-rozwiniety', on);
    if (mini) mini.setAttribute('aria-expanded', on ? 'true' : 'false');
    /* 41.3 (853, B193 b – jeden zestaw w rogu): otwarty panel porównania zamyka okno „Ostatnio oglądane” (pg-rvd.js słucha `pg:dok`) i odwrotnie */
    if (on) document.dispatchEvent(new CustomEvent('pg:dok', { detail: 'porownanie' }));
    zaplanujZak();
  }
  document.addEventListener('pg:dok', function (e) { if (e.detail !== 'porownanie' && bar.classList.contains('is-rozwiniety')) rozwin(false); });
  /* 41.3: komputer – przycisk porównania stoi w prawym dolnym rogu, dymek „Ostatnio oglądane” obok niego (pg-rvd.css): klasa `pg-dok-porownanie` na <html>
     (też zapas stopki telefonu pod przyciskiem – snippets/pg-compare-ui.liquid) i szerokość przycisku w `--pg-dok-porownanie` – napis zależy od języka
     i czcionki, więc mierzony, nie wpisany na sztywno (po zmianie szerokości okna przez próg 768 px i po wczytaniu czcionek – od nowa) */
  var mqKomp = window.matchMedia('(min-width: 768px)');
  function dok() {
    var h = document.documentElement;
    h.classList.toggle('pg-dok-porownanie', !bar.hidden);
    if (!bar.hidden && mini && mini.offsetWidth) h.style.setProperty('--pg-dok-porownanie', mini.offsetWidth + 'px');
    zaplanujZak();
  }
  if (mqKomp.addEventListener) mqKomp.addEventListener('change', dok);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(dok);
  /* 41.3 (B193 c): przycisk porównania nie zasłania bloku zakupu karty (tytuł → cena → przyciski, „Dodaj do porównania”, pasek faktów) – gdy jego prostokąt na niego
     wypada (pomiar 41.3: komputer – prawy dolny róg 1. ekranu = koniec „Dodaj do koszyka”; telefon – tytuł pod galerią), znika (`pg-compare-bar--zakryje`) i wraca
     po przewinięciu; rozwinięty panel zostaje (klient sam go otworzył). Ta sama reguła co znaczek opinii (1142 – sections/pg-znaczek-zaufania.liquid); blok liczony
     jako JEDEN prostokąt (osobno przycisk wracałby w przerwach między elementami – lekcja znaczka 05.10) */
  var blokZak = [].slice.call(document.querySelectorAll('.pm__title, .pm__price-wrapper, .pm__buttons-pay-quantity, .pg-compare-toggle--sku'));
  var chronZak = [].slice.call(document.querySelectorAll('.pg-compare-toggle--pdp, .pg-fakty > li'));
  var planZak = 0;
  function zakryj() {
    planZak = 0;
    var zak = false;
    if (!bar.hidden && !bar.classList.contains('is-rozwiniety') && mini && (blokZak.length || chronZak.length)) {
      var r = mini.getBoundingClientRect(), u = null;
      var na = function (q) { return q.right - q.left > 0 && q.bottom - q.top > 0 && q.left < r.right - 2 && q.right > r.left + 2 && q.top < r.bottom - 2 && q.bottom > r.top + 2; };
      blokZak.forEach(function (e) {
        var q = e.getBoundingClientRect(); if (!q.width || !q.height) return;
        u = u ? { left: Math.min(u.left, q.left), top: Math.min(u.top, q.top), right: Math.max(u.right, q.right), bottom: Math.max(u.bottom, q.bottom) } : { left: q.left, top: q.top, right: q.right, bottom: q.bottom };
      });
      zak = !!(u && na(u)) || chronZak.some(function (e) { return na(e.getBoundingClientRect()); });
    }
    bar.classList.toggle('pg-compare-bar--zakryje', zak);
  }
  function zaplanujZak() { if (!planZak) planZak = window.requestAnimationFrame(zakryj); }
  if (blokZak.length || chronZak.length) {
    window.addEventListener('scroll', zaplanujZak, { passive: true });
    window.addEventListener('resize', zaplanujZak);
    if (window.ResizeObserver) new ResizeObserver(zaplanujZak).observe(document.body);
    /* pasek zakupu przesuwa przycisk (klasa body) – sprawdzenie od nowa */
    if (window.MutationObserver) new MutationObserver(zaplanujZak).observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }
  var strings = {};
  try { strings = JSON.parse(ui.getAttribute('data-strings') || '{}'); } catch (e) {}
  var cache = {};

  function t(key, fallback) { return strings[key] || fallback; }
  function escapeHtml(s) { return String(s == null ? '' : s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function load() {
    try {
      var v = JSON.parse(localStorage.getItem(KEY) || '[]');
      if (!Array.isArray(v)) return [];
      return v.map(function (x) { return typeof x === 'string' ? { h: x } : x; })
        .filter(function (x) { return x && typeof x.h === 'string' && x.h; })
        .slice(0, MAX_RAZEM);
    } catch (e) { return []; }
  }
  function save(list) { try { localStorage.setItem(KEY, JSON.stringify(list.slice(0, MAX_RAZEM))); } catch (e) {} }
  function handles(list) { return list.map(function (x) { return x.h; }); }

  /* GRUPY (259 T14): klucz grupy = uchwyt kategorii głównej z `data-pg-compare-kat` (snippet pg-kat-glowna);
     wpis bez kategorii (stara lista w przeglądarce, produkt bez ścieżki okruszków) trafia do grupy „Pozostałe” */
  function kluczGrupy(x) { return x && typeof x.k === 'string' ? x.k : ''; }
  function nazwaGrupy(x) { return (x && x.kn) ? x.kn : t('grupa_inne', 'Pozostałe'); }
  function grupy(list) {
    var out = [];
    var gdzie = {};
    list.forEach(function (x) {
      var k = kluczGrupy(x);
      if (!Object.prototype.hasOwnProperty.call(gdzie, k)) { gdzie[k] = out.length; out.push({ k: k, n: nazwaGrupy(x), it: [] }); }
      out[gdzie[k]].it.push(x);
    });
    return out;
  }
  /* oglądana grupa: ostatnio dotknięta, a po odświeżeniu strony – najliczniejsza */
  function grupaAktywna(g) {
    if (!g.length) return null;
    for (var i = 0; i < g.length; i++) if (g[i].k === aktywna) return g[i];
    var naj = g[0];
    g.forEach(function (x) { if (x.it.length > naj.it.length) naj = x; });
    aktywna = naj.k;
    return naj;
  }
  function grupaZListy(list) { return grupaAktywna(grupy(list)); }

  /* miniatura dla paska: obrazek z karty albo z galerii karty produktu, w rozmiarze 120 px */
  function thumbUrl(src) {
    if (!src) return '';
    try {
      var u = new URL(src, location.href);
      if (/cdn\.shopify\.com|\/cdn\/shop\//.test(u.href)) u.searchParams.set('width', '120');
      return u.href;
    } catch (e) { return src; }
  }
  function captureInfo(btn, handle) {
    var scope = btn.closest('.product-card_cont') || btn.closest('.pm__content-wrapper') || document;
    var img = scope.querySelector('.product-card__image, .ProductSlider--ImageFirst, .ProductSlider--Image');
    var titleEl = scope.querySelector('.product-card__information-title, h1.pm__title');
    /* kategoria główna z przycisku: „uchwyt§§nazwa” (pg-kat-glowna); brak = grupa „Pozostałe” */
    var kat = (btn.getAttribute('data-pg-compare-kat') || '').split('§§');
    var info = { h: handle, i: thumbUrl(img ? (img.currentSrc || img.src) : ''), t: titleEl ? titleEl.textContent.replace(/\s+/g, ' ').trim() : '' };
    info.k = (kat[0] || '').trim();
    if (info.k && kat[1]) info.kn = kat[1].trim();
    return info;
  }

  function syncToggles(list) {
    var hs = handles(list);
    document.querySelectorAll('.pg-compare-toggle[data-pg-compare]').forEach(function (btn) {
      var on = hs.indexOf(btn.getAttribute('data-pg-compare')) !== -1;
      btn.setAttribute('aria-pressed', on ? 'true' : 'false');
      /* S1 (makieta R54): na kartach w listach zaznaczenie zmienia tylko pole – napis zostaje (dwa napisy: długi i krótki) */
      if (btn.hasAttribute('data-pg-compare-staly')) return;
      var label = btn.querySelector('.pg-compare-toggle__label');
      if (label) label.textContent = on ? t('added', 'W porównaniu') : t('add', 'Porównaj');
    });
  }
  function syncBar(list) {
    bar.hidden = list.length === 0;
    if (bar.hidden) rozwin(false);
    if (miniN) miniN.textContent = String(list.length);
    if (mini) mini.setAttribute('aria-label', t('bar', 'Porównanie') + ': ' + list.length);
    var g = grupy(list);
    var akt = grupaAktywna(g);
    /* zakładki tylko wtedy, gdy naprawdę są dwie grupy – przy jednej pasek wygląda jak dotąd */
    if (tabs) {
      tabs.hidden = g.length < 2;
      tabs.innerHTML = g.length < 2 ? '' : g.map(function (x) {
        var on = akt && x.k === akt.k;
        return '<button type="button" class="pg-compare-bar__tab' + (on ? ' is-on' : '') + '" data-pg-compare-grupa="' + escapeHtml(x.k) + '" aria-pressed="' + (on ? 'true' : 'false') + '">' +
          escapeHtml(x.n) + ' <span class="pg-compare-bar__tabn">' + x.it.length + '</span></button>';
      }).join('');
    }
    var widoczne = akt ? akt.it : [];
    var count = widoczne.length;
    items.innerHTML = widoczne.map(function (x) {
      return '<span class="pg-compare-bar__item">' +
        (x.i ? '<img src="' + escapeHtml(x.i) + '" alt="' + escapeHtml(x.t) + '" width="40" height="40" loading="lazy">' : '<span class="pg-compare-bar__noimg" aria-hidden="true"></span>') +
        '<button type="button" class="pg-compare-bar__x" data-pg-compare="' + escapeHtml(x.h) + '" aria-label="' + escapeHtml(t('remove', 'Usuń z porównania')) + '">&times;</button></span>';
    }).join('');
    bar.querySelector('[data-pg-compare-count]').textContent = count + ' / ' + MAX;
    bar.querySelector('[data-pg-compare-open]').disabled = count < 2;
    if (count < MAX && list.length < MAX_RAZEM) bar.querySelector('[data-pg-compare-msg]').textContent = '';
    /* przycisk bywa nieaktywny, choć w pasku są cztery produkty – mówimy wprost, dlaczego */
    if (count < 2 && g.length > 1) bar.querySelector('[data-pg-compare-msg]').textContent = t('grupa_info', 'Porównanie w jednej kategorii.');
    dok();
  }
  function render() { var list = load(); syncToggles(list); syncBar(list); return list; }

  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pg-compare]') : null;
    if (!btn) return;
    e.preventDefault();
    var handle = btn.getAttribute('data-pg-compare');
    var list = load();
    var i = handles(list).indexOf(handle);
    if (i !== -1) {
      list.splice(i, 1);
    } else {
      var info = captureInfo(btn, handle);
      var wGrupie = list.filter(function (x) { return kluczGrupy(x) === kluczGrupy(info); }).length;
      if (wGrupie >= MAX) {
        aktywna = kluczGrupy(info);
        bar.hidden = false;
        render();
        bar.querySelector('[data-pg-compare-msg]').textContent = t('max', 'Możesz porównać maksymalnie 4 produkty.');
        rozwin(true);
        return;
      }
      if (list.length >= MAX_RAZEM) {
        bar.hidden = false;
        bar.querySelector('[data-pg-compare-msg]').textContent = t('max_razem', 'Pasek porównania jest pełny – usuń któryś produkt.');
        rozwin(true);
        return;
      }
      list.push(info);
      aktywna = kluczGrupy(info); /* po dodaniu pokazujemy grupę, do której produkt trafił */
    }
    save(list);
    render();
    odswiezOkno(list);
  });

  /* przełączanie grup w pasku (jak zakładki kategorii na x-kom) */
  bar.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-pg-compare-grupa]') : null;
    if (!b) return;
    aktywna = b.getAttribute('data-pg-compare-grupa') || '';
    bar.querySelector('[data-pg-compare-msg]').textContent = '';
    render();
    odswiezOkno(load());
  });

  /* okno porównania zawsze pokazuje oglądaną grupę; gdy zostanie w niej mniej niż 2 produkty – zamykamy */
  function odswiezOkno(list) {
    if (overlay.hidden) return;
    var akt = grupaZListy(list);
    if (!akt || akt.it.length < 2) { closeOverlay(); return; }
    ustawNazweGrupy(akt, grupy(list).length);
    buildTable(handles(akt.it));
  }
  function ustawNazweGrupy(akt, ile) {
    if (!grupaNazwa) return;
    var pokaz = !!(akt && ile > 1 && akt.n);
    grupaNazwa.hidden = !pokaz;
    grupaNazwa.textContent = pokaz ? akt.n : '';
  }

  bar.querySelector('[data-pg-compare-clear]').addEventListener('click', function () { save([]); render(); closeOverlay(); });
  /* 41.3: przycisk to przełącznik (komputer – zostaje widoczny nad panelem, fokus zostaje na nim); telefon – przycisk znika po rozwinięciu, fokus na „zwiń” (978) */
  if (mini) mini.addEventListener('click', function () {
    var byl = bar.classList.contains('is-rozwiniety');
    rozwin(!byl);
    if (!byl && zwin && !mini.getClientRects().length) zwin.focus();
  });
  /* 41.3: komputer – klik obok panelu i przycisku zwija panel (jak okno „Ostatnio oglądane”); „Porównaj” na kartach go nie zwija (panel pokazuje dodany produkt),
     usunięty z panelu przycisk (×) – też nie (po przerysowaniu nie ma go już w dokumencie) */
  document.addEventListener('click', function (e) {
    if (!bar.classList.contains('is-rozwiniety') || !mqKomp.matches) return;
    var tg = e.target;
    if (!tg || !tg.closest || !document.contains(tg) || bar.contains(tg) || tg.closest('[data-pg-compare]')) return;
    rozwin(false);
  });
  if (zwin) zwin.addEventListener('click', function () { rozwin(false); if (mini) mini.focus(); });
  bar.querySelector('[data-pg-compare-open]').addEventListener('click', openOverlay);
  overlay.querySelector('[data-pg-compare-close]').addEventListener('click', closeOverlay);
  overlay.addEventListener('click', function (e) { if (e.target === overlay) closeOverlay(); });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    if (!overlay.hidden) { closeOverlay(); return; }
    /* 978: rozwinięty pasek na telefonie – Escape zwija go jak strzałka */
    if (!bar.classList.contains('is-rozwiniety')) return;
    var wPasku = bar.contains(document.activeElement);
    rozwin(false);
    if (wPasku && mini && mini.getClientRects().length) mini.focus();
  });
  var onlyDiff = overlay.querySelector('[data-pg-compare-diff]');
  onlyDiff.addEventListener('change', function () { overlay.classList.toggle('pg-compare-overlay--diff', onlyDiff.checked); });
  if (typeof AddToCart === 'function') { try { new AddToCart(overlay); } catch (e) {} }

  function fetchProduct(handle) {
    if (cache[handle]) return Promise.resolve(cache[handle]);
    /* v86 EN: prefiks języka (/en/), żeby dane porównywarki były w języku strony */
    var cmpRoot = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
    return fetch(cmpRoot + 'products/' + encodeURIComponent(handle) + '?section_id=pg-compare-data', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        var node = html ? new DOMParser().parseFromString(html, 'text/html').querySelector('[data-pg-compare-product]') : null;
        if (node) cache[handle] = node;
        return node;
      })
      .catch(function () { return null; });
  }

  /* tabela techniczna -> [{ name: 'Rozmiary', rows: { 'Szerokość': '790 mm', ... } }, ...];
     metapole jest owinięte w div.ggmTechnical, więc nagłówki grup i tabele bierzemy z całej
     głębokości w kolejności dokumentu, pomijając akapity wewnątrz tabel */
  function parseSheet(node) {
    var groups = [];
    var sheet = node.querySelector('.pg-compare__sheet');
    if (!sheet) return groups;
    var current = null;
    Array.prototype.forEach.call(sheet.querySelectorAll('p, h3, h4, table'), function (el) {
      var tag = el.tagName;
      if (tag !== 'TABLE' && el.closest('table')) return;
      if ((tag === 'P' || tag === 'H3' || tag === 'H4') && el.textContent.trim()) {
        current = { name: el.textContent.replace(/\s+/g, ' ').trim(), rows: {} };
        groups.push(current);
      } else if (tag === 'TABLE') {
        if (!current) { current = { name: '', rows: {} }; groups.push(current); }
        el.querySelectorAll('tr').forEach(function (tr) {
          var th = tr.querySelector('th');
          var td = tr.querySelector('td');
          if (th && td) current.rows[th.textContent.replace(/\s+/g, ' ').trim()] = td.textContent.replace(/\s+/g, ' ').trim();
        });
      }
    });
    return groups;
  }

  function buildTable(list) {
    body.innerHTML = '<p class="pg-compare__loading">' + escapeHtml(t('loading', 'Wczytuję dane…')) + '</p>';
    Promise.all(list.map(fetchProduct)).then(function (nodes) {
      var products = [];
      nodes.forEach(function (n, i) { if (n) products.push({ handle: list[i], node: n, groups: parseSheet(n) }); });
      if (products.length < 2) {
        body.innerHTML = '<p class="pg-compare__loading">' + escapeHtml(t('empty', 'Dodaj co najmniej dwa produkty.')) + '</p>';
        return;
      }
      /* kolejność grup i etykiet: jak w pierwszym produkcie, brakujące dopisane z kolejnych */
      var order = [];
      products.forEach(function (p) {
        p.groups.forEach(function (g) {
          var og = null;
          for (var k = 0; k < order.length; k++) { if (order[k].name === g.name) { og = order[k]; break; } }
          if (!og) { og = { name: g.name, labels: [] }; order.push(og); }
          Object.keys(g.rows).forEach(function (l) { if (og.labels.indexOf(l) === -1) og.labels.push(l); });
        });
      });
      var cols = products.length + 1;
      var html = '<table class="pg-compare__table"><thead><tr><th></th>';
      products.forEach(function (p) {
        var head = p.node.querySelector('.pg-compare__head');
        html += '<th>' + (head ? head.outerHTML : '') +
          '<button type="button" class="pg-compare__remove" data-pg-compare="' + escapeHtml(p.handle) + '">' + escapeHtml(t('remove', 'Usuń z porównania')) + '</button></th>';
      });
      html += '</tr></thead><tbody>';
      /* S1 (makieta R57): pierwszy wiersz „Klasa efektywności energetycznej” („D w skali od A+++ do G”) – gdy choć jeden
         porównywany produkt ma klasę w polu prime.eprel_json (tekst liczy sekcja pg-compare-data) */
      var ee = products.map(function (p) { return p.node.getAttribute('data-pg-ee-tekst') || ''; });
      if (ee.some(function (v) { return v; })) {
        var eeSame = ee.every(function (v) { return v === ee[0]; });
        html += '<tr class="' + (eeSame ? 'is-same' : 'is-diff') + '"><th>' + escapeHtml(t('ee_row', 'Klasa efektywności energetycznej')) + '</th>' +
          ee.map(function (v) { return '<td>' + (v ? escapeHtml(v) : '<span class="pg-compare__none">–</span>') + '</td>'; }).join('') + '</tr>';
      }
      order.forEach(function (g) {
        if (g.name) html += '<tr class="pg-compare__group"><th colspan="' + cols + '">' + escapeHtml(g.name) + '</th></tr>';
        g.labels.forEach(function (label) {
          var vals = products.map(function (p) {
            var grp = null;
            for (var k = 0; k < p.groups.length; k++) { if (p.groups[k].name === g.name) { grp = p.groups[k]; break; } }
            return grp && grp.rows[label] !== undefined ? grp.rows[label] : '';
          });
          var same = vals.every(function (v) { return v === vals[0]; });
          html += '<tr class="' + (same ? 'is-same' : 'is-diff') + '"><th>' + escapeHtml(label) + '</th>' +
            vals.map(function (v) { return '<td>' + (v ? escapeHtml(v) : '<span class="pg-compare__none">–</span>') + '</td>'; }).join('') + '</tr>';
        });
      });
      html += '</tbody></table>';
      body.innerHTML = html;
    });
  }

  function openOverlay() {
    var list = load();
    var akt = grupaZListy(list);
    if (!akt || akt.it.length < 2) return;
    overlay.hidden = false;
    document.body.classList.add('pg-compare-open');
    ustawNazweGrupy(akt, grupy(list).length);
    buildTable(handles(akt.it));
  }
  function closeOverlay() {
    if (overlay.hidden) return;
    overlay.hidden = true;
    document.body.classList.remove('pg-compare-open');
  }

  render();
  document.addEventListener('shopify:section:load', render);
  /* S1 (18.09, R70): karty dołożone przyciskiem „Pokaż kolejne” i siatka po filtrowaniu (collection-filters-form.js) –
     pola „Dodaj do porównania” przychodzą z serwera niezaznaczone, więc zaznaczamy je według listy porównania */
  document.addEventListener('pg:karty', render);
})();
;
/* ===== a11y-patches (v85) ===== */
/* Dwie luki z audytu axe-core: (1) uchwyty suwaka ceny (noUiSlider, role="slider") nie miały
   nazwy dostępnej - dostają aria-label z pól "od"/"do" tego samego filtra; (2) rozwijane listy
   stopki (blocks/_links-mobile-dropdown.liquid) z włączonym rozwijaniem na telefonie mają
   statyczne aria-hidden="true", a na desktopie są zawsze rozwinięte - tam aria-hidden schodzi
   na "false" (od v86 bloki bez rozwijania renderują od razu aria-hidden="false"). */
(function () {
  'use strict';
  function labelRangeHandles() {
    document.querySelectorAll('.rangeFilter--Wrapper').forEach(function (w) {
      var lo = w.querySelector('.noUi-handle-lower');
      var hi = w.querySelector('.noUi-handle-upper');
      var iMin = w.querySelector('input[data-custom-min]');
      var iMax = w.querySelector('input[data-custom-max]');
      if (lo && !lo.getAttribute('aria-label')) lo.setAttribute('aria-label', (iMin && iMin.getAttribute('aria-label')) || 'od');
      if (hi && !hi.getAttribute('aria-label')) hi.setAttribute('aria-label', (iMax && iMax.getAttribute('aria-label')) || 'do');
    });
  }
  function syncFooterDropdowns() {
    if (!window.matchMedia('(min-width: 1024px)').matches) return;
    document.querySelectorAll('footer .custom__dropdown-content[aria-hidden="true"]').forEach(function (c) {
      c.setAttribute('aria-hidden', 'false');
    });
  }
  /* (3) strzałka zwijania menu kategorii w nagłówku: skrypt motywu daje jej hidden i
     aria-hidden="true" u góry strony, choć jest widoczna (reguła display motywu bije [hidden])
     i działa jako przełącznik; po przewinięciu zmienia tylko aria-hidden. Zdejmujemy sprzeczne
     atrybuty i wystawiamy stan jako aria-expanded (z data-open motywu). */
  function fixMenuArrow() {
    var a = document.querySelector('.header-links__dropdown-arrow');
    if (!a || a.__pgA11y) return;
    a.__pgA11y = true;
    /* 22.09 (krok 18.9, WCAG 2.4.7): u góry strony strzałka bywa wygaszona do zera (opacity 0) i mimo to łapie Tab –
       klient traci naciśnięcie w miejscu, którego nie widzi. Regułą CSS tego nie załatwimy: atrybut `aria-hidden`
       zdejmujemy wyżej, a wygaszenie przychodzi z innego miejsca. Dlatego czytamy REALNE opacity i przy zerze
       zdejmujemy element z kolejności Tab; zmiana zawsze idzie przez przejście 0,2 s, więc łapie ją `transitionend`. */
    var pilnujFokusu = function () {
      var niewidoczna = parseFloat(getComputedStyle(a).opacity) === 0;
      if (niewidoczna) {
        if (a.getAttribute('tabindex') !== '-1') a.setAttribute('tabindex', '-1');
      } else if (a.getAttribute('tabindex') === '-1') {
        a.removeAttribute('tabindex');
      }
    };
    var apply = function () {
      if (a.hidden) a.hidden = false;
      if (a.hasAttribute('aria-hidden')) a.removeAttribute('aria-hidden');
      var open = a.getAttribute('data-open') === 'true' ? 'true' : 'false';
      if (a.getAttribute('aria-expanded') !== open) a.setAttribute('aria-expanded', open);
      pilnujFokusu();
    };
    apply();
    a.addEventListener('transitionend', function (e) { if (e.propertyName === 'opacity') pilnujFokusu(); });
    new MutationObserver(apply).observe(a, { attributes: true, attributeFilter: ['hidden', 'aria-hidden', 'data-open', 'class', 'style'] });
  }
  /* (4) v86: panel rekomendacji w szufladzie koszyka (.CartDrawer--Expendable) - skrypt motywu
     (global.min.js) ustawia mu aria-expanded, a to zwykły div (axe aria-allowed-attr). CSS szuflady
     czyta data-expanded; tu przepisujemy wartość i zdejmujemy atrybut ARIA przy każdej zmianie. */
  function mirrorCartPanel(el) {
    if (!el.hasAttribute('aria-expanded')) return;
    el.setAttribute('data-expanded', el.getAttribute('aria-expanded'));
    el.removeAttribute('aria-expanded');
  }
  function watchCartPanel() {
    document.querySelectorAll('.CartDrawer--Expendable').forEach(mirrorCartPanel);
    new MutationObserver(function (muts) {
      for (var i = 0; i < muts.length; i++) {
        var t = muts[i].target;
        if (t.nodeType === 1 && t.classList.contains('CartDrawer--Expendable')) mirrorCartPanel(t);
      }
    }).observe(document.documentElement, { attributes: true, subtree: true, attributeFilter: ['aria-expanded'] });
  }
  /* (6) 22.09 (krok 18.9, WCAG 2.4.7): kropki i strzałki banera siedzą w paskach `.media-slideshow_pagination`
     i `.media-slideshow_buttons`, które startują z `opacity: 0` i dostają pełną widoczność dopiero po uruchomieniu
     karuzeli. W tym czasie łapią Tab, choć ich nie widać (pomiar 22.09: 5 trafień w 40 naciśnięciach przy wolniejszym
     wczytywaniu). Widoczność ustawia skrypt motywu stylem na elemencie, więc `visibility` w CSS trwale by je ukryło –
     dlatego pilnujemy samego `tabindex`, tak jak przy strzałce menu. */
  function fixBannerControls() {
    var paski = document.querySelectorAll('.media-slideshow_pagination, .media-slideshow_buttons');
    for (var i = 0; i < paski.length; i++) {
      (function (pasek) {
        if (pasek.__pgA11y) return;
        pasek.__pgA11y = true;
        var pilnuj = function () {
          var niewidoczny = parseFloat(getComputedStyle(pasek).opacity) === 0;
          var dzieci = pasek.querySelectorAll('[tabindex], button, a');
          for (var j = 0; j < dzieci.length; j++) {
            if (niewidoczny) dzieci[j].setAttribute('tabindex', '-1');
            else if (dzieci[j].getAttribute('tabindex') === '-1') dzieci[j].setAttribute('tabindex', '0');
          }
        };
        pilnuj();
        pasek.addEventListener('transitionend', function (e) { if (e.propertyName === 'opacity') pilnuj(); });
        new MutationObserver(pilnuj).observe(pasek, { attributes: true, childList: true, attributeFilter: ['style', 'class'] });
      })(paski[i]);
    }
  }
  function run() {
    labelRangeHandles();
    syncFooterDropdowns();
    fixMenuArrow();
    fixBannerControls();
    if (!window.__pgCartPanelWatch) { window.__pgCartPanelWatch = true; watchCartPanel(); }
  }
  function schedule() {
    run();
    setTimeout(labelRangeHandles, 400);
    setTimeout(labelRangeHandles, 1500);
    setTimeout(labelRangeHandles, 4000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', schedule);
  else schedule();
  document.addEventListener('filters:rerendered', schedule);
  var t;
  window.addEventListener('resize', function () { clearTimeout(t); t = setTimeout(syncFooterDropdowns, 200); });
  /* v86: na stronie wyszukiwania suwak ceny (noUiSlider) potrafi powstać po 4 s od załadowania
     (wolne łącze) — wtedy same timery nie wystarczały (axe: aria-input-field-name). Obserwator
     łapie moment dodania uchwytów do DOM, niezależnie od tempa ładowania. */
  var queued = false;
  new MutationObserver(function (muts) {
    if (queued) return;
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if ((n.classList && n.classList.contains('noUi-handle')) || (n.querySelector && n.querySelector('.noUi-handle'))) {
          queued = true;
          window.requestAnimationFrame(function () { queued = false; labelRangeHandles(); });
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

;
/* ===== cookie-settings (14.09) ===== */
/* Przycisk „Ustawienia cookies” w stopce (blocks/_links-mobile-dropdown.liquid, atrybut data-pg-cookie-settings) otwiera
   panel CookieFirst – zmiana albo wycofanie zgody w każdej chwili (Polityka prywatności pkt 6, audyt polityk M5).
   Gdy skrypt CookieFirst się nie załadował (np. bloker), przycisk przenosi do punktu o cookies w Polityce prywatności. */
(function () {
  document.addEventListener('click', function (e) {
    var btn = e.target && e.target.closest ? e.target.closest('[data-pg-cookie-settings]') : null;
    if (!btn) return;
    e.preventDefault();
    var cf = window.CookieFirst;
    if (cf && typeof cf.openPanel === 'function') {
      try { cf.openPanel(); return; } catch (err) {}
    }
    var href = btn.getAttribute('data-fallback');
    if (href) window.location.href = href;
  });
})();

;
/* ===== okienka „i” (18.09, krok B2 planu 211) =====
   Jedna obsługa wszystkich podpowiedzi (`snippets/pg-okienko.liquid`) – na karcie produktu i na kartach w listach.
   Kryterium WCAG 1.4.13: okienko otwiera się po najechaniu, dotknięciu i z klawiatury, daje się zamknąć klawiszem
   Esc bez ruszania wskaźnika i jest NAJEZDNE (kursor może z przycisku wejść w treść – dlatego zamykamy z opóźnieniem
   i tylko wtedy, gdy wskaźnik opuścił całe okienko razem z przyciskiem). Otwarte może być jedno naraz. */
(function () {
  if (window.__pgOkienka) return;
  window.__pgOkienka = true;

  var otwarte = null;
  var licznik = null;
  var otwarteOd = 0;
  var otwartePrzez = '';
  /* S1 (makieta R52 `.v5-inline`): na telefonie okienko z panelu zakupu rozwija się W MIEJSCU – treść idzie jako pełne
     pole pod rząd chipów (albo pod akapit, np. warunki finansowania), rozsuwa to, co pod nią, i ma „Zamknij” 44 px.
     Przy zamknięciu treść wraca do swojego okienka, więc na komputerze i tablecie działa zwykła podpowiedź. */
  var telefon = window.matchMedia ? window.matchMedia('(max-width: 767px)') : { matches: false };

  function tresc(box) { return box.__pgTresc || box.querySelector('.pg-okienko__tresc'); }
  function przycisk(box) { return box.querySelector('.pg-okienko__przycisk'); }
  function wMiejscu(box) { return telefon.matches && !!box.closest('.pm__information-wrapper'); }
  function jestWMiejscu(box) { var t = box.__pgTresc; return !!(t && t.classList.contains('pg-okienko__tresc--miejsce')); }

  function przenies(box, t) {
    box.__pgTresc = t;
    t.__pgBox = box;
    var rzad = box.closest('.pg-badges-row');
    if (rzad) rzad.appendChild(t);
    else (box.closest('p, li') || box).insertAdjacentElement('afterend', t);
    t.classList.add('pg-okienko__tresc--miejsce');
    t.style.removeProperty('transform'); /* korekta położenia podpowiedzi z szerszego ekranu (przed obrotem) */
    t.style.removeProperty('--pg-ok-dx');
    t.removeAttribute('role'); /* rozwinięta treść z linkiem i przyciskiem to nie podpowiedź, tylko zwykły fragment strony */
  }
  function oddaj(box, t) {
    if (!t.classList.contains('pg-okienko__tresc--miejsce')) return;
    t.classList.remove('pg-okienko__tresc--miejsce');
    t.setAttribute('role', 'tooltip');
    box.appendChild(t);
  }

  function pokaz(box, przez) {
    if (otwarte && otwarte !== box) schowaj(otwarte);
    clearTimeout(licznik);
    var t = tresc(box); var b = przycisk(box);
    if (!t || !b) return;
    if (otwarte !== box) { otwarteOd = Date.now(); otwartePrzez = przez || ''; }
    if (wMiejscu(box)) {
      if (!t.classList.contains('pg-okienko__tresc--miejsce')) przenies(box, t);
      t.hidden = false;
      b.setAttribute('aria-expanded', 'true');
      box.classList.add('pg-okienko--otwarte');
      otwarte = box;
      return;
    }
    oddaj(box, t);
    t.hidden = false;
    b.setAttribute('aria-expanded', 'true');
    box.classList.add('pg-okienko--otwarte');
    otwarte = box;
    /* okienko przy krawędzi ekranu ma się zmieścić – korekta dokładana do przesunięcia z CSS (translateX(-50%)
       w wariancie środkowym; warianty --dol i --gora-prawo stoją przy krawędzi przycisku, bez -50%). Przesunięcie
       idzie też do zmiennej --pg-ok-dx, żeby strzałka dalej wskazywała przycisk. */
    t.style.removeProperty('transform');
    t.style.removeProperty('--pg-ok-dx');
    var srodek = !(box.classList.contains('pg-okienko--dol') || box.classList.contains('pg-okienko--gora-prawo'));
    var r = t.getBoundingClientRect();
    var margines = 8;
    var dx = 0;
    if (r.right > window.innerWidth - margines) dx = Math.round(window.innerWidth - margines - r.right);
    else if (r.left < margines) dx = Math.round(margines - r.left);
    if (dx !== 0) {
      t.style.transform = 'translateX(calc(' + (srodek ? '-50% + ' : '') + dx + 'px))';
      t.style.setProperty('--pg-ok-dx', dx + 'px');
    }
  }

  function schowaj(box) {
    var t = tresc(box); var b = przycisk(box);
    if (t) { t.hidden = true; oddaj(box, t); }
    if (b) b.setAttribute('aria-expanded', 'false');
    box.classList.remove('pg-okienko--otwarte');
    if (otwarte === box) otwarte = null;
  }

  /* okienko elementu – także dla treści przeniesionej pod rząd chipów (wskazuje ją `__pgBox`) */
  function box(el) {
    if (!el || !el.closest) return null;
    var t = el.closest('.pg-okienko__tresc');
    if (t && t.__pgBox) return t.__pgBox;
    return el.closest('[data-pg-okienko]');
  }

  /* po zamknięciu ostrość wraca na przycisk „i” – bez ponownego otwarcia przez zdarzenie focusin */
  var cisza = false;
  function zamknijIWroc(p) {
    var bp = przycisk(p);
    schowaj(p);
    if (bp) { cisza = true; bp.focus(); cisza = false; }
  }

  document.addEventListener('click', function (e) {
    var z = e.target.closest ? e.target.closest('[data-pg-okienko-zamknij]') : null;
    if (z) {
      e.preventDefault();
      var pz = box(z);
      if (pz) zamknijIWroc(pz);
      return;
    }
    var b = e.target.closest ? e.target.closest('.pg-okienko__przycisk') : null;
    if (b) {
      e.preventDefault();
      e.stopPropagation();
      var p = box(b);
      if (p === otwarte) {
        /* dotknięcie wysyła najpierw „najechanie” i ostrość (okienko już się otwiera), a dopiero potem kliknięcie –
           to samo dotknięcie nie może go od razu zamknąć */
        if (otwartePrzez !== 'click' && Date.now() - otwarteOd < 700) { otwartePrzez = 'click'; return; }
        schowaj(p);
      } else pokaz(p, 'click');
      return;
    }
    /* kliknięcie w treść okienka (np. w link) nie zamyka go; kliknięcie gdzie indziej – tak (poza okienkiem rozwiniętym
       w miejscu na telefonie: to fragment strony, zamyka go „Zamknij”, przycisk „i” albo Esc) */
    if (otwarte && !box(e.target) && !jestWMiejscu(otwarte)) schowaj(otwarte);
  }, true);

  document.addEventListener('mouseover', function (e) {
    var p = box(e.target);
    if (p) { clearTimeout(licznik); pokaz(p, 'hover'); }
  });
  document.addEventListener('mouseout', function (e) {
    var p = box(e.target);
    if (!p || p !== otwarte || jestWMiejscu(p)) return;
    /* 1.4.13: dajemy czas na przejście kursorem z przycisku w treść okienka */
    clearTimeout(licznik);
    licznik = setTimeout(function () {
      if (otwarte === p && !p.matches(':hover')) schowaj(p);
    }, 260);
  });

  document.addEventListener('focusin', function (e) {
    if (cisza) return;
    var p = box(e.target);
    if (p) pokaz(p, 'focus');
    else if (otwarte && !jestWMiejscu(otwarte)) schowaj(otwarte);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape' && e.key !== 'Esc') return;
    if (!otwarte) return;
    zamknijIWroc(otwarte);
  });

  /* obrót telefonu albo zmiana szerokości okna: otwarte okienko zamykamy, żeby treść wróciła na swoje miejsce */
  if (telefon.addEventListener) telefon.addEventListener('change', function () { if (otwarte) schowaj(otwarte); });
})();

;
/* ===== cart-lead: termin realizacji przy pozycji koszyka (18.09, krok B1 planu 211; od 28.10 bez stanu magazynu w stronie) =====
   Komunikat przy pozycji rysuje Liquid (snippets/pg-ilosc-uwaga.liquid w cart_items.liquid) – po każdej zmianie
   ilości motyw przerysowuje koszyk, więc widoczność jest zawsze aktualna. Tutaj pilnujemy ukrytej właściwości
   `_Termin realizacji`, która idzie do zamówienia i do potwierdzenia e-mailem: musi mówić to samo co komunikat
   (recenzja 8, warunek krytyczny).
   28.10 liczba sztuk na stanie nie trafia już do strony, więc skrypt nie liczy terminu sam. Termin dla
   bieżącej ilości pozycji wystawia Liquid w atrybucie `data-pg-line-termin` (zna ilość i stan na serwerze), a skrypt
   tylko porównuje go z właściwością pozycji z `/cart.js` i poprawia różnice jednym `/cart/change.js` na pozycję:
     1. po każdym przerysowaniu szuflady: motyw pobiera `?section_id=main-cart_drawer` (zmiana ilości) albo dostaje HTML szuflady
        w odpowiedzi `/cart/add.js` i `/cart/change.js` z polem sections (dodanie z karty, konfigurator); zanim motyw dostanie
        odpowiedź, poprawiamy właściwości i pobieramy szufladę jeszcze raz, więc motyw rysuje już nowe klucze pozycji
        (zmiana właściwości zmienia klucz pozycji – pułapka 57),
     2. przy wejściu na stronę z koszykiem (także po zwykłym wysłaniu formularza `/cart/update`) – z kodu strony,
     3. przed przejściem do kasy z „Kup teraz” (assets/pg-kup-teraz.js woła window.__pgCartLeadSprawdz).
   `/cart/change.js` z `properties` zastępuje WSZYSTKIE właściwości pozycji, więc przepisujemy je w całości. Własne odczyty koszyka
   i szuflady idą z cache: 'no-store': drugi odczyt tego samego adresu z pamięci przeglądarki dawał stare klucze (próba 28.10). */
(function () {
  if (window.__pgCartLead) return;
  window.__pgCartLead = true;

  var WLASCIWOSC = '_Termin realizacji';
  var SEKCJA = /[?&]section_id=main-cart_drawer(&|$)/;
  var ZMIANA = /\/cart\/(add|change)(\.js)?($|\?)/;
  var BEZ_PAMIECI = { credentials: 'same-origin', cache: 'no-store' };
  var pierwotnyFetch = window.fetch.bind(window);

  function korzen() { return (window.routes && window.routes.localeRootUrl) || ''; }

  function kopia(o) {
    var w = {};
    if (o) for (var p in o) if (Object.prototype.hasOwnProperty.call(o, p)) w[p] = o[p];
    return w;
  }

  function koszyk() {
    return pierwotnyFetch('/cart.js', BEZ_PAMIECI).then(function (r) { return r.json(); });
  }

  /* klucz pozycji → termin dla jej bieżącej ilości, z komunikatów pozycji w kodzie strony albo w HTML szuflady */
  function terminy(korzenDom) {
    var w = {};
    var lista = korzenDom.querySelectorAll('[data-pg-line-note][data-pg-line-termin]');
    for (var i = 0; i < lista.length; i++) {
      var k = lista[i].getAttribute('data-pg-line-key');
      var t = lista[i].getAttribute('data-pg-line-termin');
      if (k && t) w[k] = t;
    }
    return w;
  }

  /* poprawia właściwość pozycji, które jej potrzebują; wynik: lista { stary, nowy } kluczy pozycji */
  function popraw(t) {
    if (!Object.keys(t).length) return Promise.resolve([]);
    return koszyk().then(function (k) {
      var zmiany = (k.items || []).filter(function (poz) {
        return t[poz.key] && ((poz.properties || {})[WLASCIWOSC] || '') !== t[poz.key];
      });
      var wynik = [];
      return zmiany.reduce(function (lancuch, poz) {
        return lancuch.then(function () {
          var termin = t[poz.key];
          var wl = kopia(poz.properties);
          wl[WLASCIWOSC] = termin;
          return pierwotnyFetch('/cart/change.js', {
            method: 'POST', credentials: 'same-origin',
            headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: JSON.stringify({ id: poz.key, quantity: poz.quantity, properties: wl }),
          }).then(function (r) { return r.json(); }).then(function (nowyKoszyk) {
            var nowa = (nowyKoszyk.items || []).filter(function (p) {
              return p.variant_id === poz.variant_id && p.quantity === poz.quantity
                && ((p.properties || {})[WLASCIWOSC] || '') === termin;
            })[0];
            if (nowa && nowa.key !== poz.key) wynik.push({ stary: poz.key, nowy: nowa.key });
          });
        });
      }, Promise.resolve()).then(function () { return wynik; });
    });
  }

  function zHtml(html) {
    return terminy(new DOMParser().parseFromString(html, 'text/html'));
  }

  function szuflada() {
    return pierwotnyFetch(korzen() + '/?section_id=main-cart_drawer', BEZ_PAMIECI).then(function (r) { return r.ok ? r.text() : ''; });
  }

  /* --- 1. przerysowanie szuflady przez motyw ------------------------------------------------------------- */
  window.fetch = function (zasob, opcje) {
    var url = '';
    try { url = typeof zasob === 'string' ? zasob : (zasob && zasob.url) || ''; } catch (e) { url = ''; }
    var metoda = (opcje && opcje.method) || (zasob && zasob.method) || 'GET';
    metoda = String(metoda).toUpperCase();
    if (SEKCJA.test(url) && metoda === 'GET') {
      return pierwotnyFetch(zasob, opcje).then(function (odp) {
        if (!odp.ok) return odp;
        return odp.clone().text().then(function (html) {
          if (html.indexOf('data-pg-line-termin') < 0) return odp;
          return popraw(zHtml(html)).then(function (zmiany) {
            return zmiany.length ? pierwotnyFetch(zasob, Object.assign({}, opcje || {}, { cache: 'no-store' })) : odp;
          });
        }).catch(function () { return odp; });
      });
    }
    if (ZMIANA.test(url) && metoda === 'POST' && opcje && typeof opcje.body === 'string' && opcje.body.indexOf('main-cart_drawer') >= 0) {
      /* odpowiedź z HTML szuflady (sections): po poprawce podmieniamy w niej szufladę na świeżą, z nowymi kluczami */
      return pierwotnyFetch(zasob, opcje).then(function (odp) {
        if (!odp.ok) return odp;
        return odp.clone().json().then(function (j) {
          var html = j && j.sections && j.sections['main-cart_drawer'];
          if (typeof html !== 'string' || html.indexOf('data-pg-line-termin') < 0) return odp;
          return popraw(zHtml(html)).then(function (zmiany) {
            if (!zmiany.length) return odp;
            return szuflada().then(function (nowy) {
              if (!nowy) return odp;
              j.sections['main-cart_drawer'] = nowy;
              return new Response(JSON.stringify(j), { status: odp.status, statusText: odp.statusText, headers: odp.headers });
            });
          });
        }).catch(function () { return odp; });
      });
    }
    return pierwotnyFetch(zasob, opcje);
  };

  /* --- 3. „Kup teraz”: po dodaniu do koszyka, przed kasą ------------------------------------------------- */
  window.__pgCartLeadSprawdz = function () {
    return szuflada()
      .then(function (html) { return html.indexOf('data-pg-line-termin') < 0 ? [] : popraw(zHtml(html)); })
      .catch(function () { return []; });
  };

  /* --- 2. wejście na stronę: po poprawce przepisujemy w stronie nowy klucz pozycji, żeby przyciski „+/−”
     i „usuń” dalej działały. */
  function poprawPoWejsciu() {
    if (!document.querySelector('[data-pg-line-note][data-pg-line-termin]')) return;
    popraw(terminy(document)).then(function (zmiany) {
      zmiany.forEach(function (z) {
        var stary = z.stary;
        var nowy = z.nowy;
        var noty = document.querySelectorAll('[data-pg-line-note]');
        for (var j = 0; j < noty.length; j++) {
          if (noty[j].getAttribute('data-pg-line-key') === stary) noty[j].setAttribute('data-pg-line-key', nowy);
        }
        var elementy = document.querySelectorAll('[data-line-id="' + stary + '"]');
        for (var i = 0; i < elementy.length; i++) {
          elementy[i].setAttribute('data-line-id', nowy);
          var href = elementy[i].getAttribute('href');
          /* 19.09 (reaudyt H-10): klucz pozycji ma dwukropek („53614842249601:3e09…”), a Liquid wypisuje go
             w adresie BEZ kodowania. Samo `encodeURIComponent` (dwukropek → %3A) nie trafiało więc w adres
             i przyciski „+”/„−”/„usuń” zostawały ze starym, nieistniejącym kluczem – klik nic nie zmieniał.
             Podmieniamy obie postacie i zostawiamy tę, w której adres był zapisany. */
          if (href) {
            elementy[i].setAttribute('href', href
              .split('id=' + stary).join('id=' + nowy)
              .split('id=' + encodeURIComponent(stary)).join('id=' + encodeURIComponent(nowy)));
          }
        }
      });
    }).catch(function () { /* brak sieci – poprawi to następne przerysowanie szuflady albo wejście na stronę */ });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', poprawPoWejsciu);
  else poprawPoWejsciu();
})();
;
/* ===== mega menu: klawiatura i Esc (18.09, krok C1 planu 211; makieta sekcja 1, b) ===== */
/*
 * Motyw otwiera panel kategorii tylko najechaniem myszą (75 ms na otwarcie, 150 ms na zamknięcie –
 * dokładnie tak, jak chce makieta). Brakowało obsługi klawiatury: tu dokładamy otwieranie panelu,
 * gdy kafelek kategorii dostanie fokus (Tab), zamykanie klawiszem Esc z powrotem fokusu na kafelek
 * i zamykanie, gdy fokus wyjdzie poza pasek i panel. Nie ruszamy skryptu motywu – wywołujemy jego
 * własną obsługę, wysyłając zdarzenie najechania.
 */
(function () {
  'use strict';
  var WYZWALACZ = '[data-action="open-third-menu"]';
  function zdarzenie(el, typ) {
    var r = el.getBoundingClientRect();
    var opcje = { bubbles: true, clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 };
    var ev;
    try { ev = new PointerEvent(typ, Object.assign({ pointerType: 'mouse' }, opcje)); }
    catch (e) { ev = new MouseEvent(typ, opcje); }
    el.dispatchEvent(ev);
  }
  function otworz(el) { ['pointerover', 'pointerenter', 'mouseover', 'mouseenter'].forEach(function (t) { zdarzenie(el, t); }); }
  function zamknij() {
    document.querySelectorAll('.dm__third-dropdown[aria-hidden="false"]').forEach(function (p) {
      p.setAttribute('aria-hidden', 'true');
      p.style.display = 'none';
    });
    document.querySelectorAll(WYZWALACZ + '[aria-expanded="true"]').forEach(function (t) {
      t.setAttribute('aria-expanded', 'false');
    });
  }
  document.addEventListener('focusin', function (e) {
    if (!e.target || !e.target.closest) return;
    var kafelek = e.target.closest(WYZWALACZ);
    if (kafelek) { otworz(kafelek); return; }
    if (!e.target.closest('.dm__third-dropdown')) zamknij();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var otwarty = document.querySelector('.dm__third-dropdown[aria-hidden="false"]');
    if (!otwarty) return;
    var uchwyt = otwarty.getAttribute('data-handle-content');
    zamknij();
    var wroc = uchwyt && document.querySelector(WYZWALACZ + '[data-handle="' + uchwyt + '"]');
    if (wroc) wroc.focus();
  });
})();

;
/* ===== wybor-dostawy (18.09, krok C3 planu 211) ===== */
/*
 * Wybór sposobu dostawy w koszyku gdy pozycje mają różne
 * terminy realizacji, klient wybiera „wysyłka partiami” albo „jedna dostawa”. Wybór zapisujemy jako
 * właściwość koszyka „Sposób dostawy”, więc trafia do zamówienia (panel, wydruk, potwierdzenie).
 * Blok pokazuje się tylko przy włączonym ustawieniu motywu – snippet `pg-wybor-dostawy.liquid`.
 */
(function () {
  'use strict';
  function zapisz(box, wartosc) {
    var body = { attributes: {} };
    body.attributes['Sposób dostawy'] = wartosc;
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(body),
    }).catch(function () {});
  }
  document.addEventListener('change', function (e) {
    var input = e.target;
    if (!input || input.name !== 'pg-wybor-dostawy') return;
    var box = input.closest('[data-pg-wybor-dostawy]');
    if (!box) return;
    var opisy = box.querySelector('[data-pg-wybor-partiami]');
    if (!opisy) return;
    var wartosc = input.value === 'razem'
      ? opisy.getAttribute('data-pg-wybor-razem')
      : opisy.getAttribute('data-pg-wybor-partiami');
    zapisz(box, wartosc);
  });
})();

/* ===== pasujace-do: miejsce grupy „Pasujące do” w szufladzie (18.09, krok C3 część 3 planu 211) ===== */
/*
 * Grupa jest rysowana przez Liquid TYLKO RAZ – w środku szuflady (`.pg-pdo-slot`). Powód sprawdzony na żywo
 * 18.09: po dodaniu produktu bez przeładowania motyw podmienia wyłącznie `.cart-drawer__wrapper`, więc kopia
 * stojąca w panelu obok szuflady (`.CartDrawer--Expendable`) zostawała stara albo nie było jej wcale.
 * Rysowanie w dwóch miejscach naraz kosztowałoby też ok. 44 KB HTML na każdej stronie z niepustym koszykiem.
 * Dlatego: od 1024 px przenosimy gotowy węzeł do panelu obok szuflady (miejsce z makiety 6.4), a niżej
 * zostaje w szufladzie jako poziomy pasek (ramka telefonu z makiety). Po każdej podmianie szuflady bierzemy
 * świeży węzeł ze slotu, a starą kopię z panelu usuwamy – znacznik `data-pg-oddane` mówi, że ten slot już
 * swój węzeł oddał (świeży slot znacznika nie ma, więc pusty slot = „koszyk nie ma już grupy”).
 */
(function () {
  'use strict';
  var KOMPUTER = '(min-width: 1024px)';
  function ustaw() {
    var panel = document.querySelector('.CartDrawer--Expendable');
    if (!panel) return;
    var slot = document.querySelector('.pg-pdo-slot');
    var wSlocie = slot ? slot.querySelector('.pg-pdo') : null;
    var wPanelu = panel.querySelector('.pg-pdo');
    if (!window.matchMedia(KOMPUTER).matches) {
      if (wPanelu && slot) {
        slot.insertBefore(wPanelu, slot.firstChild);
        slot.removeAttribute('data-pg-oddane');
      }
      return;
    }
    if (wSlocie) {
      if (wPanelu && wPanelu !== wSlocie) wPanelu.parentNode.removeChild(wPanelu);
      panel.insertBefore(wSlocie, panel.firstChild);
      slot.setAttribute('data-pg-oddane', '1');
    } else if (wPanelu && slot && slot.getAttribute('data-pg-oddane') !== '1') {
      wPanelu.parentNode.removeChild(wPanelu);
    }
  }
  var czeka = false;
  function zaplanuj() {
    if (czeka) return;
    czeka = true;
    requestAnimationFrame(function () { czeka = false; ustaw(); });
  }
  function start() {
    var cel = document.querySelector('cart-drawer') || document.body;
    try { new MutationObserver(zaplanuj).observe(cel, { childList: true, subtree: true }); } catch (e) {}
    window.addEventListener('resize', zaplanuj);
    zaplanuj();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();

;
/* ===== menu-panel (S1, 18.09; makieta R7/R8) =====
   Panel podkategorii (`.dm__third-dropdown`, pozycja fixed) ma się zaczynać na dolnej linii pasa kategorii. Motyw liczy
   jego położenie stałym wzorem z wysokości nagłówka i pasa, który rozjechał się po usunięciu paska przewijania pod
   kafelkami (panel zasłaniał podpisy). Przy każdym otwarciu wpisujemy prawdziwą dolną krawędź widocznego pasa. */
(function () {
  var panele = document.querySelectorAll('.dm__third-dropdown');
  if (!panele.length || !('MutationObserver' in window)) return;
  function pasek() {
    var lista = document.querySelectorAll('desktop-menu-carousel');
    for (var i = 0; i < lista.length; i++) {
      var b = lista[i].getBoundingClientRect();
      if (b.height > 0 && getComputedStyle(lista[i]).visibility !== 'hidden') return b;
    }
    return null;
  }
  /* 23.09 (B150 c): klasa na body zamiast `body:has(.dm__third-dropdown[aria-hidden="false"])` – pasek porównania i przycisk opinii chowane przy otwartym podmenu */
  function klasaPodmenu() {
    var otwarte = false;
    for (var i = 0; i < panele.length; i++) if (panele[i].getAttribute('aria-hidden') === 'false') { otwarte = true; break; }
    document.body.classList.toggle('pg-podmenu-otwarte', otwarte);
  }
  var mo = new MutationObserver(function (zmiany) {
    var bylo = document.body.classList.contains('pg-podmenu-otwarte'); // stan sprzed tych zmian (klasę ustawia poprzednie wywołanie)
    klasaPodmenu();
    zmiany.forEach(function (m) {
      var p = m.target;
      if (p.getAttribute('aria-hidden') !== 'false') return;
      /* 03.10 (1035, przegląd agenta nr 1): przełączenie z innego panelu – bez wygaszania od zera (tło zostaje ciemne jak na .dk); pierwsze otwarcie – łagodnie */
      p.style.animation = bylo ? 'none' : '';
      var b = pasek();
      if (!b) return;
      var gora = Math.round(b.bottom - 1) + 'px';
      p.style.setProperty('top', gora, 'important');
      p.style.setProperty('--pg-panel-top', gora); /* 03.10 (1035): wysokość panelu – do 96 px nad dołem okna (third-lvl_desktop-menu.css) */
    });
  });
  panele.forEach(function (p) { mo.observe(p, { attributes: true, attributeFilter: ['aria-hidden'] }); });
  klasaPodmenu();
})();

;
/* ===== menu-uklad =====
   Komputer – panel `.dm__third-dropdown` (grupy w blokach `.dm__blok` / `.dm__karty`, snippets/menu-desktop-3rd-tresc.liquid):
   (1) równe rzędy w każdej grupie: liczba kolumn k z szerokości siatki i najmniejszej szerokości karty (`--pg-mk-szer`), szerokość kolumny `--pg-tor`
       (te same kolumny co dotąd); grupa z n kartami dostaje `--pg-kol` = ceil(n / ceil(n / k)) – rząd z jedną kartą nie powstaje przy żadnej szerokości
       ani przy żadnym menu (9 kart przy 8 w rzędzie = 5 + 4);
   (2) znak przewijania: `pg-jest-nizej`, gdy pod widokiem jest treść (pas z cieniem i przyciskiem, napis = nazwy grup poniżej), `pg-przewiniety`
       po przewinięciu (cień pod nagłówkiem panelu); przycisk przewija panel o 80 % wysokości.
   Telefon – `#menu` (grupy w akordeonie, snippets/menu-level.liquid): `pg-jest-nizej` na przewijanej liście poziomu 2 i 3 → biały cień na dole.
   Przeliczenie: otwarcie panelu (aria-hidden), wstawienie treści (doczytanie menu), zmiana szerokości okna, przewinięcie (scroll w fazie
   przechwytywania), rozwinięcie grupy akordeonu (toggle). Bez skryptu: siatka jak dotąd, pas niewidoczny. */
(function () {
  if (window.pgMenuUklad) return;
  function nb(s) { return (s || '').replace(/\s+/g, ' ').trim(); }
  function znak(P) {
    var dol = P.scrollTop + P.clientHeight < P.scrollHeight - 4;
    P.classList.toggle('pg-przewiniety', P.scrollTop > 2);
    P.classList.toggle('pg-jest-nizej', dol);
    var b = P.querySelector('.dm__wiecej');
    if (!b || !dol) return;
    var granica = P.getBoundingClientRect().bottom - 48; // nagłówek grupy pod tą linią (także pod białym cieniem pasa) = grupa „niżej”
    var nazwy = [];
    P.querySelectorAll('.dm__grupa').forEach(function (h) { if (h.getBoundingClientRect().top > granica) nazwy.push(nb(h.textContent)); });
    var t = b.getAttribute('data-wiecej') || '';
    if (nazwy.length) t = b.getAttribute('data-nizej') + ' ' + nazwy.slice(0, 2).join(', ') + (nazwy.length > 2 ? ' ' + b.getAttribute('data-i') + ' ' + (nazwy.length - 2) : '');
    if (b.textContent !== t) b.textContent = t;
  }
  function uloz(P) {
    var L = P.querySelector('.links-container');
    var g0 = L && L.querySelector('.dm__karty');
    if (g0 && L.clientWidth > 0) {
      var W = L.clientWidth;
      var gap = parseFloat(getComputedStyle(g0).columnGap) || 12;
      var min = parseFloat(getComputedStyle(P).getPropertyValue('--pg-mk-szer')) || 156;
      var k = Math.max(1, Math.floor((W + gap) / (min + gap)));
      var tor = ((W - (k - 1) * gap) / k).toFixed(2) + 'px';
      if (L.style.getPropertyValue('--pg-tor') !== tor) L.style.setProperty('--pg-tor', tor);
      L.querySelectorAll('.dm__karty').forEach(function (g) {
        var n = g.children.length;
        var kol = String(n ? Math.ceil(n / Math.ceil(n / k)) : 1);
        if (g.style.getPropertyValue('--pg-kol') !== kol) g.style.setProperty('--pg-kol', kol);
      });
      L.classList.add('pg-uklad');
    }
    znak(P);
  }
  function otwarte() { return Array.prototype.slice.call(document.querySelectorAll('.dm__third-dropdown[aria-hidden="false"]')); }
  var mo = 'MutationObserver' in window ? new MutationObserver(function (zmiany) {
    var lista = [];
    zmiany.forEach(function (m) {
      var el = m.target.nodeType === 1 ? m.target : m.target.parentElement;
      var P = el && el.closest ? el.closest('.dm__third-dropdown') : null;
      if (P && P.getAttribute('aria-hidden') === 'false' && lista.indexOf(P) < 0) lista.push(P);
    });
    lista.forEach(uloz);
  }) : null;
  function obserwuj() {
    if (!mo) return;
    document.querySelectorAll('.dm__third-dropdown').forEach(function (P) {
      if (P.__pgUklad) return;
      P.__pgUklad = true;
      mo.observe(P, { attributes: true, attributeFilter: ['aria-hidden'], childList: true, subtree: true });
    });
  }
  obserwuj();
  document.addEventListener('DOMContentLoaded', obserwuj);
  document.addEventListener('pg:menu-gotowe', function () { obserwuj(); otwarte().forEach(uloz); });

  function znakT(L) { L.classList.toggle('pg-jest-nizej', L.clientHeight > 0 && L.scrollTop + L.clientHeight < L.scrollHeight - 4); }
  function listyT() { document.querySelectorAll('#menu .menu__second-level, #menu .menu__third-level').forEach(znakT); }
  var klatki = {};
  function wKlatce(klucz, f) { if (klatki[klucz]) return; klatki[klucz] = requestAnimationFrame(function () { klatki[klucz] = 0; f(); }); }
  document.addEventListener('scroll', function (e) {
    var t = e.target;
    if (!t || !t.classList) return;
    if (t.classList.contains('dm__third-dropdown')) wKlatce('panel', function () { znak(t); });
    else if (t.classList.contains('menu__third-level') || t.classList.contains('menu__second-level')) wKlatce('lista', function () { znakT(t); });
  }, { capture: true, passive: true });
  window.addEventListener('resize', function () { wKlatce('okno', function () { otwarte().forEach(uloz); listyT(); }); });
  document.addEventListener('toggle', function (e) {
    var d = e.target;
    if (d && d.matches && d.matches('details.pg-mm-akordeon')) { var L = d.closest('.menu__third-level'); if (L) znakT(L); }
  }, true);
  /* menu telefonu: szuflady wjeżdżają przejściem – stan cienia po jego końcu */
  ['click', 'keyup'].forEach(function (typ) {
    document.addEventListener(typ, function (e) {
      if (e.target && e.target.closest && e.target.closest('#menu, [data-toggle-id="menu"]')) setTimeout(listyT, 450);
    }, true);
  });
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.dm__wiecej') : null;
    var P = b && b.closest('.dm__third-dropdown');
    if (!P) return;
    e.preventDefault();
    P.scrollBy({ top: Math.round(P.clientHeight * 0.8), behavior: 'smooth' });
  });
  window.pgMenuUklad = uloz;
})();

;
/* ===== energia-karty (S1, 18.09; makieta R54 `.v7-ee--sm`, R55/R56) =====
   Strzałki klasy energetycznej na kartach w listach (snippets/pg-energia-karta.liquid). Miejsce i strzałkę zastępczą
   (klasa i kolor z `prime.eprel_json`) rysuje Liquid; tutaj podmieniamy ją na obrazek z aplikacji etykiet – ten sam, co na
   karcie produktu – JEDNYM zapytaniem na wszystkie strzałki, które weszły na ekran (IntersectionObserver, zapas 400 px).
   Karty dołożone później (karuzele z doładowaniem, „Pokaż kolejne”) łapie MutationObserver. Kliknięcie strzałki otwiera
   okno z etykietą (`/apps/energy-label/api/products/<numer>/labels`) i linkiem do karty informacyjnej produktu. */
(function () {
  if (window.__pgEeKarty) return;
  window.__pgEeKarty = true;
  var obrazki = {};
  var kolejka = [];
  var licznik = null;
  var widoczne = 'IntersectionObserver' in window ? new IntersectionObserver(function (wpisy) {
    wpisy.forEach(function (w) {
      if (!w.isIntersecting) return;
      widoczne.unobserve(w.target);
      dodaj(w.target);
    });
  }, { rootMargin: '400px 0px' }) : null;

  function wstaw(slot) {
    var nr = slot.getAttribute('data-pg-ee');
    var src = obrazki[nr];
    var box = slot.querySelector('.pg-ee-karta__img');
    if (!src || !box || slot.hasAttribute('data-pg-ee-ok')) return;
    var img = new Image();
    img.alt = '';
    img.decoding = 'async';
    /* 12.10.2026 (CENTRUM S-19, paczka P13, 46.19): strzałkę zastępczą CHOWAMY zamiast kasować (dawniej box.textContent = ''). Gdy obrazek doszedł między
       wciśnięciem a puszczeniem przycisku myszy, element pod kursorem znikał z drzewa i przeglądarka gubiła kliknięcie (H19 30.09, H40 09.10).
       Styl w linii, bo CSS daje .pg-ee-karta__zast display: flex (atrybut hidden by nie zadziałał). */
    img.onload = function () {
      Array.prototype.forEach.call(box.children, function (c) { c.style.display = 'none'; });
      box.appendChild(img);
      slot.setAttribute('data-pg-ee-ok', '');
    };
    img.src = src;
  }
  function dodaj(slot) {
    var nr = slot.getAttribute('data-pg-ee');
    if (!nr) return;
    if (obrazki[nr]) { wstaw(slot); return; }
    kolejka.push(slot);
    clearTimeout(licznik);
    licznik = setTimeout(pobierz, 150);
  }
  function pobierz() {
    var sloty = kolejka.splice(0);
    var nry = [];
    sloty.forEach(function (s) { var n = s.getAttribute('data-pg-ee'); if (!obrazki[n] && nry.indexOf(n) < 0) nry.push(n); });
    if (!nry.length) { sloty.forEach(wstaw); return; }
    fetch('/apps/energy-label/api/products/badges', { method: 'POST', body: JSON.stringify({ typeData: 'eprelNumbers', data: nry }) })
      .then(function (r) { return r.ok ? r.json() : []; })
      .then(function (lista) {
        (Array.isArray(lista) ? lista : []).forEach(function (el) {
          if (el && el.eprel_number && el.badge && typeof el.badge.base64 === 'string' && el.badge.base64.indexOf('data:image/') === 0) obrazki[String(el.eprel_number)] = el.badge.base64;
        });
      })
      .catch(function () { /* aplikacja nie odpowiedziała – zostaje strzałka zastępcza z klasą */ })
      .then(function () { sloty.forEach(wstaw); });
  }
  function zarejestruj(root) {
    (root.querySelectorAll ? root.querySelectorAll('[data-pg-ee]:not([data-pg-ee-reg])') : []).forEach(function (s) {
      s.setAttribute('data-pg-ee-reg', '');
      if (widoczne) widoczne.observe(s); else dodaj(s);
    });
  }
  zarejestruj(document);
  if ('MutationObserver' in window) {
    var czekaj = null;
    new MutationObserver(function () {
      clearTimeout(czekaj);
      czekaj = setTimeout(function () { zarejestruj(document); }, 200);
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* okno z etykietą – jedno na stronę, natywny <dialog> (Esc i ostrość w oknie robi przeglądarka) */
  var okno = null;
  function otworz(slot) {
    var nr = slot.getAttribute('data-pg-ee');
    if (!okno) {
      okno = document.createElement('dialog');
      okno.className = 'pg-ee-okno';
      okno.innerHTML = '<div class="pg-ee-okno__bar"><b class="pg-ee-okno__t"></b><button type="button" class="pg-ee-okno__x"></button></div>' +
        '<div class="pg-ee-okno__img"></div><a class="pg-ee-okno__a" target="_blank" rel="noopener"></a>';
      okno.querySelector('.pg-ee-okno__x').addEventListener('click', function () { okno.close(); });
      okno.addEventListener('click', function (e) { if (e.target === okno) okno.close(); });
      document.body.appendChild(okno);
    }
    okno.querySelector('.pg-ee-okno__t').textContent = slot.getAttribute('data-t-tytul') || '';
    okno.querySelector('.pg-ee-okno__x').textContent = slot.getAttribute('data-t-zamknij') || '×';
    var a = okno.querySelector('.pg-ee-okno__a');
    a.textContent = slot.getAttribute('data-t-karta') || '';
    a.href = '/apps/energy-label/api/products/' + encodeURIComponent(nr) + '/sheets';
    var box = okno.querySelector('.pg-ee-okno__img');
    box.textContent = '';
    box.setAttribute('aria-busy', 'true');
    if (typeof okno.showModal === 'function') okno.showModal(); else okno.setAttribute('open', '');
    fetch('/apps/energy-label/api/products/' + encodeURIComponent(nr) + '/labels')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (d) {
        box.removeAttribute('aria-busy');
        if (d && typeof d.base64 === 'string' && d.base64.indexOf('data:image/') === 0) {
          var img = new Image();
          img.alt = slot.getAttribute('aria-label') || '';
          img.src = d.base64;
          box.appendChild(img);
        } else {
          box.textContent = slot.getAttribute('data-t-blad') || '';
        }
      })
      .catch(function () { box.removeAttribute('aria-busy'); box.textContent = slot.getAttribute('data-t-blad') || ''; });
  }
  document.addEventListener('click', function (e) {
    var slot = e.target && e.target.closest ? e.target.closest('[data-pg-ee]') : null;
    if (!slot) return;
    e.preventDefault();
    e.stopPropagation();
    otworz(slot);
  }, true);
})();

;
/* ===== karty-w-koszyku (S1, 18.09; makieta R54 `.v7-cart b`) =====
   Znacznik przy koszyku karty (ile sztuk tego produktu jest w koszyku) liczy Liquid przy wyświetlaniu strony.
   Po dodaniu do koszyka albo zmianie w szufladzie motyw wysyła „product:added” / „cart:render” – wtedy jedno
   zapytanie o koszyk i odświeżenie wszystkich znaczników na stronie. */
(function () {
  if (window.__pgKartyKoszyk) return;
  window.__pgKartyKoszyk = true;
  var licznik = null;
  function odswiez() {
    if (!document.querySelector('[data-pg-w-koszyku]')) return;
    fetch((window.Shopify && window.Shopify.routes && window.Shopify.routes.root ? window.Shopify.routes.root : '/') + 'cart.js', { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (c) {
        var ile = {};
        (c.items || []).forEach(function (it) { ile[it.product_id] = (ile[it.product_id] || 0) + it.quantity; });
        document.querySelectorAll('[data-pg-w-koszyku]').forEach(function (b) {
          var f = b.closest('form[data-productid]');
          if (!f) return;
          var n = ile[f.getAttribute('data-productid')] || 0;
          b.textContent = n > 99 ? '99+' : String(n);
          b.hidden = n === 0;
        });
      })
      .catch(function () {});
  }
  function pozniej() { clearTimeout(licznik); licznik = setTimeout(odswiez, 250); }
  document.addEventListener('product:added', pozniej);
  document.addEventListener('cart:render', pozniej);
})();

;
/* ===== wsparcie (S1, 18.09; makieta R65/R64 – strona wsparcia produktu `sections/pg-wsparcie.liquid`) =====
   Trzy przyciski strony, jedno nasłuchiwanie na dokumencie (ta sama sekcja bywa wstawiana skryptem na /pages/wsparcie):
   „Pokaż wszystkie (N)” części (lista od 4. karty schowana w CSS), „Dane techniczne” (panel pod pastylkami)
   i „Zapytaj o część” (formularz schowany do kliknięcia; bez skryptu otwiera go sama kotwica – `:target`). */
(function () {
  if (window.__pgWsparcie) return;
  window.__pgWsparcie = true;
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target : null;
    if (!t) return;
    var b = t.closest('[data-pg-ws-wszystkie]');
    if (b) {
      var lista = document.getElementById(b.getAttribute('aria-controls'));
      if (!lista) return;
      var otwarta = lista.classList.toggle('is-otwarta');
      b.setAttribute('aria-expanded', otwarta ? 'true' : 'false');
      if (!b.hasAttribute('data-t-wiecej')) b.setAttribute('data-t-wiecej', b.textContent);
      b.textContent = otwarta ? (b.getAttribute('data-t-mniej') || b.textContent) : b.getAttribute('data-t-wiecej');
      return;
    }
    var d = t.closest('[data-pg-ws-dane]');
    if (d) {
      var panel = document.getElementById(d.getAttribute('aria-controls'));
      if (!panel) return;
      var ukryty = !panel.hidden;
      panel.hidden = ukryty;
      d.setAttribute('aria-expanded', ukryty ? 'false' : 'true');
      return;
    }
    var z = t.closest('[data-pg-ws-zapytaj]');
    if (z) {
      var ws = z.closest('[data-pg-ws]') || document;
      var form = ws.querySelector('#pg-ws-zapytaj');
      if (!form) return;
      e.preventDefault();
      form.classList.add('is-otwarty');
      form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      var pole = form.querySelector('textarea');
      if (pole) setTimeout(function () { try { pole.focus({ preventScroll: true }); } catch (_) { pole.focus(); } }, 450);
    }
  });
})();

;
/* ===== czesci (S1, 18.09; makieta R61–R65 – wyszukiwarka części `snippets/pg-czesci-szukaj.liquid`) =====
   Podpowiedzi od drugiego znaku: dwa zapytania do podpowiedzi Shopify z sekcją `pg-czesci-podpowiedzi` – po samym SKU
   (pewne dla maszyn, jak w „Szybkim zamówieniu”) i po nazwie; kolejność: dokładne SKU → SKU zaczynające się od kodu → reszta,
   części osobno na dole („Części z „KDV9” w nazwie (N)”). Wybór → ta sama strona z `?sku=`; pod tym adresem skrypt wstawia
   stronę wsparcia produktu (sekcja `pg-wsparcie` przez Section Rendering) i chowa wyszukiwarkę. Kod bez produktu → „Nie mamy
   w sklepie modelu „X”.” z trzema drogami (R63); kilka produktów z tym samym SKU → lista do wyboru. */
(function () {
  var strona = document.querySelector('[data-pg-czesci]');
  if (!strona || window.__pgCzesci) return;
  window.__pgCzesci = true;
  var blok = strona.querySelector('[data-pg-cz-szukaj]');
  var pole = strona.querySelector('[data-pg-cz-pole]');
  var lista = strona.querySelector('[data-pg-cz-lista]');
  var stan = strona.querySelector('[data-pg-cz-stan]');
  var brak = strona.querySelector('[data-pg-cz-brak]');
  var widok = strona.querySelector('[data-pg-cz-widok]');
  if (!blok || !pole || !lista || !widok) return;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAKS = 5;
  var nr = 0;
  var zegar = null;
  var wiersze = [];
  var aktywny = -1;
  function T(n) { return strona.getAttribute('data-t-' + n) || ''; }
  function adresSku(sku) {
    var teraz = new URLSearchParams(location.search);
    var p = new URLSearchParams();
    if (teraz.get('view')) p.set('view', teraz.get('view'));
    p.set('sku', sku);
    return location.pathname + '?' + p.toString();
  }
  function zapytanie(q, pola) {
    var u = root + 'search/suggest?q=' + encodeURIComponent(q) + '&resources[type]=product&resources[limit]=10' +
      '&resources[limit_scope]=each&resources[options][fields]=' + pola + '&section_id=pg-czesci-podpowiedzi';
    return fetch(u, { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (h) { var d = document.createElement('div'); d.innerHTML = h; return [].slice.call(d.querySelectorAll('[data-pg-cz-i]')); });
  }
  function polacz(q, poSku, poNazwie) {
    var Q = q.toUpperCase();
    var byly = {};
    var akc = {};
    var inne = [];
    var czesci = [];
    poSku.concat(poNazwie).forEach(function (el) {
      var u = el.getAttribute('data-uchwyt');
      if (!u || byly[u]) return;
      byly[u] = 1;
      (el.getAttribute('data-akc') || '').split('|').forEach(function (h) { if (h) akc[h] = 1; });
      (el.getAttribute('data-typ') === 'czesc' ? czesci : inne).push(el);
    });
    function ranga(el) {
      var s = (el.getAttribute('data-sku') || '').toUpperCase();
      return s === Q ? 0 : (s.indexOf(Q) === 0 ? 1 : 2);
    }
    /* przy tym samym stopniu dopasowania krótszy SKU wyżej (KDV920 przed zestawem KDV920#SFF511) */
    inne = inne.map(function (el, i) { return { el: el, r: ranga(el), d: (el.getAttribute('data-sku') || '').length, i: i }; })
      .sort(function (a, b) { return a.r - b.r || (a.r === 1 ? a.d - b.d : 0) || a.i - b.i; })
      .map(function (x) { return x.el; });
    /* produkt bez własnej listy części, który jest na liście akcesoriów urządzenia z wyników = „akcesorium”
       (poza samym szukanym modelem); liczby plików i akcesoriów znikają – przy akcesoriach makieta ich nie pokazuje */
    inne.forEach(function (el) {
      if (!akc[el.getAttribute('data-uchwyt')] || ranga(el) === 0 || el.getAttribute('data-czesci') !== '0') return;
      el.setAttribute('data-typ', 'akcesorium');
      var em = el.querySelector('[data-pg-cz-typ]');
      if (em) em.textContent = T('akcesorium');
      var l = el.querySelector('.pg-cz__licz');
      if (l) l.parentNode.removeChild(l);
    });
    return { inne: inne, czesci: czesci };
  }
  function ustawAktywny(i) {
    wiersze.forEach(function (w, k) { w.classList.toggle('is-on', k === i); w.setAttribute('aria-selected', k === i ? 'true' : 'false'); });
    aktywny = i;
    if (i >= 0 && wiersze[i]) { pole.setAttribute('aria-activedescendant', wiersze[i].id); wiersze[i].scrollIntoView({ block: 'nearest' }); } else pole.removeAttribute('aria-activedescendant');
  }
  function zamknij() {
    lista.hidden = true;
    pole.setAttribute('aria-expanded', 'false');
    ustawAktywny(-1);
  }
  function pokaz(q, w) {
    lista.innerHTML = '';
    wiersze = [];
    var dodaj = function (el) {
      var sku = el.getAttribute('data-sku');
      if (sku) el.setAttribute('href', adresSku(sku));
      el.id = 'pg-cz-o-' + wiersze.length;
      el.setAttribute('aria-selected', 'false');
      lista.appendChild(el);
      wiersze.push(el);
    };
    w.inne.slice(0, MAKS).forEach(dodaj);
    if (w.czesci.length) {
      var h = document.createElement('p');
      h.className = 'pg-cz__h';
      h.setAttribute('role', 'presentation');
      h.textContent = T('grupa').replace('[q]', q).replace('[n]', String(w.czesci.length));
      lista.appendChild(h);
      w.czesci.slice(0, MAKS).forEach(dodaj);
    }
    var jest = wiersze.length > 0;
    lista.hidden = !jest;
    pole.setAttribute('aria-expanded', jest ? 'true' : 'false');
    aktywny = -1;
    if (brak) {
      brak.hidden = jest;
      var bh = brak.querySelector('[data-pg-cz-brak-h]');
      if (bh) bh.textContent = T('brak').replace('[q]', q);
    }
    stan.textContent = '';
  }
  function szukaj(q) {
    var moj = ++nr;
    stan.textContent = T('szukam');
    return Promise.all([zapytanie(q, 'variants.sku'), zapytanie(q, 'title')])
      .then(function (w) { if (moj !== nr) return; pokaz(q, polacz(q, w[0], w[1])); })
      .catch(function () { if (moj !== nr) return; zamknij(); stan.textContent = T('blad'); });
  }
  pole.addEventListener('input', function () {
    clearTimeout(zegar);
    var q = pole.value.trim();
    if (q.length < 2) { nr++; zamknij(); if (brak) brak.hidden = true; stan.textContent = ''; return; }
    zegar = setTimeout(function () { szukaj(q); }, 250);
  });
  pole.addEventListener('keydown', function (e) {
    if (e.key === 'ArrowDown' && wiersze.length) { e.preventDefault(); if (lista.hidden) { lista.hidden = false; pole.setAttribute('aria-expanded', 'true'); } ustawAktywny(Math.min(aktywny + 1, wiersze.length - 1)); }
    else if (e.key === 'ArrowUp' && wiersze.length) { e.preventDefault(); ustawAktywny(Math.max(aktywny - 1, 0)); }
    else if (e.key === 'Escape') { zamknij(); }
    else if (e.key === 'Enter') {
      e.preventDefault();
      var q = pole.value.trim().toUpperCase();
      var cel = aktywny >= 0 ? wiersze[aktywny] : null;
      if (!cel) wiersze.forEach(function (w) { if (!cel && (w.getAttribute('data-sku') || '').toUpperCase() === q) cel = w; });
      if (cel) location.href = cel.getAttribute('href');
      else if (pole.value.trim().length >= 2) { clearTimeout(zegar); szukaj(pole.value.trim()); }
    }
  });
  /* „Zapytaj o część do tego modelu” – kod z pola trafia do formularza (model i temat wiadomości) */
  strona.addEventListener('click', function (e) {
    var z = e.target && e.target.closest ? e.target.closest('[data-pg-ws-zapytaj]') : null;
    if (!z || !blok.contains(z)) return;
    var q = pole.value.trim();
    var form = blok.querySelector('#pg-ws-zapytaj');
    if (!form || !q) return;
    var m = form.querySelector('[data-pg-ws-model]');
    if (m) m.value = q;
    var t = form.querySelector('[data-pg-ws-temat]');
    if (t) t.value = t.getAttribute('data-pg-ws-temat') + ': ' + q;
  });

  /* ?sku= – strona wsparcia produktu pod trwałym adresem */
  function wstaw(url) {
    return fetch(url + (url.indexOf('?') < 0 ? '?' : '&') + 'section_id=pg-wsparcie', { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (h) {
        widok.innerHTML = h;
        /* jeden formularz na stronie: po wysłaniu komunikat jest w formularzu strony – wtedy zostaje on, inaczej ten z widoku */
        var fStrony = blok.querySelector('#pg-ws-zapytaj');
        var fWidoku = widok.querySelector('#pg-ws-zapytaj');
        if (fStrony && fWidoku) {
          if (fStrony.querySelector('.pg-ws__ok, .pg-ws__blad')) { fWidoku.parentNode.replaceChild(fStrony, fWidoku); fStrony.classList.add('is-otwarty'); fStrony.scrollIntoView(); }
          else fStrony.parentNode.removeChild(fStrony);
        }
      });
  }
  var sku = (new URLSearchParams(location.search).get('sku') || '').trim();
  if (sku) {
    blok.hidden = true;
    widok.innerHTML = '<div class="pg-ws"><p class="pg-cz__wczyt"></p></div>';
    widok.querySelector('.pg-cz__wczyt').textContent = T('wczytuje');
    var pokazSzukaj = function () { widok.innerHTML = ''; blok.hidden = false; pole.value = sku; };
    zapytanie(sku, 'variants.sku').then(function (els) {
      var S = sku.toUpperCase();
      var dokladne = els.filter(function (el) { return (el.getAttribute('data-sku') || '').toUpperCase() === S; });
      if (dokladne.length === 1) return wstaw(dokladne[0].getAttribute('data-url')).catch(function () { pokazSzukaj(); stan.textContent = T('blad'); });
      pokazSzukaj();
      if (dokladne.length > 1) {
        pokaz(sku, { inne: dokladne, czesci: [] });
        /* ten sam SKU w kilku produktach – wiersz prowadzi prosto do strony wsparcia danego produktu (adres karty + view) */
        wiersze.forEach(function (w) { var u = w.getAttribute('data-url'); if (u) w.setAttribute('href', u + (u.indexOf('?') < 0 ? '?' : '&') + 'view=wsparcie'); });
        stan.textContent = T('wiele');
      }
      else szukaj(sku);
    }).catch(function () { pokazSzukaj(); stan.textContent = T('blad'); });
  }
})();

;
/* ===== druk (S1, 18.09; makieta R68 – arkusze `snippets/pg-druk.liquid` i `pg-druk-koszyk.liquid`) =====
   Przed drukiem: data i godzina w stopce („Wydruk ze strony … z dnia 18.09.2026, godz. 10:40”), a na karcie produktu linia
   dostępności z napisów chipów panelu zakupu (dokładnie to, co widać na karcie – bez okienek „i” i bez „Przewidywanej
   wysyłki”). */
(function () {
  if (!document.querySelector('[data-pg-druk-data]')) return;
  var druk = document.querySelector('[data-pg-druk]');
  function dwa(n) { return (n < 10 ? '0' : '') + n; }
  function uzupelnij() {
    var d = new Date();
    var data = dwa(d.getDate()) + '.' + dwa(d.getMonth() + 1) + '.' + d.getFullYear();
    var godz = dwa(d.getHours()) + ':' + dwa(d.getMinutes());
    /* stopki arkusza strony i porównania (nakładka porównywarki ma własną stopkę) */
    [].forEach.call(document.querySelectorAll('[data-pg-druk-data]'), function (e) { e.textContent = data; });
    [].forEach.call(document.querySelectorAll('[data-pg-druk-godz]'), function (e) { e.textContent = godz; });
    var dost = druk ? druk.querySelector('[data-pg-druk-dost]') : null;
    var panel = document.querySelector('.pm__price-container');
    if (!dost || !panel) return;
    var napisy = [];
    [].forEach.call(panel.querySelectorAll('.pg-chip .ml-2-badges'), function (el) {
      var kopia = el.cloneNode(true);
      [].forEach.call(kopia.querySelectorAll('.pg-okienko, [class*="pg-okienko"], .pg-chip__kr'), function (x) { x.parentNode.removeChild(x); });
      var t = kopia.textContent.replace(/\s+/g, ' ').trim();
      if (t && napisy.indexOf(t) < 0) napisy.push(t);
    });
    dost.textContent = napisy.join(' · ');
  }
  window.addEventListener('beforeprint', uzupelnij);
  uzupelnij();
})();

;
/* ===== wiecej (S1, 18.09; makieta R70 – „Pokaż kolejne 24 produkty” w kolekcji, `snippets/pg-wiecej.liquid`) =====
   Przycisk to zwykły link do następnej strony. Tu dokładamy karty z tej strony na koniec siatki bez przeładowania (ten sam
   adres + `section_id` – Section Rendering API; filtry i sortowanie są już w adresie), a adres w pasku przeglądarki zostaje.
   Potem: przycisk z pobranej strony (następna porcja) albo koniec listy, zdarzenie `pg:karty` (porównywarka zaznacza pola
   na nowych kartach), komunikat dla czytników ekranu i ostrość na pierwszej nowej karcie (przycisk znika spod palca/klawisza).
   Ten sam produkt dwa razy (katalog zmienił się między porcjami) – pomijamy. Błąd pobierania → zwykłe przejście pod adres. */
(function () {
  if (window.__pgWiecej) return;
  window.__pgWiecej = true;
  var zajety = false;
  function komunikat(tekst) {
    var live = document.getElementById('pg-wiecej-live');
    if (!live) {
      live = document.createElement('div');
      live.id = 'pg-wiecej-live';
      live.className = 'pg-wiecej__live';
      live.setAttribute('aria-live', 'polite');
      document.body.appendChild(live);
    }
    live.textContent = '';
    setTimeout(function () { live.textContent = tekst; }, 60);
  }
  document.addEventListener('click', function (e) {
    var a = e.target && e.target.closest ? e.target.closest('[data-pg-wiecej-link]') : null;
    if (!a || e.defaultPrevented || e.button > 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var siatka = document.getElementById('collection__main-grid');
    var sekcja = a.getAttribute('data-pg-wiecej-sekcja');
    if (!siatka || !sekcja || !window.fetch || !window.DOMParser) return;
    e.preventDefault();
    if (zajety) return;
    zajety = true;
    /* 22.10 rezerwa miejsca w chwili kliknięcia. Karty przychodzą po 0,5 do 2 s, czyli po oknie
       500 ms, w którym przeglądarka nie liczy przesunięć po kliknięciu; dołożenie kart przesuwało wtedy widoczną stopkę. Siatka dostaje od razu dolny odstęp na nowe
       rzędy (stopka schodzi w dół jeszcze w oknie kliknięcia), a po dołożeniu kart odstęp znika w tym samym zadaniu; różnica dzieje
       się już pod ekranem. Odstęp, nie min-height: siatka rozciąga rzędy do min-height (pułapka 103). Jeden odczyt geometrii na klik. */
    try {
      var ile = parseInt(a.getAttribute('data-pg-wiecej-ile'), 10) || parseInt(siatka.getAttribute('data-pagination-limit'), 10) || 24;
      var dzieci = siatka.children, wys = siatka.getBoundingClientRect().height, pb = parseFloat(getComputedStyle(siatka).paddingBottom) || 0;
      if (dzieci.length && wys > 0) {
        var top0 = dzieci[0].getBoundingClientRect().top, kol = 0;
        for (var i = 0; i < dzieci.length && Math.abs(dzieci[i].getBoundingClientRect().top - top0) < 2; i++) kol++;
        kol = Math.max(kol, 1);
        siatka.style.paddingBottom = Math.round(pb + (wys - pb) / Math.ceil(dzieci.length / kol) * Math.ceil(ile / kol)) + 'px';
      }
    } catch (x) { siatka.style.paddingBottom = ''; }
    var href = a.href;
    a.setAttribute('aria-busy', 'true');
    var url = new URL(href, location.href);
    url.searchParams.set('section_id', sekcja);
    fetch(url.toString(), { credentials: 'same-origin' })
      .then(function (r) { if (!r.ok) throw new Error('HTTP ' + r.status); return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nowa = doc.getElementById('collection__main-grid');
        if (!nowa) throw new Error('brak siatki');
        var juz = {};
        [].forEach.call(siatka.querySelectorAll('.product-card__title-link'), function (l) { juz[l.getAttribute('href')] = 1; });
        var dodane = [];
        [].slice.call(nowa.children).forEach(function (el) {
          var l = el.querySelector('.product-card__title-link');
          if (l && juz[l.getAttribute('href')]) return;
          var w = document.importNode(el, true);
          siatka.appendChild(w);
          dodane.push(w);
        });
        /* animacje wejścia motywu są wyłączone (klasa animationsDisabled); gdyby je włączyć, obserwator motywu nie widzi
           dokładanych kart (szuka [data-animation]) – bez tego zostałyby przezroczyste */
        if (!document.documentElement.classList.contains('animationsDisabled')) dodane.forEach(function (el) { el.style.opacity = '1'; });
        var stary = a.closest('[data-pg-wiecej]');
        var nowy = doc.querySelector('[data-pg-wiecej="dol"]');
        if (stary && nowy) stary.parentNode.replaceChild(document.importNode(nowy, true), stary);
        else if (stary) stary.parentNode.removeChild(stary);
        siatka.style.paddingBottom = '';
        var kom = doc.querySelector('[data-pg-wiecej-komunikat]');
        if (kom) komunikat(kom.textContent.trim());
        var pierwsza = dodane.length ? dodane[0].querySelector('.product-card__title-link') : null;
        if (pierwsza) { try { pierwsza.focus({ preventScroll: true }); } catch (x) { pierwsza.focus(); } }
        document.dispatchEvent(new CustomEvent('pg:karty', { detail: { dodane: dodane.length } }));
        zajety = false;
      })
      .catch(function () { location.href = href; });
  });
})();

;
/* ===== sortowanie (S1, 18.09; makieta R77 – rząd przycisków `snippets/pg-sortowanie.liquid`) =====
   Przycisk zaznacza tę samą opcję w szufladzie „Sortuj według” (radio `#sortMobile-<wartość>` w formularzu filtrów motywu)
   i woła przeliczenie formularza motywu (collection-filters-form.js – `renderPage`) z bieżącymi filtrami, bez przeładowania,
   z zapisem adresu. Stan przycisków: od razu po kliknięciu, po wyborze w szufladzie (telefon, tablet) i po „wstecz/dalej”
   (z adresu; bez `sort_by` – kolejność domyślna kolekcji). Gdy formularza nie ma – zwykłe przejście pod adres z `sort_by`.
   BŁĄD zgłoszony 18.09 (T5): pierwsza wersja wysyłała „change” na radiu z szuflady – motyw po 300 ms „klika”
   wtedy przycisk zamknięcia szuflady, który w rzeczywistości PRZEŁĄCZA (`toggle-drawer`), więc zamknięta szuflada się
   otwierała, a strona zostawała z blokadą przewijania. Teraz `renderPage` bez zdarzenia – szuflada nie jest ruszana. */
(function () {
  if (window.__pgSort) return;
  window.__pgSort = true;
  function ustaw(wartosc) {
    [].forEach.call(document.querySelectorAll('[data-pg-sort]'), function (b) {
      b.setAttribute('aria-pressed', b.getAttribute('data-pg-sort') === wartosc ? 'true' : 'false');
    });
  }
  // wybór w szufladzie (telefon, tablet) – rząd przycisków ma pokazać to samo po zmianie szerokości okna
  document.addEventListener('change', function (e) {
    var r = e.target;
    if (r && r.matches && r.matches('[data-action="apply-sort"]') && r.checked) ustaw(r.value);
  });
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-pg-sort]') : null;
    if (!b || b.getAttribute('aria-pressed') === 'true') return;
    var w = b.getAttribute('data-pg-sort');
    var r = document.getElementById('sortMobile-' + w);
    var cf = r && r.closest ? r.closest('collection-filters-form') : null;
    if (r && r.form && cf && typeof cf.renderPage === 'function') {
      r.checked = true;
      cf.clear = false;
      cf.renderPage(new URLSearchParams(new FormData(r.form)).toString(), null);
      ustaw(w);
    } else {
      var u = new URL(location.href);
      u.searchParams.set('sort_by', w);
      u.searchParams.delete('page');
      location.href = u.toString();
    }
  });
  window.addEventListener('popstate', function () {
    var g = document.querySelector('[data-pg-sort-grupa]');
    if (!g) return;
    var w = new URLSearchParams(location.search).get('sort_by') || g.getAttribute('data-pg-sort-domyslne');
    ustaw(w);
    var r = document.getElementById('sortMobile-' + w);
    if (r) r.checked = true;
  });
})();

;
/* ===== 404 (S1, 18.09; makieta R67 – `sections/pg-404.liquid`) =====
   Słowa ze starego adresu → pełne wyszukiwanie sklepu (sekcja `pg-404-wyniki`) → trzy zwykłe karty, kategorie tych produktów
   i „Czy chodziło o: …?”, gdy jeden produkt pasuje najlepiej. Bez wyników – krótsze zapytanie (bez ostatnich słów, najmniej dwa).
   „Czy chodziło o”: udział słów z adresu w nazwie produktu (bez polskich znaków i wielkości liter; słowo z cyfrą, np. „7x”,
   waży podwójnie – odróżnia modele); pokazujemy tylko przy co najmniej 75 % i bez remisu z drugim wynikiem. */
(function () {
  var box = document.querySelector('[data-pg-404]');
  if (!box || window.__pg404) return;
  window.__pg404 = true;
  /* słowa z adresu: ostatni człon ścieżki, bez rozszerzenia i bez numeru dawnego sklepu na początku („1234-piec-…”);
     w Liquid szablonu 404 adres to „/404”, dlatego liczy to skrypt */
  var czlony = location.pathname.split('/').filter(Boolean);
  var ost = czlony.length ? czlony[czlony.length - 1] : '';
  try { ost = decodeURIComponent(ost); } catch (_) {}
  var slowa = ost.toLowerCase().replace(/\.[a-z0-9]{2,5}$/, '').split(/[-_+\s]+/).filter(Boolean);
  if (slowa.length && /^\d+$/.test(slowa[0])) slowa.shift();
  var q = slowa.join(' ');
  if (q === '404' || q.length < 2) return;
  var pole0 = box.querySelector('[data-pg-404-pole]');
  if (pole0 && !pole0.value) pole0.value = q;
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  function norm(s) {
    return String(s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/ł/g, 'l');
  }
  function tokeny(s) { return norm(s).split(/[^a-z0-9]+/).filter(Boolean); }
  function pobierz(zap) {
    return fetch(root + 'search?q=' + encodeURIComponent(zap) + '&type=product&section_id=pg-404-wyniki', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (h) { var d = document.createElement('div'); d.innerHTML = h; return d.querySelector('[data-pg-404-wyniki]'); });
  }
  function probuj(n) {
    var zap = slowa.slice(0, n).join(' ');
    return pobierz(zap).then(function (w) {
      if (w && w.querySelector('.pg-404__karta')) return { w: w, zap: zap };
      if (n > 2) return probuj(n - 1);
      return null;
    });
  }
  function czyChodzilo(w) {
    var szukane = tokeny(slowa.join(' '));
    var waga = function (t) { return /\d/.test(t) ? 2 : 1; };
    var razem = szukane.reduce(function (s, t) { return s + waga(t); }, 0);
    if (!razem) return null;
    var oceny = [].slice.call(w.querySelectorAll('[data-pg-404-p]')).map(function (el) {
      var mam = {};
      tokeny(el.getAttribute('data-tytul')).forEach(function (t) { mam[t] = 1; });
      var pkt = szukane.reduce(function (s, t) { return s + (mam[t] ? waga(t) : 0); }, 0);
      return { el: el, ocena: pkt / razem };
    }).sort(function (a, b) { return b.ocena - a.ocena; });
    if (!oceny.length || oceny[0].ocena < 0.75) return null;
    if (oceny[1] && oceny[1].ocena >= oceny[0].ocena) return null;
    return oceny[0].el;
  }
  /* 23.09 (przegląd „świeżymi oczami” O22): przy braku wyników rezerwa NIE znika – zdjęcie rezerwy (ok. 420 px na telefonie) podnosiło
     „Wszystkie kategorie” i pomoc o 416 px po ok. 3 s (CLS 0,1309 na 390 × 844). Rezerwa to trzy prawdziwe karty bestsellerów, więc
     odsłaniamy je z nagłówkiem w zarezerwowanej linii („Czy chodziło o…”) – to samo miejsce, zero przesunięcia. */
  function bestsellery() {
    var karty = box.querySelector('[data-pg-404-karty]');
    var rez = karty && karty.querySelector('[data-pg-404-rezerwa]');
    if (!rez) { box.classList.remove('pg-404--czeka'); return; }
    rez.classList.remove('pg-404__karty--rezerwa');
    rez.removeAttribute('aria-hidden');
    rez.removeAttribute('inert');
    var czy = box.querySelector('[data-pg-404-czy]');
    var t = box.getAttribute('data-t-popularne');
    if (czy && t) { czy.textContent = t; czy.hidden = false; }
  }
  probuj(slowa.length).then(function (wynik) {
    if (!wynik) { bestsellery(); return; }
    var karty = box.querySelector('[data-pg-404-karty]');
    var zrodlo = wynik.w.querySelector('[data-pg-404-wynik-karty]');
    /* 21.09 (K7-3): niewidoczna rezerwa z kart (sekcja) schodzi w tej samej klatce, w której wchodzą wyniki; wysokość kontenera sprzed
       podmiany zostaje jako min-height – karty różnych produktów mają różną liczbę wierszy (chipy, parametry: 390 px vs 428 px na 390 px
       szerokości), więc bez tego dolna część strony podjeżdżałaby o kilkanaście px (CLS 0,0009–0,0042 zamiast 0) */
    var rezerwa = karty && karty.querySelector('[data-pg-404-rezerwa]');
    var h0 = karty && rezerwa ? karty.getBoundingClientRect().height : 0;
    if (karty && zrodlo) { zrodlo.removeAttribute('data-pg-404-wynik-karty'); karty.appendChild(zrodlo); if (rezerwa) rezerwa.remove(); if (h0 > 0) karty.style.minHeight = Math.ceil(h0) + 'px'; }
    var opis = box.querySelector('[data-pg-404-wyniki-opis]');
    if (opis) opis.hidden = false;
    var pole = box.querySelector('[data-pg-404-pole]');
    if (pole && wynik.zap !== q) pole.value = wynik.zap;
    var kat = box.querySelector('[data-pg-404-kat]');
    var wszystkie = box.querySelector('[data-pg-404-wszystkie]');
    var nowe = wynik.w.querySelector('[data-pg-404-wynik-kat]');
    /* 22.09 (W-39): pastylki kategorii dokładamy NA KONIEC, nie przed „Wszystkie kategorie” – wstawienie przed
       przesuwało istniejącą pastylkę w bok, a to też liczy się do CLS (0,0039 na telefonie). Kolejność „od ogółu
       do szczegółu” jest przy okazji czytelniejsza. */
    if (kat && wszystkie && nowe) [].slice.call(nowe.children).forEach(function (a) { kat.appendChild(a); });
    var el = czyChodzilo(wynik.w);
    var czy = box.querySelector('[data-pg-404-czy]');
    if (el && czy) {
      var wzor = box.getAttribute('data-t-czy') || '[x]';
      var czesci = wzor.split('[x]');
      var a = document.createElement('a');
      a.href = el.getAttribute('data-url');
      a.textContent = el.getAttribute('data-tytul');
      czy.textContent = '';
      czy.appendChild(document.createTextNode(czesci[0] || ''));
      czy.appendChild(a);
      czy.appendChild(document.createTextNode(czesci[1] || ''));
      czy.hidden = false;
    }
  }).catch(function () { bestsellery(); });
})();

;
/* ===== szuflady-fokus (19.09, D5 – dostępność; 22.09 rozszerzone – fokus WCHODZI do szuflady i w niej zostaje) ===== */
/* Szuflady motywu (menu telefonu, koszyk, filtry: `.Drawer--wrapper`) mają `role="dialog"`, ale nie są natywnym
   <dialog>, więc przeglądarka nie pilnuje w nich fokusu. Zmierzone 22.09 na motywie testowym I NA ŻYWYM (to samo
   zachowanie – wada zastana, nie nasz regres): po dodaniu do koszyka z klawiatury szuflada się otwiera, a fokus
   zostaje na <body>; Tab wędruje po stronie POD szufladą (WCAG 2.4.3 i 2.1.1 – zasłonięta treść dostaje fokus).
   Tu trzy rzeczy: (1) przy otwarciu fokus idzie na samą szufladę (`tabindex="-1"`, czytnik czyta jej `aria-label`)
   – nie na pierwszy element, bo w koszyku jest nim link produktu z rekomendacji; (2) Tab i Shift+Tab zawijają się
   wewnątrz otwartej szuflady; (3) po zamknięciu fokus wraca na element, który ją otworzył (to było już z 19.09:
   motyw w `global.min.js` woła `removeTrapFocus(this.element)`, czyli oddaje fokus SAMEJ ukrytej szufladzie).
   Uwaga z pomiaru: na stronie stale jest jakiś `dialog[open]` (okna motywu), więc modal rozpoznajemy po `:modal`;
   podszuflady kategorii (`#link__kategorie…`) NIE MAJĄ `aria-hidden`, dlatego otwarta = dokładnie `="false"`. */
(function () {
  var WYBIERALNE = 'a[href], button:not([disabled]), input:not([disabled]):not([type="hidden"]), select:not([disabled]), textarea:not([disabled]), [tabindex]:not([tabindex="-1"])';
  var poza = null;
  var otwieracz = new WeakMap();
  var otwarte = new WeakSet();
  function wSzufladzie(el) { return !!(el && el.closest && el.closest('.Drawer--wrapper')); }
  function modalOtwarty() { try { return !!document.querySelector('dialog:modal'); } catch (e) { return false; } }
  function otwartaSzuflada() { return document.querySelector('.Drawer--wrapper[aria-hidden="false"]'); }
  function wybieralne(d) {
    return [].slice.call(d.querySelectorAll(WYBIERALNE)).filter(function (e) {
      return e.getClientRects().length && getComputedStyle(e).visibility !== 'hidden';
    });
  }
  document.addEventListener('focusin', function (e) { if (!wSzufladzie(e.target)) poza = e.target; }, true);
  document.addEventListener('click', function (e) {
    var t = e.target && e.target.closest && e.target.closest('button, a, [tabindex]');
    if (t && !wSzufladzie(t)) poza = t;
  }, true);
  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab' || modalOtwarty()) return;
    var d = otwartaSzuflada();
    if (!d) return;
    var lista = wybieralne(d);
    if (!lista.length) return;
    var pierwszy = lista[0], ostatni = lista[lista.length - 1], a = document.activeElement;
    if (!d.contains(a)) { e.preventDefault(); (e.shiftKey ? ostatni : pierwszy).focus(); return; }
    if (e.shiftKey && (a === pierwszy || a === d)) { e.preventDefault(); ostatni.focus(); }
    else if (!e.shiftKey && a === ostatni) { e.preventDefault(); pierwszy.focus(); }
  }, true);
  var obs = new MutationObserver(function (lista) {
    lista.forEach(function (m) {
      var d = m.target;
      var ukryta = d.getAttribute('aria-hidden') === 'true';
      if (!ukryta) {
        if (otwarte.has(d)) return;            /* kolejna zmiana przy JUŻ otwartej – nie nadpisujemy otwieracza */
        otwarte.add(d);
        if (poza) otwieracz.set(d, poza);
        /* 04.10 (41.5 – axe `aria-allowed-attr`, krytyczne): `aria-modal` tylko przy roli dialog / alertdialog. Menu ☰ (`#menu`) ma rolę
           `navigation` (punkt orientacyjny z nazwą „Menu główne”) i tam ten atrybut jest niedozwolony; fokus i Tab w szufladzie – bez zmian. */
        if (/^(alert)?dialog$/.test(d.getAttribute('role') || '')) d.setAttribute('aria-modal', 'true');
        /* Trzy próby, nie jedna: koszyk po dodaniu produktu dociąga zawartość przez AJAX i motyw w tym czasie
           woła własne `removeTrapFocus`, które zdejmuje fokus z powrotem na <body> (zmierzone 22.09: przy jednej
           próbie po 260 ms fokus wracał na body, a klient trafiał do szuflady dopiero Tabem). Próba odpuszcza,
           gdy szuflada zdążyła się zamknąć, gdy nad nią stoi okno modalne albo gdy fokus jest już w środku. */
        [260, 700, 1300].forEach(function (ms) {
          setTimeout(function () {
            if (!otwarte.has(d) || d.getAttribute('aria-hidden') === 'true' || modalOtwarty()) return;
            var a = document.activeElement;
            if (a && a !== document.body && (d === a || d.contains(a))) return;  /* klient już sam kliknął w środku */
            /* Fokus poza szufladą zostawiamy w spokoju – z jednym wyjątkiem: elementu, który ją otworzył
               (przycisk ☰, „Dodaj do koszyka”). Inaczej po kliknięciu ☰ z klawiatury fokus zostawał na przycisku,
               a menu – mimo `role="dialog"` – trzeba było dopiero znaleźć Tabem (zmierzone 22.09). */
            if (a && a !== document.body && !d.contains(a) && a !== otwieracz.get(d)) return;
            if (!d.hasAttribute('tabindex')) d.setAttribute('tabindex', '-1');
            d.focus({ preventScroll: true });
          }, ms);
        });
        return;
      }
      otwarte.delete(d);
      d.removeAttribute('aria-modal');
      var cel = otwieracz.get(d);
      var a = document.activeElement;
      if (!cel || !document.contains(cel) || !cel.getClientRects().length) return;
      if (a && a !== document.body && a !== d && !d.contains(a)) return;
      cel.focus({ preventScroll: true });
    });
  });
  document.querySelectorAll('.Drawer--wrapper').forEach(function (d) {
    obs.observe(d, { attributes: true, attributeFilter: ['aria-hidden'] });
  });
})();

/* ===== dokumenty-tabele (19.09, F6 – dostępność) ===== */
/* Tabele w dokumentach prawnych (treść stron z panelu: `.pg-reg .pg-scroll` z przewijaniem w bok) na wąskim ekranie
   wychodzą poza szerokość, a obszaru przewijania nie dało się wybrać klawiaturą (axe scrollable-region-focusable – Zwroty
   i reklamacje, Polityka prywatności przy 375 px; WCAG 2.1.1). Obszar, który naprawdę się przewija, dostaje tabindex="0"
   (obrys z reguły `[tabindex]:focus-visible` w base-min.css), rolę region i nazwę z nagłówka sekcji nad tabelą; gdy po
   obróceniu ekranu tabela się mieści – wraca do stanu z treści strony. Treść stron bez zmian. */
(function () {
  var obszary = document.querySelectorAll('.pg-reg .pg-scroll');
  if (!obszary.length) return;
  function naglowek(el) {
    for (var p = el.previousElementSibling; p; p = p.previousElementSibling) {
      if (/^H[2-4]$/.test(p.tagName)) return p.textContent.replace(/\s+/g, ' ').trim();
    }
    return '';
  }
  function ustaw() {
    obszary.forEach(function (el) {
      var przewija = el.scrollWidth > el.clientWidth + 1;
      if (przewija && !el.hasAttribute('tabindex')) {
        el.setAttribute('tabindex', '0');
        el.setAttribute('role', 'region');
        var n = naglowek(el);
        if (n) el.setAttribute('aria-label', n);
        el.setAttribute('data-pg-tabela', '1');
      } else if (!przewija && el.hasAttribute('data-pg-tabela')) {
        ['tabindex', 'role', 'aria-label', 'data-pg-tabela'].forEach(function (a) { el.removeAttribute(a); });
      }
    });
  }
  ustaw();
  /* ponownie po wczytaniu czcionek i obrazów (szerokość tabeli może się jeszcze zmienić) i przy zmianie rozmiaru okna */
  window.addEventListener('load', ustaw);
  var czas;
  window.addEventListener('resize', function () { clearTimeout(czas); czas = setTimeout(ustaw, 200); });
})();

;
/* ===== obszar-zakupu (21.09 22:5x, polecenia 277 T7 i 278; mandat B118) =====
   JEDNA reguła „okno czy zwykły odnośnik” dla okna kontaktu i okna dokumentów (zgłoszenie; „»Co to znaczy« w Uruchomienie, i pewnie jeszcze inne tego typu odnośniki, to musi
   otwierać zawsze popup, odnośniki do polityk i reguł tylko w stopkach i miejscach skąd nie odciągamy klienta od zakupu”):
     OKNO     – cała strona karty produktu (każda sekcja szablonu produktu: panel zakupu, pasek „Warto wiedzieć”, zakładki, pytania i odpowiedzi),
                strona koszyka, szuflada koszyka, przyklejony pasek zakupu i każde miejsce oznaczone `data-pg-okno` (dawniej `data-pg-dok-okno` / `data-pg-ko-okno`);
     ODNOŚNIK – nagłówek, pasek kontaktu nad logo, menu główne, menu telefonu, stopka i wszystkie pozostałe strony (klient nie jest w trakcie zakupu).
   Do 21.09 wieczorem okno dokumentów działało tylko wewnątrz `.pm__content` (odnośnik „Co to znaczy” w pasku pod kartą wyprowadzał ze strony),
   a okno kontaktu łapało KAŻDY odnośnik do strony Kontakt, także w menu i stopce. */
window.pgWObszarzeZakupu = function (a) {
  if (!a || !a.closest) return false;
  if (a.closest('[data-pg-bez-okna]')) return false;
  /* najpierw miejsca wskazane wprost – szuflada koszyka bywa osadzona w grupie sekcji nagłówka, a mimo to jest obszarem zakupu */
  if (a.closest('[data-pg-okno], [data-pg-dok-okno], [data-pg-ko-okno], .pg-stickybar, cart-drawer, .cart-drawer, .main-cart, #main-cart, form[action$="/cart"]')) return true;
  if (a.closest('header, footer, nav, .shopify-section-group-header-group, .shopify-section-group-footer-group')) return false;
  return !!(document.querySelector('.product-module') && a.closest('main, #MainContent, .pm__content, #product-info'));
};

/* ===== kontakt-okno (20.09, T3, mandat B112 a; zakres od 21.09 22:52 – polecenia 263 T1, 277 T7, 278, mandat B118) ===== */
/* Odnośniki do strony Kontakt TYLKO W OBSZARZE ZAKUPU (cała karta produktu: „Zapytaj o produkt”, „Powiadom mnie o dostawie” bez
   aplikacji, „Zapytaj o część”, FAQ na karcie; koszyk, szuflada koszyka, pasek zakupu – jedno źródło: `window.pgWObszarzeZakupu`)
   otwierają okno z danymi kontaktowymi i formularzem (snippets/pg-kontakt-okno.liquid, natywny <dialog>) zamiast
   wyprowadzać klienta ze strony; „Kontakt” w menu, pasku nad logo, menu telefonu i stopce prowadzi NA STRONĘ Kontakt.
   Bez skryptu odnośnik działa jak dotąd (strona Kontakt); tak samo klik środkowym przyciskiem
   albo z Ctrl/Shift (nowa karta). Produkt i SKU z adresu odnośnika (?produkt=&sku=) trafiają do pól ukrytych i na początek
   wiadomości (szablon `pg.contact_prefill`). Po wysłaniu Shopify wraca na tę samą stronę z `?contact_posted=true#pg-kontakt`
   (albo z błędami w formularzu) – wtedy okno otwiera się samo z komunikatem, a ten sam komunikat w innych formularzach
   kontaktowych strony (formularz strony głównej, „Zapytaj o część”) jest zdejmowany, żeby nie było go dwa razy. */
(function () {
  var okno = document.querySelector('dialog[data-pg-ko]');
  if (!okno || typeof okno.showModal !== 'function') return;
  var naglowek = okno.querySelector('[data-pg-ko-h]');
  var tytul0 = naglowek ? naglowek.textContent : '';
  var tresc = okno.querySelector('[data-pg-ko-tresc]');
  var poleProd = okno.querySelector('[data-pg-ko-produkt]');
  var poleSku = okno.querySelector('[data-pg-ko-sku]');
  var reKontakt = /\/pages\/kontakt(?:[?#]|$)/;
  var reWyslane = /[?&]contact_posted=true(?:&|$)/;
  /* kotwica powrotu: Shopify bierze ją z identyfikatora FORMULARZA (`#pg-kontakt-form`), nie okna */
  var reKotwica = /^#pg-kontakt(?:-form)?$/;
  var prefillOstatni = '';

  function otworz(prod, sku) {
    var zProduktem = !!(prod || sku);
    if (naglowek) naglowek.textContent = zProduktem ? (okno.getAttribute('data-t-produkt') || tytul0) : tytul0;
    if (poleProd) { poleProd.value = prod || ''; poleProd.disabled = !prod; }
    if (poleSku) { poleSku.value = sku || ''; poleSku.disabled = !sku; }
    if (tresc) {
      if (zProduktem && !tresc.value.trim()) {
        tresc.value = (okno.getAttribute('data-t-prefill') || '').replace('%p', prod || '').replace('%s', sku || '') + '\n\n';
        prefillOstatni = tresc.value;
      } else if (!zProduktem && prefillOstatni && tresc.value === prefillOstatni) {
        /* otwarte z ogólnego „Kontakt” po wcześniejszym „Zapytaj o produkt” bez dopisania niczego – nietknięty szablon znika */
        tresc.value = '';
        prefillOstatni = '';
      }
    }
    if (!okno.open) okno.showModal();
    /* 23.09 (B150 c): klasa zamiast `html:has(.pg-ko[open])` – blokada przewijania pod oknem bez kosztownego :has() na całym dokumencie */
    document.documentElement.classList.add('pg-ko-otwarte');
    var cel = okno.querySelector('[data-pg-ko-ok], [data-pg-ko-blad]') ? okno.querySelector('[data-pg-ko-zamknij]') : okno.querySelector('input[name="contact[name]"]');
    try { if (cel) cel.focus({ preventScroll: true }); } catch (e) {}
  }

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target && e.target.closest ? e.target.closest('a[href]') : null;
    if (!a || a.hasAttribute('data-pg-ko-strona') || a.target === '_blank') return;
    var href = a.getAttribute('href') || '';
    if (!reKontakt.test(href)) return;
    /* 21.09 22:5x (T7 – zgłoszenie; mandat B118 z 263 T1 objął 21.09 tylko okno DOKUMENTÓW –
       okno KONTAKTU nadal łapało każdy odnośnik do strony Kontakt: menu główne, pasek nad logo, menu telefonu, stopkę). Teraz ta sama zasada:
       okno tylko w obszarze zakupu (karta produktu razem z jej pytaniami i odpowiedziami, koszyk, szuflada koszyka, pasek zakupu) albo tam,
       gdzie rodzic ma atrybut `data-pg-ko-okno`; wszędzie indziej zwykły odnośnik prowadzi NA STRONĘ Kontakt. */
    if (!window.pgWObszarzeZakupu(a)) return;
    /* „Powiadom mnie o dostawie” obsługuje aplikacja (część „powiadom” w pg-product.js), jeśli jej przycisk jest na stronie – chyba że jej serwer
       milczał 15 s (`window.pgCbMilczy` – 06.10, 43.46): wtedy to okno kontaktu z nazwą i SKU */
    if (a.hasAttribute('data-pg-powiadom') && document.querySelector('.pm__product-atc-wrapper .gw-button-widget') && !window.pgCbMilczy) return;
    var q = null;
    try { q = new URL(href, location.href).searchParams; } catch (er) {}
    e.preventDefault();
    otworz(q ? (q.get('produkt') || '') : '', q ? (q.get('sku') || '') : '');
  });
  okno.querySelector('[data-pg-ko-zamknij]').addEventListener('click', function () { okno.close(); });
  okno.addEventListener('click', function (e) { if (e.target === okno) okno.close(); });
  okno.addEventListener('close', function () { document.documentElement.classList.remove('pg-ko-otwarte'); });
  /* wysyłka (po sprawdzeniu pól przez przeglądarkę): okno się zamyka, bo ochrona formularzy Shopify potrafi wstawić na stronę
     sprawdzenie „nie jestem robotem” – POD warstwą wierzchnią okna byłoby niewidoczne (test 20.09 22:20); po powrocie okno
     otwiera się samo z komunikatem, a wpisana treść zostaje w formularzu, gdyby klient wrócił do okna bez wysyłki */
  var formularz = okno.querySelector('form');
  if (formularz) formularz.addEventListener('submit', function () { setTimeout(function () { if (okno.open) okno.close(); }, 0); });

  /* powrót z wysyłki (Shopify wraca na tę samą stronę): komunikat w oknie, dublet tego komunikatu poza oknem zdjęty */
  if (reKotwica.test(location.hash) && (reWyslane.test(location.search) || okno.querySelector('[data-pg-ko-blad]'))) {
    var duble = document.querySelectorAll('.contact-form__success-message, .contact-form__error-message, .pg-ws__ok, .pg-ws__blad');
    for (var i = 0; i < duble.length; i++) {
      if (!okno.contains(duble[i]) && duble[i].parentNode) duble[i].parentNode.removeChild(duble[i]);
    }
    otworz('', '');
  }
})();

/* ===== dok-okno (21.09, T12, mandat B112 a) =====
   Odnośniki do NASZYCH stron z dokumentami (Regulamin, Zwroty i reklamacje, Warunki dostawy, Polityka prywatności,
   Dostępność, Informacje kontaktowe, strona wsparcia) otwierają okno z treścią tej strony (snippets/pg-dok-okno.liquid,
   natywny <dialog>) zamiast wyprowadzać klienta z karty produktu. Treść pobieramy Section Rendering API
   (`?section_id=main-page`) – to ta sama sekcja, którą rysuje strona, więc nic nie trzeba powielać.
   Kotwica z odnośnika (np. `#p10` – warunki gwarancji) przewija okno do właściwego paragrafu.
   Bez skryptu, przy błędzie pobrania, przy kliknięciu środkowym / z Ctrl / Shift i na samych stronach dokumentów
   odnośnik działa jak dotąd (pełna strona). W stopce okna zostaje „Otwórz pełną stronę”. */
(function () {
  var okno = document.querySelector('dialog[data-pg-dok]');
  if (!okno || typeof okno.showModal !== 'function' || !window.fetch) return;
  var root = okno.getAttribute('data-root') || '/';
  var strony = (okno.getAttribute('data-strony') || '').split(',').filter(Boolean);
  var body = okno.querySelector('[data-pg-dok-body]');
  var naglowek = okno.querySelector('[data-pg-dok-h]');
  var pelna = okno.querySelector('[data-pg-dok-pelna]');
  var cache = {};

  function uchwytZAdresu(href) {
    try {
      var u = new URL(href, location.origin);
      if (u.origin !== location.origin) return null;
      var m = u.pathname.match(/\/pages\/([^/?#]+)\/?$/);
      if (!m) return null;
      return strony.indexOf(m[1]) > -1 ? { uchwyt: m[1], hash: u.hash || '', sciezka: u.pathname } : null;
    } catch (e) { return null; }
  }

  function pokazBlad() {
    body.innerHTML = '';
    var p = document.createElement('p');
    p.className = 'pg-dok__stan';
    p.textContent = okno.getAttribute('data-t-blad') || '';
    body.appendChild(p);
  }

  function wstaw(html, hash) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var tresc = doc.querySelector('.rte, .pageWrapper, main');
    if (!tresc) { pokazBlad(); return; }
    var h1 = tresc.querySelector('h1');
    if (h1) { if (naglowek) naglowek.textContent = h1.textContent.trim(); h1.remove(); }
    body.innerHTML = '';
    body.appendChild(tresc);
    body.scrollTop = 0;
    if (hash) {
      var cel = null;
      try { cel = body.querySelector(hash); } catch (e) { cel = null; }
      if (cel) cel.scrollIntoView({ block: 'start' });
    }
  }

  function otworz(dane) {
    if (!okno.open) okno.showModal();
    if (pelna) pelna.setAttribute('href', dane.sciezka + dane.hash);
    if (naglowek) naglowek.textContent = naglowek.getAttribute('data-domyslny') || naglowek.textContent;
    body.innerHTML = '<p class="pg-dok__stan">' + (okno.getAttribute('data-t-ladowanie') || '') + '</p>';
    var klucz = dane.uchwyt;
    if (cache[klucz]) { wstaw(cache[klucz], dane.hash); return; }
    var url = root + 'pages/' + klucz + '?section_id=main-page';
    fetch(url, { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (html) {
        if (!html) { pokazBlad(); return; }
        cache[klucz] = html;
        wstaw(html, dane.hash);
      })
      .catch(pokazBlad);
  }

  /* 21.09 (T1, mandat B118 – OKNO CZY LINK): okno otwieramy TYLKO tam, gdzie wyjście na inną stronę
     przerywałoby zakup – na karcie produktu (razem z paskiem przy przycisku i chipami), w koszyku i w szufladzie koszyka.
     W stopce, w menu, na stronach stałych i wszędzie indziej link ma prowadzić NA STRONĘ dokumentu, jak zwykły odnośnik
     („w stopce te linki do polityk i regulaminów mają przenosić na te strony, a nie otwierać popup”).
     Nowe miejsce, w którym okno ma działać, wystarczy oznaczyć atrybutem `data-pg-dok-okno` na dowolnym rodzicu. */
  var OBSZAR_ZAKUPU = [
    '[data-pg-dok-okno]',
    '.pm__content',              /* karta produktu – cała sekcja */
    '.product-information-section',
    '#mobile-product-info-section',
    'cart-drawer',               /* szuflada koszyka */
    '.cart-drawer',
    '.main-cart',                /* strona koszyka */
    '#main-cart',
    'form[action$="/cart"]',
  ].join(', ');

  document.addEventListener('click', function (e) {
    if (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    var a = e.target.closest ? e.target.closest('a[href*="/pages/"]') : null;
    if (!a || a.target === '_blank' || a.hasAttribute('download') || a.hasAttribute('data-pg-dok-pelna')) return;
    /* poza obszarem zakupu zostawiamy zwykły link (B118); od 21.09 22:5x jedna reguła dla obu okien – `window.pgWObszarzeZakupu` wyżej
       (cała karta produktu, nie tylko `.pm__content`: odnośnik „Co to znaczy” w pasku pod kartą wyprowadzał ze strony – ) */
    if (!a.closest(OBSZAR_ZAKUPU) && !window.pgWObszarzeZakupu(a)) return;
    var dane = uchwytZAdresu(a.getAttribute('href') || '');
    if (!dane) return;
    /* jesteśmy już na tej stronie – nic nie przechwytujemy */
    if (location.pathname.replace(/\/$/, '') === dane.sciezka.replace(/\/$/, '')) return;
    e.preventDefault();
    otworz(dane);
  });

  okno.querySelectorAll('[data-pg-dok-zamknij]').forEach(function (b) { b.addEventListener('click', function () { okno.close(); }); });
  okno.addEventListener('click', function (e) { if (e.target === okno) okno.close(); });
})();

;
/* ===== leaselink-a11y (v85) ===== */
/* Kalkulator LeaseLink (assets/pluginLL.js, element <leaselink-calculator> z otwartym shadow DOM):
   obrazy bez alt (przycisk zamknięcia, gwiazdki ocen, ikony "nagradzani za innowacje" i "część
   grupy mBank" z podpisem obok), logo <leaselink-logo> bez nazwy, tekst zastrzeżenia #888 (3,1:1)
   i treść poza punktami orientacyjnymi (axe: image-alt, region, color-contrast). Kalkulator
   renderuje się od nowa przy otwarciu, stąd obserwator na shadow root. */
(function () {
  'use strict';
  /* shadow root kalkulatora zawiera kolejne elementy z własnym shadow DOM (<leaselink-logo> ma w środku
     dwa <img class="leaselink-logo"> bez alt), więc łatka schodzi rekurencyjnie i obserwuje każdy root */
  function observe(el, fn) {
    if (!el.shadowRoot || el.__pgObs) return;
    el.__pgObs = new MutationObserver(fn);
    el.__pgObs.observe(el.shadowRoot, { childList: true, subtree: true });
  }
  function patchRoot(sr, host) {
    if (!sr) return;
    if (!sr.querySelector('style[data-pg-a11y]')) {
      var st = document.createElement('style');
      st.setAttribute('data-pg-a11y', '1');
      /* 19.09 (F6): także napis nieaktywnej zakładki „Raty dla Firm / 3 - 36 miesięcy” – #888 na białym (3,54 : 1, axe przy
         otwartym kalkulatorze); aktywna zakładka (atrybut selected) ma biały napis na fiolecie i zostaje bez zmian */
      st.textContent = '.offer-disclaimer{color:#5c6771 !important}' +
        'offer-button[financial-product-button]:not([selected]) .financial-product-button span{color:#5c6771 !important}';
      sr.appendChild(st);
    }
    sr.querySelectorAll('img:not([alt])').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      img.setAttribute('alt', /close/i.test(src) ? 'Zamknij' : '');
    });
    /* 19.09 (F6 – warunek publikacji z oświadczenia o dostępności: „zamknięcie działa z klawiatury i ma rolę przycisku”):
       zamknięcie to <img class="close-button" tabindex="0"> obsługujące tylko kliknięcie – Enter i spacja nic nie robiły */
    sr.querySelectorAll('img.close-button:not([data-pg-kl])').forEach(function (x) {
      x.setAttribute('data-pg-kl', '1');
      x.setAttribute('role', 'button');
      x.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); x.click(); }
      });
    });
    sr.querySelectorAll('leaselink-logo:not([role])').forEach(function (l) {
      l.setAttribute('role', 'img');
      l.setAttribute('aria-label', 'LeaseLink');
    });
    sr.querySelectorAll('*').forEach(function (el) {
      if (el.shadowRoot) {
        patchRoot(el.shadowRoot, host);
        observe(el, function () { patchRoot(el.shadowRoot, host); });
      }
    });
  }
  /* zwraca true dopiero gdy element ma shadow root (jest już "ulepszony" przez pluginLL.js);
     sam znacznik <leaselink-calculator> siedzi w HTML od początku, a shadow DOM dostaje później */
  function patch(host) {
    if (!host.shadowRoot) return false;
    if (!host.getAttribute('role')) {
      host.setAttribute('role', 'region');
      host.setAttribute('aria-label', 'Kalkulator leasingu LeaseLink');
    }
    patchRoot(host.shadowRoot, host);
    observe(host, function () { patch(host); });
    sledz(host);
    return true;
  }
  /* 19.09 (F6): fokus i Escape. Kalkulator nie przejmował fokusu – po otwarciu z klawiatury fokus szedł dalej po stronie pod
     panelem (do „Zamknij” 135 naciśnięć Tab), a Escape go nie zamykał. Teraz: otwarty z klawiatury – fokus na „Zamknij”;
     Escape zamyka; po zamknięciu fokus wraca na element, z którego kalkulator otwarto. Przy otwarciu myszą fokus zostaje. */
  var otwieracz = null;
  var klawiszCzas = 0;
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' || e.key === ' ') klawiszCzas = Date.now();
    if (e.key !== 'Escape') return;
    document.querySelectorAll('leaselink-calculator').forEach(function (h) {
      if (!otwarty(h)) return;
      var x = h.shadowRoot && h.shadowRoot.querySelector('img.close-button');
      if (x) { e.preventDefault(); x.click(); }
    });
  }, true);
  function otwarty(h) { return h.hasAttribute('is-opened') && h.getAttribute('is-opened') !== 'false'; }
  function sledz(h) {
    if (h.__pgKl) return;
    h.__pgKl = new MutationObserver(function () {
      if (otwarty(h)) {
        if (h.__pgOtw) return;
        h.__pgOtw = true;
        var a = document.activeElement;
        otwieracz = a && a !== document.body && a !== h ? a : null;
        if (Date.now() - klawiszCzas > 1500) return;
        var proby = 0;
        (function fokus() {
          var x = h.shadowRoot && h.shadowRoot.querySelector('img.close-button');
          if (x) x.focus(); else if (++proby < 20) setTimeout(fokus, 100);
        })();
      } else if (h.__pgOtw) {
        h.__pgOtw = false;
        var a2 = document.activeElement;
        if (otwieracz && document.contains(otwieracz) && (a2 === h || a2 === document.body || !a2)) otwieracz.focus();
        otwieracz = null;
      }
    });
    h.__pgKl.observe(h, { attributes: true, attributeFilter: ['is-opened'] });
  }
  function init() {
    var hosts = document.querySelectorAll('leaselink-calculator');
    if (!hosts.length) return false;
    var done = true;
    hosts.forEach(function (h) { if (!patch(h)) done = false; });
    return done;
  }
  /* 1) odpytywanie do skutku (maks. 60 s) — wcześniej pętla kończyła się przy pierwszym znalezionym
     znaczniku, zanim kalkulator dostał shadow root, i łatka nigdy nie ruszała */
  var tries = 0;
  var timer = setInterval(function () { if (init() || ++tries > 120) clearInterval(timer); }, 500);
  /* 2) moment zdefiniowania elementu przez pluginLL.js */
  if (window.customElements && customElements.whenDefined) {
    customElements.whenDefined('leaselink-calculator').then(function () {
      setTimeout(init, 0);
      setTimeout(init, 500);
      setTimeout(init, 2000);
    }).catch(function () {});
  }
  /* 3) kalkulator dodany lub odtworzony później (np. po zmianie wariantu) */
  var queued = false;
  function schedule() {
    if (queued) return;
    queued = true;
    window.requestAnimationFrame(function () { queued = false; init(); });
  }
  new MutationObserver(function (muts) {
    for (var i = 0; i < muts.length; i++) {
      var added = muts[i].addedNodes;
      for (var j = 0; j < added.length; j++) {
        var n = added[j];
        if (n.nodeType !== 1) continue;
        if (n.tagName === 'LEASELINK-CALCULATOR' || (n.querySelector && n.querySelector('leaselink-calculator'))) {
          schedule();
          return;
        }
      }
    }
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* 22.09 (krok 30.8) – moduł „zakladki-krajow”: zakładki krajów w sekcji salonów (strona główna) są od dziś przyciskami
   (Tab + Enter/spacja). Skrypt motywu (LocationsSection w global.min.js) obsługuje kliknięcie i oznacza aktywny kraj atrybutem
   data-country-active – tu tylko przepisujemy ten stan do aria-pressed dla czytnika ekranu (jedno źródło prawdy, skrypt motywu nietknięty). */
(function () {
  function sync(tab) { tab.setAttribute("aria-pressed", tab.hasAttribute("data-country-active") ? "true" : "false"); }
  function init() {
    var tabs = document.querySelectorAll("button.locations__tab");
    for (var i = 0; i < tabs.length; i++) {
      var t = tabs[i];
      if (t.__pgPressed) continue;
      t.__pgPressed = true;
      sync(t);
      new MutationObserver(function (muts) { sync(muts[0].target); }).observe(t, { attributes: true, attributeFilter: ["data-country-active"] });
    }
  }
  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init); else init();
  document.addEventListener("shopify:section:load", init);

  /* 29.09 (ramka R6 – odchudzenie sekcji salonów bez jej zdejmowania): slajdy krajów innych niż aktywny przychodzą w nieaktywnym
     `<template data-pg-loc-slajdy>` (`snippets/group-location-slides.liquid`). Kliknięcie zakładki kraju (Enter / spacja na przycisku to też
     kliknięcie) wstawia je do grupy w fazie PRZECHWYTYWANIA – przed obsługą kliknięcia w skrypcie motywu (LocationsSection słucha w fazie
     bąbelkowania), więc grupa pokazuje się i uruchamia karuzelę już ze slajdami. Slajdy mają klasę `animatedContent` (start z przezroczystości 0) –
     obserwator animacji motywu zna tylko elementy z chwili wczytania, więc wstawione dostają to samo pojawienie się co w motywie (750 ms, ease);
     przy wyłączonych animacjach albo ograniczonym ruchu widoczność daje CSS motywu (base-min.css). */
  document.addEventListener("click", function (e) {
    var tab = e.target && e.target.closest ? e.target.closest("[data-country-tab]") : null;
    if (!tab) return;
    var sekcja = tab.closest("locations-section");
    if (!sekcja) return;
    var kraj = tab.getAttribute("data-country-tab") || "";
    var grupa = sekcja.querySelector(".locations__swiper[data-country-group=\"" + (window.CSS && CSS.escape ? CSS.escape(kraj) : kraj) + "\"]");
    var szablon = grupa ? grupa.querySelector("template[data-pg-loc-slajdy]") : null;
    if (!szablon) return;
    var tresc = szablon.content;
    var nowe = [].slice.call(tresc.querySelectorAll(".animatedContent"));
    szablon.replaceWith(tresc);
    var anim = window.theme && window.theme.enableAnimations;
    var ruch = window.matchMedia && window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!anim || ruch) return;
    var odstep = (window.theme && +window.theme.animationBetweenElements) || 0;
    nowe.forEach(function (el, i) {
      if (!el.animate) { el.style.opacity = "1"; return; }
      setTimeout(function () { el.animate([{ opacity: "0" }, { opacity: "1" }], { duration: 750, easing: "ease", fill: "forwards" }); }, odstep * i);
    });
  }, true);

  /* 22.09 (krok 30.10 b) – WYŚCIG Z ARKUSZEM SEKCJI: `section-locations.css` wczytuje się bez blokowania (media="print" → "all" po
     wczytaniu), a Swiper zakładek ma `slidesPerView: "auto"`, więc mierzy szerokość zakładek z CSS. Gdy skrypt motywu zainicjuje
     Swipera PRZED dojściem arkusza, każda zakładka ma jeszcze `width: 100%` (cała szerokość paska) i siatka wychodzi w wielokrotnościach
     szerokości kontenera (zmierzone 22.09: rozmiar slajdu 1360 px zamiast 81, przesunięcie −2720 px po kliknięciu – pasek pusty).
     Po wczytaniu arkusza (i na wszelki wypadek po `load` okna) przeliczamy siatkę i wracamy do aktywnego kraju; przy poprawnej siatce
     to nic nie zmienia (te same liczby), więc bez skoku układu. */
  function przelicz() {
    var paski = document.querySelectorAll(".locations__tabs-swiper");
    for (var i = 0; i < paski.length; i++) {
      var sw = paski[i].swiper;
      if (!sw || sw.destroyed) continue;
      sw.update();
      var tabs = paski[i].querySelectorAll(".locations__tab");
      for (var k = 0; k < tabs.length; k++) {
        if (tabs[k].hasAttribute("data-country-active")) { sw.slideTo(k, 0); break; }
      }
    }
  }
  var arkusz = document.querySelector("link[href*=\"section-locations\"]");
  if (arkusz) {
    if (arkusz.sheet && arkusz.media === "all") przelicz();
    else arkusz.addEventListener("load", function () { setTimeout(przelicz, 0); });
  }
  if (document.readyState === "complete") przelicz(); else window.addEventListener("load", function () { setTimeout(przelicz, 0); });
})();

;
/* ===== pm-atrybucja (23.09, polecenia 361 T2, 365, 366, 367; krok 36.19; badania/2026-09-23-profitmetrics-a-z-354.md sekcja 4) =====
   Osadzenie ProfitMetrics (PM) zapisuje parametry wizyty (atrybuty koszyka __pm_*: źródło, kampania, gclid…) do koszyka tylko wtedy, gdy
   (1) koszyk już istnieje i (2) dane wizyty zmieniły się od ostatniego wysłania do PM, a przy „Do kasy” zapis rusza dopiero po odpowiedzi serwera PM
   (~250 ms), kiedy strona już się zamyka – przeglądarka go odrzuca (test T1 23.09: zamówienie 3113800 bez __pm_*; 15 z 49 zamówień web ma atrybuty).
   Dwie poprawki; atrybuty pisze nadal wyłącznie PM (ten moduł niczego za niego nie zapisuje):
   (a) przy zgodzie na statystykę albo marketing i braku koszyka zakładamy pusty koszyk (POST /cart/update.js z {}), żeby pierwsza synchronizacja PM
       trafiła do istniejącego koszyka;
   (b) gdy przy wysyłce formularza kasy trwa zapis PM, wysyłka czeka na jego koniec i idzie dalej tym samym przyciskiem. Sufit 5 s (24.09 01:1x, polecenie 431 T2:
       „nie wazne czy pol sekundy czy 5, ma sie zawsze poprawnie zapisac”; pomiar 24.09: zapis PM trwa zwykle 0,5–0,6 s) – sufit jest tylko po to, żeby awaria
       serwera PM nie zablokowała zakupu (B147 b); w czasie czekania przycisk ma aria-busy (wygląd: base-min.css).
   Bez zgody PM niczego nie wysyła, więc (a) i (b) się nie włączają; bez JavaScriptu kasa działa zwykłym formularzem. */
(function () {
  if (window.__pgPmAtrybucja || !window.fetch || !window.Promise) return;
  window.__pgPmAtrybucja = true;

  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var MAKS_MS = 5000;
  var CISZA_MS = 60;
  var trwa = 0;
  var zmiana = 0;

  /* (b) licznik trwających zapytań PM – nakładka na fetch nie zmienia ani zapytania, ani odpowiedzi */
  var pierwotny = window.fetch;
  window.fetch = function (input, init) {
    var p = pierwotny.apply(window, arguments);
    try {
      var url = typeof input === 'string' ? input : (input && input.url) || String(input || '');
      var body = init && typeof init.body === 'string' ? init.body : '';
      if (/\/apps\/profitmetrics\/api\/trk/.test(url) || (/\/cart\/update\.js/.test(url) && body.indexOf('"__pm_') !== -1)) {
        trwa++;
        zmiana = Date.now();
        var koniec = function () { trwa = Math.max(0, trwa - 1); zmiana = Date.now(); };
        p.then(koniec, koniec);
      }
    } catch (e) {}
    return p;
  };

  /* (a) pusty koszyk przy zgodzie – bez robotów i pomiarów Lighthouse */
  var robot = /bot|crawl|spider|slurp|headless|lighthouse|pagespeed|webdriver/i.test(navigator.userAgent || '') || navigator.webdriver === true;
  /* zgoda jak u PM: najpierw Shopify, a zanim Shopify wczyta moduł zgód – zapis zgody w danych wizyty PM (_pma: cc_statistics / cc_marketing) */
  function zgoda() {
    try {
      var cp = window.Shopify && window.Shopify.customerPrivacy;
      if (cp && cp.analyticsProcessingAllowed) return !!(cp.analyticsProcessingAllowed() || cp.marketingAllowed());
      var m = document.cookie.match(/(?:^|;\s*)_pma=([^;]*)/);
      if (!m) return false;
      var d = JSON.parse(decodeURIComponent(m[1]));
      return !!(d && (d.cc_statistics || d.cc_marketing));
    } catch (e) { return false; }
  }
  function maKoszyk() { return /(?:^|;\s*)cart=/.test(document.cookie); }
  var zakladam = false;
  function zalozKoszyk() {
    if (robot || zakladam || maKoszyk() || !zgoda()) return;
    zakladam = true;
    pierwotny.call(window, ROOT + 'cart/update.js', {
      method: 'POST',
      credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
      body: '{}'
    }).then(function () { zakladam = false; }, function () { zakladam = false; });
  }
  zalozKoszyk();
  [1000, 2500, 5000].forEach(function (ms) { setTimeout(zalozKoszyk, ms); });
  document.addEventListener('visitorConsentCollected', function () { setTimeout(zalozKoszyk, 0); });

  /* (b) formularz kasy: czekamy tylko wtedy, gdy PM coś właśnie zapisuje */
  function czyKasa(form, przycisk) {
    if (przycisk && przycisk.getAttribute('name') === 'checkout') return true;
    return /(^|\/)checkouts?(\/|$|\?)/.test(form.getAttribute('action') || '');
  }
  var czeka = false;
  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    if (form.__pgPmDalej) { form.__pgPmDalej = false; return; }
    var akt = document.activeElement;
    var przycisk = e.submitter || (akt && akt.form === form && /^(submit|image)$/i.test(akt.type || '') ? akt : null);
    if (!czyKasa(form, przycisk)) return;
    if (czeka) { e.preventDefault(); e.stopImmediatePropagation(); return; }
    if (trwa === 0) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    czeka = true;
    var start = Date.now();
    if (przycisk) { przycisk.setAttribute('aria-busy', 'true'); przycisk.style.cursor = 'progress'; }
    (function sprawdz() {
      var teraz = Date.now();
      if (teraz - start < MAKS_MS && (trwa > 0 || teraz - zmiana < CISZA_MS)) { setTimeout(sprawdz, 25); return; }
      czeka = false;
      if (przycisk) { przycisk.removeAttribute('aria-busy'); przycisk.style.cursor = ''; }
      form.__pgPmDalej = true;
      try {
        if (form.requestSubmit) { form.requestSubmit(przycisk && przycisk.form === form ? przycisk : undefined); return; }
      } catch (err) {}
      form.__pgPmDalej = false;
      if (przycisk && przycisk.getAttribute('name')) {
        var ukryte = document.createElement('input');
        ukryte.type = 'hidden';
        ukryte.name = przycisk.getAttribute('name');
        ukryte.value = przycisk.value || '';
        form.appendChild(ukryte);
      }
      form.submit();
    })();
  }, true);
})();

;
/* ===== pasuje-wiecej (25.09, T2; 30.09 – 803 WIECEJ-2) =====
   „Pasuje do” przy części zamiennej (snippets/pg-pasuje-do.liquid): numery w jednym wierszu, reszta za odnośnikiem „+N więcej” – ile widać, mówią reguły
   `@container` wypisane przez snippet wg szerokości ramki (tylko przy klasie `js`). Kliknięcie rozwija listę w miejscu, ponowne zwija (klasa is-otwarte,
   aria-expanded). Karta produktu i strona wsparcia – jeden delegowany odbiornik. */
(function () {
  'use strict';
  if (window.__pgPasujeWiecej) return;
  window.__pgPasujeWiecej = true;
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('[data-pg-pasuje-wiecej]') : null;
    if (!b) return;
    var box = b.closest('.pg-pasuje');
    if (!box) return;
    var otw = !box.classList.contains('is-otwarte');
    box.classList.toggle('is-otwarte', otw);
    b.setAttribute('aria-expanded', otw ? 'true' : 'false');
    /* 30.09 (803 – WIECEJ-2): odnośnik ma napisy w środku („+N więcej” osobno dla każdego zakresu szerokości ramki i „Pokaż mniej”) – przełącza je CSS po klasie is-otwarte;
       napis z atrybutów tylko w starszym HTML (strona z pamięci podręcznej) */
    if (b.hasAttribute('data-wiecej')) b.textContent = otw ? (b.getAttribute('data-mniej') || '') : (b.getAttribute('data-wiecej') || '');
  });
})();

/* ===== zawczasu (03.10, krok 30.24 / – B150 (f); badania/2026-10-03-ukryte-zdjecia-30-24.md) =====
   Zdjęcia, które klient ODSŁANIA najechaniem albo kliknięciem, pobierane zawczasu – po wczytaniu strony, w bezczynności przeglądarki, z niskim
   priorytetem, małymi porcjami – żeby po odsłonięciu pokazały się od razu (pomiar 03.10, pierwsza wizyta: panele menu komputera – 110 ze 166 zdjęć
   dochodziło na oczach klienta, zakładki salonów 22 z 29 na komputerze i 21 z 26 na telefonie, menu ☰ telefonu 64 ze 102 przy plikach „zimnych”
   na serwerze zdjęć; po zmianie – 0).
   Tylko miejsca odsłaniane przez klienta – zdjęć ukrytych celowo wg szerokości ekranu (lista kategorii telefonu na komputerze, `not_mobile`…) nie ruszamy:
   - szablony <template> (treść wstawiana dopiero przy odsłonięciu): panele 3. poziomu menu komputera (`template[data-third-tpl]`, od 1024 px),
     menu ☰ telefonu (poniżej 1024 px) – 2. poziom w całości (`template[data-lazy-submenus]`), z 3. poziomu (`template[data-lazy-drawer]`) pierwsze
     12 zdjęć każdego panelu (18 od 600 px) – tyle widać po wejściu w kategorię; dalsze ładuje motyw przy otwarciu panelu, zanim klient przewinie
     (A/B 03.10: cały 3. poziom – ok. 420 plików – to ok. 2 s pracy wątku głównego na słabym telefonie), zakładki salonów na głównej
     (`template[data-pg-loc-slajdy]` – pierwsze 4 zdjęcia kraju na komputerze, 2 na telefonie: tyle widać po zmianie zakładki – pomiar 03.10,
     na telefonie drugie zdjęcie wystaje z prawej). Pobieramy osobnym
     obrazkiem `new Image()` z TYM SAMYM `src` / `srcset` / `sizes` (przeglądarka wybiera ten sam plik); obraz trafia na listę dostępnych obrazów
     dokumentu (HTML Standard, „list of available images”), więc wstawiony później pokazuje się bez ponownego pobierania;
   - obrazki w stronie (`loading=eager` + `fetchpriority=low`): kafelki pasa menu z menu .dk (`[data-pg-dk-src]` – pas drugiej zakładki jest ukryty),
     dalsze slajdy wybranego kraju salonów, flagi w oknie języka; kafelki podkategorii od 9. – dawna część „kafelki-dalsze” (26.09, 525 T8 K1;
     te same warunki: w bezczynności po wczytaniu, przy Save-Data zostają leniwe);
   - karuzele produktów na telefonie i tablecie (08.10, etap 2 – badanie §3.16): karuzela pokazuje 1,3 karty (tablet 2,4), resztę przycina (`.swiper` –
     `overflow: clip`, więc zapas leniwego ładowania Chrome dla karuzel przewijanych jej nie obejmuje) – zdjęcie karty, która wjeżdża, ruszało dopiero po
     przesunięciu, a przy pliku spoza pamięci CDN klient widział puste miejsce 0,4–0,6 s; zdjęcie GŁÓWNE kart do 1,5 szerokości karuzeli za prawą krawędzią
     (telefon – 2 karty za wystającą, po każdym przesunięciu następna) dostaje `loading=eager` + `fetchpriority=low`, gdy karuzela jest ekran od okna;
     komputer bez zmian (pomiar 08.10 – 0 czekania; drugie zdjęcie „po najechaniu” tylko tam).
   Kolejność: menu → salony (gdy sekcja zbliża się do ekranu – od razu, na początek kolejki) → flagi. Porcje: 6 naraz na komputerze, 4 na telefonie,
   kolejne w `requestIdleCallback`; karta w tle – przerwa. Bez pobierania zawczasu: oszczędzanie danych (Save-Data), łącze 3g i wolniejsze, edytor motywu.
   Szablony menu przychodzą osobnym zapytaniem (snippets/pg-menu-laduj.liquid) – zbieramy je także po zdarzeniu `pg:menu-gotowe`. Koszt pierwszej
   wizyty (03.10): menu ok. 1,3 MB na komputerze (ok. 2,6 MB przy ekranie 2×), ok. 0,7 MB na telefonie (pliki AVIF ok. 3 KB), salony ok. 1 MB –
   kolejne strony biorą je z pamięci przeglądarki. */
(function () {
  if (window.__pgZawczasu) return;
  window.__pgZawczasu = 1;
  var lacze = navigator.connection;
  if ((lacze && lacze.saveData) || (window.Shopify && Shopify.designMode)) return;
  var wolne = !!(lacze && /(^|-)(2g|3g)$/.test(lacze.effectiveType || ''));
  var KOMP = !!(window.matchMedia && window.matchMedia('(min-width: 1024px)').matches);
  var MAX = KOMP ? 6 : 4;
  var znane = Object.create(null), kolejka = [], trzymane = [], wToku = 0, ruszylo = false, czeka = false;
  // kolejna strona wizyty: zdjęcia menu są już w pamięci przeglądarki – bez ponownego pobierania zawczasu (A/B 03.10 „druga strona”: ok. 240 trafień w pamięć
  // = +2–5 s pracy wątku głównego na słabym telefonie); znacznik w localStorage z podpisem menu (inne menu = inny podpis) ważny 12 h, zapisywany dopiero, gdy menu
  // pobrało się w całości; bez localStorage – jak na pierwszej stronie
  var MENU_KLUCZ = 'pgZawczasuMenu', POMIN_PONOWNIE = !KOMP, menuZostalo = 0, menuPodpis = '';
  function menuPamieta(podpis) { try { var o = JSON.parse(localStorage.getItem(MENU_KLUCZ) || 'null'); return !!(o && o.p === podpis && Date.now() - o.t < 432e5); } catch (_) { return false; } }
  function menuZapamietaj() { try { localStorage.setItem(MENU_KLUCZ, JSON.stringify({ p: menuPodpis, t: Date.now() })); } catch (_) {} }
  function bezczynnie(fn, ms) { if ('requestIdleCallback' in window) requestIdleCallback(fn, { timeout: ms }); else setTimeout(fn, Math.min(ms, 2000)); }
  function wczesniej(img) { img.setAttribute('fetchpriority', 'low'); img.setAttribute('loading', 'eager'); }
  // dane obrazka z szablonu (bez <noscript> – tam zapasowy 1×); zastępniki `data:` pomijamy
  function dane(img) {
    if (img.closest && img.closest('noscript')) return null;
    var src = img.getAttribute('data-src') || img.getAttribute('src') || '', ss = img.getAttribute('data-srcset') || img.getAttribute('srcset') || '';
    if (/^data:/i.test(src)) src = '';
    if (/^data:/i.test(ss)) ss = '';
    return src || ss ? { src: src, ss: ss, sizes: img.getAttribute('sizes') || '' } : null;
  }
  function dodaj(lista, naPoczatek, zMenu) {
    var nowe = [];
    for (var i = 0; i < lista.length; i++) {
      var z = lista[i] && lista[i].nodeType ? dane(lista[i]) : lista[i];
      if (!z) continue;
      var k = z.ss || z.src;
      if (znane[k]) continue;
      znane[k] = 1; if (zMenu) { z.m = 1; menuZostalo++; } nowe.push(z);
    }
    kolejka = naPoczatek ? nowe.concat(kolejka) : kolejka.concat(nowe);
    if (ruszylo) planuj();
  }
  function zSzablonow(sel, ileZKazdego) {
    var out = [];
    [].forEach.call(document.querySelectorAll(sel), function (t) {
      if (!t.content) return;
      var a = [].filter.call(t.content.querySelectorAll('img'), function (img) { return !(img.closest && img.closest('noscript')); });
      [].push.apply(out, ileZKazdego ? a.slice(0, ileZKazdego) : a);
    });
    return out;
  }
  function porcja() {
    czeka = false;
    if (document.visibilityState === 'hidden') return;
    while (wToku < MAX && kolejka.length) {
      var z = kolejka.shift(), im = new Image();
      wToku++; trzymane.push(im);
      im.decoding = 'async';
      try { im.fetchPriority = 'low'; } catch (_) {}
      im._m = z.m;
      im.onload = im.onerror = function () { this.onload = this.onerror = null; wToku--; var i = trzymane.indexOf(this); if (i >= 0) trzymane.splice(i, 1); if (this._m && !--menuZostalo) menuZapamietaj(); planuj(); };
      if (z.sizes) im.sizes = z.sizes;
      if (z.ss) im.srcset = z.ss;
      if (z.src) im.src = z.src;
    }
  }
  function planuj() { if (czeka || !kolejka.length || wToku >= MAX) return; czeka = true; bezczynnie(porcja, 1500); }
  function menu() {
    var lista = KOMP ? zSzablonow('.dm__third-dropdown template[data-third-tpl]')
      : zSzablonow('#menu template[data-lazy-submenus]').concat(zSzablonow('#menu template[data-lazy-drawer]', innerWidth >= 600 ? 18 : 12));
    if (!lista.length) return;
    var a = dane(lista[0]) || {}, b = dane(lista[lista.length - 1]) || {};
    var podpis = (KOMP ? 'k' : 't') + lista.length + '|' + (a.ss || a.src || '').slice(-60) + '|' + (b.ss || b.src || '').slice(-60);
    if (podpis === menuPodpis) return;
    menuPodpis = podpis;
    if (POMIN_PONOWNIE && menuPamieta(podpis)) return;
    dodaj(lista, false, true);
  }
  function salony(sekcja) {
    dodaj(zSzablonow('locations-section template[data-pg-loc-slajdy]', KOMP ? 4 : 2), true);
    [].forEach.call(sekcja.querySelectorAll('.locations__swiper img[loading="lazy"]'), wczesniej);
  }
  // karuzele produktów – telefon i tablet (08.10, 30.24 etap 2; opis w nagłówku modułu): obserwator z korzeniem w karuzeli i zapasem 1,5 jej szerokości
  // w prawo; „Polecane” (`product-recommendations`) podmieniają karuzelę po zapytaniu – obserwator zmian czeka na karty (także po zmianie wariantu)
  function karuzele() {
    if (!('IntersectionObserver' in window)) return;
    var karuzela = function (k) {
      if (k.__pgZaw) return;
      k.__pgZaw = 1;
      var obs = new IntersectionObserver(function (wpisy) {
        wpisy.forEach(function (w) {
          if (!w.isIntersecting) return;
          obs.unobserve(w.target);
          var img = w.target.querySelector('img.product-card__image:not(.product-card__image--secondary)');
          if (img && img.getAttribute('loading') === 'lazy') wczesniej(img);
        });
      }, { root: k, rootMargin: '0px 150% 0px 0px' });
      [].forEach.call(k.querySelectorAll('.swiper-slide'), function (s) { obs.observe(s); });
    };
    var zKartami = function (el) {
      var k = el.matches('.pc__carousel') ? el : el.querySelector('.pc__carousel');
      return k && k.querySelector('.swiper-slide') ? k : null;
    };
    var blisko = new IntersectionObserver(function (wpisy) {
      wpisy.forEach(function (w) {
        if (!w.isIntersecting) return;
        var el = w.target, k = zKartami(el);
        blisko.unobserve(el);
        if (k) karuzela(k);
        if (el.matches('product-recommendations')) new MutationObserver(function () { var k2 = zKartami(el); if (k2) karuzela(k2); }).observe(el, { childList: true, subtree: true });
      });
    }, { rootMargin: '100% 0px' });
    [].forEach.call(document.querySelectorAll('product-recommendations, .pc__carousel'), function (el) {
      if (!(el.matches('.pc__carousel') && el.closest('product-recommendations'))) blisko.observe(el);
    });
  }
  function start() {
    ruszylo = true;
    [].forEach.call(document.querySelectorAll('img.subcategory-image[loading="lazy"]'), wczesniej);
    if (wolne) return;
    menu();
    if (KOMP) dodaj([].map.call(document.querySelectorAll('desktop-menu-carousel [data-pg-dk-src]'), function (el) { return { src: el.getAttribute('data-pg-dk-src') || '', ss: '', sizes: '' }; }).filter(function (z) { return z.src; }));
    dodaj(document.querySelectorAll('.country-selector__dropdown img'));
    if (!KOMP) karuzele();
    planuj();
  }
  if (!wolne) {
    document.addEventListener('pg:menu-gotowe', function () { if (ruszylo) menu(); });
    document.addEventListener('visibilitychange', function () { if (ruszylo && document.visibilityState === 'visible') planuj(); });
    // salony: gdy sekcja jest ekran od okna (klient do niej dochodzi) – od razu, na początek kolejki; po wyborze kraju – jego dalsze slajdy
    var sek = document.querySelector('locations-section');
    if (sek && 'IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (wpisy) {
        if (!wpisy.some(function (w) { return w.isIntersecting; })) return;
        io.disconnect();
        salony(sek);
        if (!ruszylo) { ruszylo = true; planuj(); }
      }, { rootMargin: '100% 0px' });
      io.observe(sek);
      sek.addEventListener('click', function (e) {
        if (!e.target.closest || !e.target.closest('[data-country-tab]')) return;
        setTimeout(function () { [].forEach.call(sek.querySelectorAll('.locations__swiper img[loading="lazy"]'), wczesniej); }, 0);
      });
    }
  }
  if (document.readyState === 'complete') bezczynnie(start, 4000);
  else window.addEventListener('load', function () { bezczynnie(start, 4000); }, { once: true });
})();

/* ===== naglowek-960 (01.10, 960 – WYGLAD-E2 = A; 41.2, prototyp narzedzia-audytu/dane-2026-10-01/naglowek-41-2/warianty/proto-naglowek.js) =====
   (1) R2 – panel kategorii otwiera się, gdy kursor się ZATRZYMA na kafelku paska (hoverIntent: < 8 px w ciągu 100 ms; najpóźniej po 600 ms na tym samym
   kafelku), a nie po stałym czasie – przejazd ukosem nie otwiera po drodze kolejnych paneli (pomiar 01.10 15:3x: przejazdy 1–4 → 0 zbędnych otwarć).
   Nasłuch mouseenter w fazie przechwytywania na document zatrzymuje zdarzenie przed obsługą motywu, a po zatrzymaniu kursora wysyła zdarzenia
   najechania jeszcze raz (znacznik __pgx) – ten sam wzór co snippets/pg-menu-laduj.liquid (pułapka 108 c). Klawiatura i dotyk – bez zmian.
   (2) zakładka złączona z paskiem: klasa pg-zakladka na odnośniku, którego pasek jest teraz widoczny (na starcie – Liquid w main-header,
   potem po kliknięciu, najechaniu, fokusie w menu i przy przewijaniu; samo tło – bez zmiany układu). Tylko komputer (≥ 1024 px). */
(function () {
  if (!window.matchMedia || !window.matchMedia('(min-width: 1024px)').matches || window.__pgNaglowek960) return;
  window.__pgNaglowek960 = 1;
  var q = function (s, r) { return (r || document).querySelector(s); };
  var qa = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var SEL = '[data-action="open-third-menu"][data-handle]';
  var mx = -1, my = -1, timer = null, aktywny = null;
  document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; }, { capture: true, passive: true });
  function otwarty(el) { var p = q('.dm__third-dropdown[data-handle-content="' + el.getAttribute('data-handle') + '"]'); return !!(p && p.style.display !== 'none' && p.getBoundingClientRect().height > 50); }
  function wyslij(el) {
    var r = el.getBoundingClientRect(), o = { bubbles: true, clientX: r.left + r.width / 2, clientY: r.top + r.height / 2 };
    ['pointerover', 'pointerenter', 'mouseover', 'mouseenter'].forEach(function (t) {
      var ev;
      try { ev = t.indexOf('pointer') === 0 ? new PointerEvent(t, Object.assign({ pointerType: 'mouse' }, o)) : new MouseEvent(t, o); } catch (_) { ev = new MouseEvent(t, o); }
      ev.__pgx = 1; el.dispatchEvent(ev);
    });
  }
  document.addEventListener('mouseenter', function (e) {
    if (e.__pgx) return;
    var trig = e.target && e.target.closest ? e.target.closest(SEL) : null;
    if (!trig) return;
    // zdarzenie wysłane skryptem (fokus z klawiatury – moduł „mega menu” wyżej, doczytanie menu) bez kursora na kafelku: motyw otwiera od razu,
    // jak przed 960 – inaczej Tab nie otwierał panelu (przegląd B191 01.10 22:43, B147)
    if (!e.isTrusted && !trig.matches(':hover')) return;
    e.stopPropagation();
    if (trig === aktywny && timer) return;
    clearInterval(timer); aktywny = trig;
    if (otwarty(trig)) { timer = null; return; }
    // 03.10 (1035, przegląd agenta nr 1 – pomiar co klatkę: przy przejściu na sąsiedni kafelek ok. 175 ms bez żadnego panelu i 230 ms wygaszania od zera
    // – mrugało całe przyciemnienie): gdy panel tego paska jest JUŻ otwarty, przełączenie jak na .dk – po 90 ms na kafelku (przejazd ukosem przez sąsiedni
    // kafelek do panelu nie przełącza); do tej chwili stary panel zostaje: motyw widzi kursor na pasku (`hoveredTrigger`), więc jego zamknięcie po 150 ms
    // od zjazdu nie zadziała, a przełączenie (`_openMenu`) zamyka stary i otwiera nowy w jednej chwili
    var karuzela = trig.closest('desktop-menu-carousel');
    if (karuzela && karuzela.openMenu) {
      karuzela.hoveredTrigger = trig;
      timer = setTimeout(function () { timer = null; if (trig.matches(':hover')) wyslij(trig); }, 90);
      return;
    }
    var px = mx, py = my, t0 = performance.now();
    timer = setInterval(function () {
      if (!trig.matches(':hover')) { clearInterval(timer); timer = null; aktywny = null; return; }
      var d = Math.hypot(mx - px, my - py); px = mx; py = my;
      if (d < 8 || performance.now() - t0 > 600) { clearInterval(timer); timer = null; wyslij(trig); }
    }, 100);
  }, true);
  // (2) zakładka: widoczny = cały łańcuch od paska do <li> bez display:none i visibility:hidden, z opacity ≥ 0,5 i wysokością > 20 px
  // (nieaktywny pasek motyw chowa przez visibility:hidden + opacity:0 – wysokość zostaje) i spod rzędu menu widać > 20 px paska: przy przewijaniu
  // pasek wsuwa się pod nagłówek (przesunięcie z osi przewijania – base-min.css, „pasek kategorii v4”), więc zakładka bez paska nie zostaje
  var h = q('#header');
  if (!h) return;
  function widoczny(el, li) { for (var e = el; e && e !== li.parentElement; e = e.parentElement) { var s = getComputedStyle(e); if (s.display === 'none' || s.visibility === 'hidden' || parseFloat(s.opacity) < 0.5) return false; } var r = el.getBoundingClientRect(); return r.height > 20 && r.bottom - li.getBoundingClientRect().bottom > 20; }
  function oznacz() { qa('#header li.header-link-desk').forEach(function (li) { var a = q(':scope > a.header-main-links', li), p = q(':scope > .desktop-menu__dropdown-wrapper.pg-pasek', li); if (a) a.classList.toggle('pg-zakladka', !!(p && widoczny(p, li))); }); }
  var zaplanowane = false;
  function pozniej() { if (zaplanowane) return; zaplanowane = true; setTimeout(function () { oznacz(); setTimeout(function () { oznacz(); zaplanowane = false; }, 390); }, 60); } // drugi odczyt po animacji paska
  try { var mo = new MutationObserver(pozniej); qa('#header li.header-link-desk, #header li.header-link-desk > .desktop-menu__dropdown-wrapper.pg-pasek').forEach(function (p) { mo.observe(p, { attributes: true, attributeFilter: ['style', 'class', 'hidden', 'aria-hidden'] }); }); } catch (_) {}
  ['click', 'mouseover', 'mouseout', 'focusin', 'focusout'].forEach(function (t) { h.addEventListener(t, pozniej, true); });
  var klatka = 0; // przewijanie: odczyt raz na klatkę (pasywny nasłuch – nie wstrzymuje przewijania)
  window.addEventListener('scroll', function () { if (klatka) return; klatka = requestAnimationFrame(function () { klatka = 0; oznacz(); }); }, { passive: true });
  if (document.readyState === 'complete') pozniej(); else window.addEventListener('load', pozniej, { once: true });
})();
/* (3) przycisk „Szukaj” przy pustym polu (01.10 22:1x): zamiast pustej strony wyników otwiera wyszukiwanie motywu (klik w formularz –
   data-action="open-search") i stawia kursor w polu; z wpisanym tekstem – zwykłe wysłanie formularza. Każda szerokość ekranu. */
(function () {
  document.addEventListener('click', function (e) {
    var b = e.target && e.target.closest ? e.target.closest('.pg-szukaj') : null;
    if (!b) return;
    var f = b.form || document.getElementById(b.getAttribute('form'));
    var p = f && f.querySelector('input[type="search"]');
    if (!p || p.value.trim()) return;
    e.preventDefault();
    f.click();
    p.focus();
  });
})();
/* (4) 02.10.2026 (970, W2 – K3 z badania 525): zdjęcie karty produktu pobrane PRZED kliknięciem. Najechanie myszą na kartę produktu
   (≥ 150 ms – tyle co podgląd strony „moderate” w Chrome) albo fokus klawiatury → w tle pobiera się GŁÓWNE zdjęcie tej karty
   produktu w szerokości, którą wybierze strona produktu (ten sam `srcset` 400/550/600/800/1200 i `sizes` co pierwszy slajd galerii
   `blocks/_product_swiper.liquid` i preload w `layout/theme.liquid`), więc po kliknięciu zdjęcie jest już w pamięci przeglądarki.
   Adres = adres zdjęcia karty z inną szerokością (ten sam plik: karta i galeria biorą `featured_media` / pierwsze media produktu).
   Bez „oszczędzania danych” i na 2G – nic; każdy produkt raz; najwyżej 12 na stronę; niski priorytet – nie konkuruje z bieżącą stroną.
   Dotyk – bez pobierania (02.10 09:5x): `touchstart` zaczyna też każde przewijanie palcem po liście, więc ciągnąłby zdjęcia z danych komórkowych,
   a na telefonie zdjęcie i tak jest pobrane na długo przed pokazaniem – czeka zajęty procesor (badanie 970 §4.3–4.4). */
(function () {
  var SZER = [400, 550, 600, 800, 1200], SIZES = '(max-width: 768px) 95vw, 550px', juz = {}, ile = 0, zwloka = 0;
  function oszczedny() { var c = navigator.connection; return !!(c && (c.saveData || /(^|-)2g$/.test(c.effectiveType || ''))); }
  function odnosnik(e) { var t = e.target; return t && t.closest ? t.closest('a.product-card__title-link') : null; }
  function pobierz(a) {
    if (ile >= 12 || oszczedny()) return;
    var href = a.getAttribute('href') || ''; if (!href || href === '#' || juz[href]) return;
    var karta = a.closest('.product-card_cont'); if (!karta) return;
    var im = karta.querySelector('img.product-card__image:not(.product-card__image--secondary)'); if (!im) return;
    var src = im.getAttribute('src') || ''; if (!/[?&]width=\d+/.test(src)) return;
    juz[href] = 1; ile++;
    var i = new Image(); try { i.fetchPriority = 'low'; } catch (_) {}
    i.decoding = 'async'; i.sizes = SIZES;
    i.srcset = SZER.map(function (w) { return src.replace(/([?&]width=)\d+/, '$1' + w) + ' ' + w + 'w'; }).join(', ');
    i.src = src.replace(/([?&]width=)\d+/, '$1800');
  }
  document.addEventListener('pointerover', function (e) {
    if (e.pointerType && e.pointerType !== 'mouse') return;
    var a = odnosnik(e); if (!a) return;
    clearTimeout(zwloka); zwloka = setTimeout(function () { pobierz(a); }, 150);
  }, { passive: true });
  document.addEventListener('pointerout', function (e) { if (odnosnik(e)) clearTimeout(zwloka); }, { passive: true });
  document.addEventListener('focusin', function (e) { var a = odnosnik(e); if (a) pobierz(a); });
})();
